/* ============================================================
   BulkThreads Customizer — live-product engine
   ============================================================ */
(function(){
  "use strict";
  if (typeof fabric === 'undefined') {
    console.error('[BulkThreads] Fabric.js failed to load from CDN.');
    return;
  }

  var BT_QUOTE_EMAIL = (BT_CFG.quoteEmail || '').replace(/^\s*mailto:\s*/i,'').trim();
  var SPEC_GUIDE_URL = BT_CFG.specGuideUrl;
  var FORM_ENDPOINT = (BT_CFG.formEndpoint || '').trim();
  var FORM_KEY = (BT_CFG.formAccessKey || '').trim();

  var SANMAR_ENABLED   = BT_CFG.sanmarBackviews;
  var SANMAR_DATA_URL  = BT_CFG.sanmarViewsUrl;
  var SANMAR_USE_PROXY = BT_CFG.sanmarUseProxy;
  var SANMAR_PROXY_BASE = (BT_CFG.sanmarProxyBase || '').trim();

  var SNS_ENABLED    = BT_CFG.snsViews;
  var SNS_DATA_URL   = BT_CFG.snsViewsUrl;
  var SNS_PROXY_BASE = (BT_CFG.snsProxyBase || '').trim();

  var ALIAS_DATA_URL = BT_CFG.styleAliasesUrl;

  var GALLERY_ENABLED = BT_CFG.showGallery;
  var GALLERY_DATA_URL = (BT_CFG.galleryUrl || BT_CFG.customizerGalleryUrl || '').trim();

  var DESIGN_ENABLED  = BT_CFG.saveShare;
  var DESIGN_API_BASE = (BT_CFG.designApiBase || '').trim();
  var CHECKOUT_API = DESIGN_API_BASE.replace(/\/d\/?$/, '') + '/checkout';
  var UPLOAD_API = DESIGN_API_BASE.replace(/\/d\/?$/, '') + '/upload';
  var PREMIUM_MODE = BT_CFG.premiumMode;
  var PB_API = DESIGN_API_BASE.replace(/\/d\/?$/, '') + '/pb';
  var LOGO_GEN_API = DESIGN_API_BASE.replace(/\/d\/?$/, '') + '/logo-gen';
  var TURNSTILE_SITE_KEY = (BT_CFG.turnstileSiteKey || '').trim();

  var TS_ENABLED  = BT_CFG.teamStores;
  var TS_API_BASE = (BT_CFG.tsApiBase || '').trim();
  var TS_PAGE     = (BT_CFG.teamStorePage || '/pages/team-store').trim();

  var PRICING_ENABLED   = BT_CFG.livePricing;

  /* ── Funnel tracking ────────────────────────────────────────────────────────
     The six wizard steps all happen on ONE page, so until now the only things that
     ever reached a server were "sent a quote" and "reached checkout" — the people who
     FINISHED. Everyone who dropped out was invisible. cxTrack beacons one event per
     step/action so abandonment is measurable.

     navigator.sendBeacon, not fetch: a fetch is cancelled when the tab closes, which is
     exactly the abandonment moment we're trying to capture. Beacons can only send
     "simple" requests, so the body goes as text/plain — an application/json content type
     would force a CORS preflight that a beacon cannot perform, and the event would
     vanish silently. The server JSON.parses it.

     Never throws and never blocks the UI: analytics must not be able to break checkout. */
  var CX_ENDPOINT = (BT_CFG.cxEventEndpoint || '').trim();
  var CX_SID = (function(){
    try{
      var k='bt_cx_sid', v=sessionStorage.getItem(k);
      if(!v){ v=(Date.now().toString(36)+Math.random().toString(36).slice(2,10)); sessionStorage.setItem(k,v); }
      return v;
    }catch(e){ return 'nostore-'+Math.random().toString(36).slice(2,10); }
  })();
  var CX_MAXSTEP = 0;
  function cxTrack(event, extra){
    if(!CX_ENDPOINT) return;
    try{
      var m = (extra && extra.step) ? parseInt(extra.step,10) : 0;
      if(m > CX_MAXSTEP){
        CX_MAXSTEP = m;
        // tag the Clarity session too, so replays can be filtered by furthest step
        try{ if(window.clarity) window.clarity('set','cx_max_step',String(m)); }catch(e){}
      }
      try{ if(window.clarity) window.clarity('set','cx_event',event); }catch(e){}
      var body = { session_id: CX_SID, event: event, referrer: document.referrer || '' };
      for(var k in (extra||{})) if(extra[k]!=null && extra[k]!=='') body[k]=extra[k];
      var blob = new Blob([JSON.stringify(body)], { type:'text/plain;charset=UTF-8' });
      if(navigator.sendBeacon) navigator.sendBeacon(CX_ENDPOINT, blob);
      else fetch(CX_ENDPOINT,{method:'POST',body:JSON.stringify(body),headers:{'Content-Type':'text/plain'},keepalive:true}).catch(function(){});
    }catch(e){ /* analytics must never break the page */ }
  }
  // What the customer has told us so far — attached to every event so an abandoned
  // session is a usable lead (name/email/ZIP come from step 1, price from step 4+).
  function cxContext(){
    var o={};
    try{
      o.name=qval('qName'); o.email=qval('qEmail'); o.zip=(shipDest()||{}).raw||'';
      if(product && product.title) o.product=product.title;
      if(currentMethod()) o.method=currentMethod();
      var pcs=totalPieces(); if(pcs>0) o.pieces=pcs;
      if(PRICE_RATES && !designsBelowMoq().length){
        var b=null; try{ b=priceOrder(); }catch(e){}
        if(b && b.total>0) o.total=b.total;
      }
    }catch(e){}
    return o;
  }
  var PRICING_RATES_URL = BT_CFG.pricingRatesUrl;
  var DISCOUNT_DATA_URL = BT_CFG.discountProductsUrl;
  var SHIPPING_DATA_URL = BT_CFG.garmentShippingUrl;

  const STAGE_W = 588, STAGE_H = 700;  // native design resolution (0.84 garment aspect); larger = bigger, crisper canvas

  const fonts = ["DM Sans","Bricolage Grotesque","Anton","Bebas Neue","Oswald",
                 "Playfair Display","Pacifico","Lobster","Permanent Marker","Caveat",
                 "Montserrat","Poppins","Roboto","Open Sans","Lato","Raleway",
                 "Archivo Black","Teko","Fjalla One","Staatliches","Alfa Slab One",
                 "Bungee","Luckiest Guy","Bangers","Titan One","Fredoka","Baloo 2",
                 "Righteous","Russo One","Passion One","Black Ops One","Monoton",
                 "Audiowide","Orbitron","Abril Fatface","Merriweather","Lora",
                 "Roboto Slab","Bitter","Rye","Dancing Script","Great Vibes",
                 "Satisfy","Sacramento","Kaushan Script","Yellowtail"];
  const swatchPal = ["#181410","#ffffff","#c0322f","#1f2a44","#e0a526","#1f9d55","#5a3a8e","#e2682a"];

  let product = null;        // /products/{handle}.js object
  let selectedColor = null;  // chosen color value (string)
  let currentView = null;    // current image src being designed on
  let designs = {};          // viewSrc -> fabric JSON
  let colorGroups = [];      // [{val, img, images:[...], url}] one per color (merged across split pages)
  let selectedSourceUrl = null; // the specific sibling-page URL for the chosen color (for the quote)
  let pendingColor = null;   // color to auto-select after a deep-link load (?color=)
  let uploads = [];          // session library of uploaded art {id,name,kind,data}
  let uploadSeq = 1;
  let zoom = 1;

  /* ============================================================
     SANMAR FRONT/BACK VIEWS
     Maps a product's style# (the trailing token of its SanMar
     title) + color to SanMar's front/back model images (flat-lay
     as fallback), so customers can design the back of a garment
     even when only the front was imported into Shopify.
     ============================================================ */
  let sanmarData = null;     // {prefix, styles:{STYLE:{color:[fm,bm,ff,bf]}}}
  let sanmarLoading = null;  // in-flight fetch promise (load once, cache)

  function loadSanmar(){
    if(!SANMAR_ENABLED) return Promise.resolve(null);
    if(sanmarData) return Promise.resolve(sanmarData);
    if(sanmarLoading) return sanmarLoading;
    sanmarLoading = fetch(SANMAR_DATA_URL,{headers:{'Accept':'application/json'}})
      .then(r=>{ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(d=>{ sanmarData=d; return d; })
      .catch(e=>{ console.warn('[BulkThreads] SanMar views unavailable',e); return null; });
    return sanmarLoading;
  }

  function sqTok(x){ return String(x).replace(/[^A-Za-z0-9]+/g,'').toUpperCase(); }
  function nvVendor(x){ return String(x||'').toLowerCase().replace(/[^a-z0-9]+/g,''); }

  var aliasData = null, aliasLoading = null;
  function loadAliases(){
    if(aliasData) return Promise.resolve(aliasData);
    if(aliasLoading) return aliasLoading;
    if(!ALIAS_DATA_URL) return Promise.resolve(null);
    aliasLoading = fetch(ALIAS_DATA_URL,{headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(d){ aliasData=d||{}; return aliasData; })
      .catch(function(e){ console.warn('[BulkThreads] style aliases unavailable',e); aliasData={}; return aliasData; });
    return aliasLoading;
  }
  function styleAlias(tok, vendor){
    if(!aliasData) return '';
    var m=aliasData[nvVendor(vendor)];
    return (m && m[tok]) || '';
  }

  function vendorPrefixes(vendor){
    var mills=(sanmarData&&sanmarData.mills)||{}, v=nvVendor(vendor);
    if(!v) return [];
    if(mills[v]) return mills[v];
    var keys=Object.keys(mills);
    for(var i=0;i<keys.length;i++){ var k=keys[i]; if(k&&(k.indexOf(v)===0||v.indexOf(k)===0)) return mills[k]; }
    return [];
  }

  function styleCandidates(tok, vendor){
    var out=[tok], stripped=tok.replace(/^[A-Za-z]+/,'');
    if(stripped && stripped!==tok) out.push(stripped);
    var pfx=vendorPrefixes(vendor);
    for(var i=0;i<pfx.length;i++){ out.push(pfx[i]+tok); if(stripped) out.push(pfx[i]+stripped); }
    return out;
  }

  function matchStyle(title, vendor){
    if(!sanmarData) return '';
    var styles=sanmarData.styles;
    var toks=String(title||'').trim().split(/\s+/).map(sqTok).filter(Boolean);
    var vpfx=vendorPrefixes(vendor);
    if(vpfx.length){
      for(var pi=0;pi<toks.length;pi++){
        if(!/[0-9]/.test(toks[pi])) continue;
        var pstr=toks[pi].replace(/^[A-Z]+/,'');
        for(var pp=0;pp<vpfx.length;pp++){
          if(vpfx[pp] && styles[vpfx[pp]+toks[pi]]) return vpfx[pp]+toks[pi];
          if(vpfx[pp] && pstr && pstr!==toks[pi] && styles[vpfx[pp]+pstr]) return vpfx[pp]+pstr;
        }
      }
    }
    for(var d=0; d<2; d++){
      for(var i=0;i<toks.length;i++){
        if(d===0 && !/[0-9]/.test(toks[i])) continue;
        if(styles[toks[i]]) return toks[i];
      }
    }
    for(var j=0;j<toks.length;j++){
      if(!/[0-9]/.test(toks[j])) continue;
      var cs=styleCandidates(toks[j], vendor);
      for(var k=0;k<cs.length;k++){ if(styles[cs[k]]) return cs[k]; }
    }
    for(var a=0;a<toks.length;a++){
      var ak=styleAlias(toks[a], vendor);
      if(!ak) continue;
      if(styles[ak]) return ak;
      var acs=styleCandidates(ak, vendor);
      for(var ci=0;ci<acs.length;ci++){ if(styles[acs[ci]]) return acs[ci]; }
    }
    return '';
  }

  function sanmarLookup(style, color){
    if(!sanmarData || !style) return null;
    var st=sanmarData.styles[String(style).toUpperCase()];
    if(!st) return null;
    var key=String(color||'').trim().toLowerCase();
    if(st[key]) return st[key];
    var squash=function(x){return String(x).replace(/[^a-z0-9]+/g,'');};
    var want=squash(key), keys=Object.keys(st);
    for(var i=0;i<keys.length;i++){ if(squash(keys[i])===want) return st[keys[i]]; }
    if(want){ for(var j=0;j<keys.length;j++){ var s=squash(keys[j]); if(s.indexOf(want)===0||want.indexOf(s)===0) return st[keys[j]]; } }
    return null;
  }

  function sanmarImg(rel){
    if(!rel) return '';
    if(/^https?:/i.test(rel)) return rel;                 // already absolute (none today)
    if(!SANMAR_USE_PROXY || !SANMAR_PROXY_BASE) return '';
    return SANMAR_PROXY_BASE + rel.split('/').map(encodeURIComponent).join('/');
  }

  function sanmarViews(style, color){
    var rec=sanmarLookup(style,color);
    if(!rec) return [];
    var front=sanmarImg((rec[0]||'')||(rec[2]||'')), back=sanmarImg((rec[1]||'')||(rec[3]||''));
    var out=[];
    if(front) out.push({label:'Front', src:front});
    if(back)  out.push({label:'Back',  src:back});
    return out;
  }

  /* ============================================================
     S&S ACTIVEWEAR FRONT/SIDE/BACK VIEWS
     S&S serves on-model front/side/back from its CDN; we proxy them
     (origin hidden) and prefer them over SanMar because they add a
     side view. Lookup: styleName -> [{b:brandNorm, c:{color:[colorID,views]}}].
     ============================================================ */
  let snsData = null, snsLoading = null;
  function loadSns(){
    if(!SNS_ENABLED) return Promise.resolve(null);
    if(snsData) return Promise.resolve(snsData);
    if(snsLoading) return snsLoading;
    snsLoading = fetch(SNS_DATA_URL,{headers:{'Accept':'application/json'}})
      .then(r=>{ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(d=>{ snsData=d; return d; })
      .catch(e=>{ console.warn('[BulkThreads] S&S views unavailable',e); return null; });
    return snsLoading;
  }

  function snsVendorMatch(vendor, b){
    var v=nvVendor(vendor);
    return v && b && (v.indexOf(b)===0 || b.indexOf(v)===0 || v.indexOf(b)>=0 || b.indexOf(v)>=0);
  }
  function matchSnsStyle(title, vendor){
    if(!snsData) return null;
    var toks=String(title||'').trim().split(/\s+/).map(sqTok).filter(Boolean);
    for(var i=0;i<toks.length;i++){
      if(!/[0-9]/.test(toks[i])) continue;
      var entries=snsData.styles[toks[i]];
      if(entries){
        for(var j=0;j<entries.length;j++){ if(snsVendorMatch(vendor, entries[j].b)) return entries[j]; }
        if(entries.length===1) return entries[0];
      }
      var sstr=toks[i].replace(/^[A-Z]+/,'');
      if(sstr && sstr!==toks[i]){
        var sent=snsData.styles[sstr];
        if(sent){ for(var k=0;k<sent.length;k++){ if(snsVendorMatch(vendor, sent[k].b)) return sent[k]; } }
      }
    }
    for(var t=0;t<toks.length;t++){
      var ak=styleAlias(toks[t], vendor);
      var aents=ak && snsData.styles[ak];
      if(!aents) continue;
      for(var e=0;e<aents.length;e++){ if(snsVendorMatch(vendor, aents[e].b)) return aents[e]; }
      if(aents.length===1) return aents[0];
    }
    // "STYLE-Descriptor" titles (Independent Trading "SS4500Z-Unisex ...", Core365
    // "CE106W-Women's ...") glue the style to the next word with a hyphen; sqTok strips
    // it to "SS4500ZUNISEX", which matches nothing. Recover the style head (an alnum run
    // containing a digit, immediately before a "-<letter>" boundary — so numeric ranges
    // like "1565-1566" stay glued) and match it, but ONLY on a vendor agreement (no
    // single-entry fallback) so a bare number can't cross brands (e.g. Imperial 6014 vs
    // Comfort Colors 6014). Runs last, so it never changes an existing match.
    var heads=String(title||'').trim().split(/\s+/).map(function(w){
      var m=w.match(/^([A-Za-z0-9]*[0-9][A-Za-z0-9]*)-[A-Za-z]/); return m?sqTok(m[1]):'';
    }).filter(Boolean);
    for(var h=0;h<heads.length;h++){
      var hen=snsData.styles[heads[h]];
      if(hen){ for(var hi=0;hi<hen.length;hi++){ if(snsVendorMatch(vendor, hen[hi].b)) return hen[hi]; } }
      var hs=heads[h].replace(/^[A-Z]+/,'');
      if(hs && hs!==heads[h]){ var hsent=snsData.styles[hs]; if(hsent){ for(var hj=0;hj<hsent.length;hj++){ if(snsVendorMatch(vendor, hsent[hj].b)) return hsent[hj]; } } }
    }
    return null;
  }
  function snsColorRec(colors, color){
    var k=String(color||'').trim().toLowerCase();
    if(colors[k]) return colors[k];
    var sq2=function(x){return String(x).replace(/[^a-z0-9]+/g,'');};
    var want=sq2(k), ks=Object.keys(colors);
    for(var i=0;i<ks.length;i++){ var s=sq2(ks[i]); if(s===want||s.indexOf(want)===0||want.indexOf(s)===0) return colors[ks[i]]; }
    return null;
  }
  function snsImg(colorID, code){
    if(!SNS_PROXY_BASE) return '';
    var file=colorID+'_'+code+'_'+(snsData&&snsData.size||'fl')+'.jpg';
    return SNS_PROXY_BASE + encodeURIComponent(file);
  }
  function snsViews(title, vendor, color){
    if(!snsData) return [];
    var e=matchSnsStyle(title, vendor); if(!e) return [];
    var rec=snsColorRec(e.c, color); if(!rec) return [];
    var id=rec[0], views=rec[1]||'', vm=snsData.views||{f:'omf',s:'oms',b:'omb'};
    var fs=views.indexOf('f')>=0?snsImg(id,vm.f):'', sd=views.indexOf('s')>=0?snsImg(id,vm.s):'', bk=views.indexOf('b')>=0?snsImg(id,vm.b):'';
    var out=[];
    if(fs) out.push({label:'Front', src:fs});
    if(sd) out.push({label:'Side',  src:sd});
    if(bk) out.push({label:'Back',  src:bk});
    return out;
  }

  const canvas = new fabric.Canvas('c', {
    backgroundColor:'transparent',
    preserveObjectStacking:true,
    selection:true
  });
  canvas.setDimensions({width:STAGE_W,height:STAGE_H});

  var BT_ACCENT = (BT_CFG.btAccent || '#ff4a23');
  fabric.Object.prototype.borderColor = BT_ACCENT;
  fabric.Object.prototype.cornerColor = BT_ACCENT;
  fabric.Object.prototype.cornerStrokeColor = '#ffffff';
  fabric.Object.prototype.cornerStyle = 'circle';
  fabric.Object.prototype.transparentCorners = false;
  fabric.Object.prototype.cornerSize = 12;
  fabric.Object.prototype.borderScaleFactor = 2;
  fabric.Object.prototype.padding = 4;
  if (fabric.Control) {
    var btDelImg = new Image();
    fabric.Object.prototype.controls.btDelete = new fabric.Control({
      x: 0.5, y: -0.5, offsetX: 14, offsetY: -14, cursorStyle: 'pointer',
      mouseUpHandler: function(eventData, transform){
        var c = transform.target.canvas, t = transform.target;
        c.remove(t); c.discardActiveObject(); c.requestRenderAll();
        try{ refreshLayers(); }catch(e){}
        return true;
      },
      render: function(ctx, left, top){
        var r = 11;
        ctx.save();
        ctx.translate(left, top);
        ctx.beginPath(); ctx.arc(0, 0, r, 0, 2*Math.PI, false);
        ctx.fillStyle = BT_ACCENT; ctx.fill();
        ctx.lineWidth = 1.5; ctx.strokeStyle = '#ffffff'; ctx.stroke();
        ctx.beginPath(); ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 2; ctx.lineCap = 'round';
        var k = 4; ctx.moveTo(-k,-k); ctx.lineTo(k,k); ctx.moveTo(k,-k); ctx.lineTo(-k,k); ctx.stroke();
        ctx.restore();
      },
      sizeX: 22, sizeY: 22
    });
    [fabric.Textbox, fabric.IText, fabric.Text].forEach(function(K){
      if (K && K.prototype && K.prototype.controls) K.prototype.controls.btDelete = fabric.Object.prototype.controls.btDelete;
    });
  }

  function showOverlay(msg,dur,after){
    const ov=document.getElementById('overlay'), bar=document.getElementById('ovBar'), m=document.getElementById('ovMsg');
    m.textContent=msg; bar.style.width='0'; ov.classList.add('show');
    let p=0; const t=setInterval(()=>{p+=Math.random()*22;if(p>100)p=100;bar.style.width=p+'%';
      if(p>=100){clearInterval(t);setTimeout(()=>{ov.classList.remove('show');after&&after();},220);}},dur/6);
  }

  document.querySelectorAll('#rail button[data-tab]').forEach(b=>b.onclick=()=>{
    if(typeof spotMode!=='undefined' && spotMode) exitSpotMode();   // never leave the user stuck in an erase mode
    if(typeof brushMode!=='undefined' && brushMode) exitBrushMode(true);
    document.querySelectorAll('#rail button').forEach(x=>x.classList.remove('active'));
    b.classList.add('active');
    document.querySelectorAll('.bt-customizer .pane').forEach(p=>p.classList.remove('active'));
    document.querySelector(`.bt-customizer [data-pane="${b.dataset.tab}"]`).classList.add('active');
  });
  function goTab(name){document.querySelector(`#rail [data-tab="${name}"]`).click();}

  var DECOR_URL = (BT_CFG.decorationGuideUrl || '').trim();
  document.getElementById('railDecoration').onclick=()=>{ if(DECOR_URL) window.open(DECOR_URL,'_blank','noopener'); };
  document.getElementById('railSpec').onclick=openSpecGuide;

  /* ---- "See our work" gallery ----
     Loads the curated list once and reveals the rail button only if it has
     items, so customers never see an empty gallery. */
  var galleryItems=null;
  function loadGallery(){
    if(!GALLERY_ENABLED || !GALLERY_DATA_URL) return;
    fetch(GALLERY_DATA_URL,{headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(d){
        galleryItems=(Array.isArray(d)?d:(d&&d.items)||[]).filter(function(it){ return it&&it.src; });
        if(galleryItems.length) document.getElementById('railWork').style.display='';
      })
      .catch(function(e){ console.warn('[BulkThreads] gallery unavailable',e); });
  }
  function openWorkGallery(){
    var grid=document.getElementById('workGrid');
    if(galleryItems&&galleryItems.length){
      grid.innerHTML='';
      galleryItems.forEach(function(it){
        var fig=document.createElement('div'); fig.className='work-item';
        var img=document.createElement('img'); img.loading='lazy'; img.src=it.src; img.alt=it.caption||'Our work';
        img.onerror=function(){ fig.style.display='none'; };   // hide broken images gracefully
        fig.appendChild(img);
        if(it.caption){ var cap=document.createElement('div'); cap.className='work-cap'; cap.textContent=it.caption; fig.appendChild(cap); }
        grid.appendChild(fig);
      });
    }else{
      grid.innerHTML='<div class="work-empty">Project photos coming soon.</div>';
    }
    document.getElementById('workModal').classList.add('show');
  }
  function closeWorkGallery(){ document.getElementById('workModal').classList.remove('show'); }
  document.getElementById('railWork').onclick=openWorkGallery;
  document.getElementById('wmClose').onclick=closeWorkGallery;
  document.getElementById('workModal').addEventListener('click',function(e){ if(e.target.id==='workModal') closeWorkGallery(); });
  loadGallery();

  /* ============================================================
     PRODUCT SEARCH + SELECTION (Shopify AJAX API)
     ============================================================ */
  const searchInput = document.getElementById('prodSearch');
  const resultsBox = document.getElementById('searchResults');
  let searchTimer=null;

  let searchState = { query:'', page:0, pages:1, total:0, groups:[], byTitle:new Map() };

  searchInput.addEventListener('input',()=>{
    clearTimeout(searchTimer);
    const q=searchInput.value.trim();
    if(q.length<2){
      if(PREMIUM_MODE){ searchTimer=setTimeout(()=>runSearch('',false),250); return; }
      searchState={query:'',page:0,pages:1,total:0,groups:[],byTitle:new Map()};resultsBox.innerHTML='';return;
    }
    searchTimer=setTimeout(()=>runSearch(q,false),250);
  });
  if(PREMIUM_MODE){ searchInput.addEventListener('focus',()=>{ if(!searchState.groups.length) runSearch('',false); }); }
  document.querySelectorAll('#pbBrands .pb-brand').forEach(function(b){
    b.addEventListener('click',function(){ var brand=(b.dataset.brand||'').trim(); searchInput.value=brand; runSearch(brand,false); });
  });
  if(PREMIUM_MODE){
    var pbMenu=document.getElementById('pbBrandMenu'), pbMenuWrap=document.getElementById('pbBrandMenuWrap');
    if(pbMenu){
      fetch(PB_API+'/brands',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(list){
        if(!Array.isArray(list)||!list.length) return;
        list.forEach(function(b){ var o=document.createElement('option'); o.value=b; o.textContent=b; pbMenu.appendChild(o); });
        if(searchInput.value){ pbMenu.value=searchInput.value; }   // reflect a ?brand= deep link
        if(pbMenuWrap) pbMenuWrap.style.display='';
      }).catch(function(){});
      pbMenu.addEventListener('change',function(){ var v=pbMenu.value; searchInput.value=v; runSearch(v,false); });
    }
  }

  // Warm the sibling customizer page so the Standard <-> Retail toggle feels fast (prefetch on
  // hover/touch/focus, plus once on idle for no-hover devices). Cuts the reload lag.
  (function(){
    var t = document.querySelector('.pb-toggle a.pb-toggle-opt'); if(!t || !t.getAttribute('href')) return;
    var done = false;
    function pf(){ if(done) return; done = true; var l = document.createElement('link'); l.rel = 'prefetch'; l.href = t.getAttribute('href'); document.head.appendChild(l); }
    ['mouseenter','touchstart','focus'].forEach(function(ev){ t.addEventListener(ev, pf, { passive:true, once:true }); });
    (window.requestIdleCallback || function(f){ setTimeout(f, 1800); })(pf);
  })();

  async function runSearch(q, append){
    if(PREMIUM_MODE) return runSearchPremium(q, append);
    if(!append){
      searchState={query:q,page:0,pages:1,total:0,groups:[],byTitle:new Map()};
      resultsBox.innerHTML='<div class="search-empty">Searching…</div>';
    }
    const nextPage=searchState.page+1;
    try{
      const url=`/search?q=${encodeURIComponent(q)}&type=product&options[unavailable_products]=last&view=customizer&page=${nextPage}`;
      const res=await fetch(url,{headers:{'Accept':'application/json'}});
      if(!res.ok) throw new Error('HTTP '+res.status);
      const data=JSON.parse(await res.text());
      searchState.page=data.page||nextPage;
      searchState.pages=data.pages||1;
      searchState.total=data.total||searchState.total;
      (data.products||[]).forEach(p=>addToResults(p));
      renderResults();
    }catch(e){
      console.error('[BulkThreads] search failed, falling back to suggest',e);
      if(!append) await runSearchSuggest(q);
    }
  }

  async function runSearchSuggest(q){
    try{
      const url=`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`;
      const res=await fetch(url,{headers:{'Accept':'application/json'}});
      const data=await res.json();
      const prods=(data.resources&&data.resources.results&&data.resources.results.products)||[];
      searchState.page=1; searchState.pages=1;
      prods.forEach(p=>addToResults({title:p.title,handle:p.handle,vendor:p.vendor,image:p.image||p.featured_image||''}));
      renderResults();
    }catch(e){
      resultsBox.innerHTML='<div class="search-empty">Search is unavailable right now.</div>';
    }
  }

  async function runSearchPremium(q, append){
    if(!append){
      searchState={query:q,page:0,pages:1,total:0,groups:[],byTitle:new Map(),cursor:null,hasNext:false};
      resultsBox.innerHTML='<div class="search-empty">Loading…</div>';
    }
    try{
      const url=PB_API+'/list?q='+encodeURIComponent(q)+((append&&searchState.cursor)?('&cursor='+encodeURIComponent(searchState.cursor)):'');
      const res=await fetch(url,{headers:{'Accept':'application/json'}});
      if(!res.ok) throw new Error('HTTP '+res.status);
      const data=await res.json();
      searchState.cursor=data.cursor||null;
      searchState.hasNext=!!data.hasNext;
      (data.items||[]).forEach(it=>addToResults({title:it.title,handle:it.handle,vendor:it.vendor,image:it.image,price:it.price}));
      renderResults();
    }catch(e){
      console.error('[BulkThreads] premium search failed',e);
      if(!append) resultsBox.innerHTML='<div class="search-empty">Search is unavailable right now.</div>';
    }
  }

  function addToResults(p){
    const key=(p.title||'').trim().toLowerCase();
    let g=searchState.byTitle.get(key);
    if(!g){ g={title:p.title,image:p.image||'',vendor:p.vendor||'',handles:[]}; searchState.byTitle.set(key,g); searchState.groups.push(g); }
    if(!g.image && p.image) g.image=p.image;
    if(p.price!=null && g.price==null) g.price=p.price;
    if(p.handle) g.handles.push(p.handle);
  }

  function renderResults(){
    resultsBox.innerHTML='';
    const groups=searchState.groups;
    if(!groups.length){resultsBox.innerHTML='<div class="search-empty">No products found.</div>';return;}
    groups.forEach(g=>{
      const row=document.createElement('div');row.className='search-result';
      const badge=g.handles.length>1?`<div class="sr-badge">${g.handles.length} pages · all colors merged</div>`:'';
      const priceHtml=(g.price!=null)?`<div class="sr-price">from ${money(g.price)}</div>`:'';
      row.innerHTML=`<div class="sr-thumb">${g.image?`<img src="${g.image}" alt="">`:''}</div><div><div class="sr-title">${g.title}</div>${priceHtml}${badge}</div>`;
      row.onclick=()=>selectGroup(g);
      resultsBox.appendChild(row);
    });
    const hasMore = PREMIUM_MODE ? searchState.hasNext : (searchState.page<searchState.pages);
    if(hasMore){
      const more=document.createElement('button');more.type='button';more.className='search-more';
      more.textContent=`Load more — showing ${groups.length}${searchState.total?` of ${searchState.total}`:''}`;
      more.onclick=()=>{more.textContent='Loading…';more.disabled=true;runSearch(searchState.query,true);};
      resultsBox.appendChild(more);
    }
  }

  function showBackToResults(){
    if(!searchState.groups.length){resultsBox.innerHTML='';return;}
    resultsBox.innerHTML='';
    const back=document.createElement('button');back.type='button';back.className='search-back';
    const n=searchState.groups.length;
    back.textContent=`← Back to ${n} result${n>1?'s':''}${searchState.query?` for “${searchState.query}”`:''}`;
    back.onclick=()=>renderResults();
    resultsBox.appendChild(back);
  }

  function fetchProduct(handle){
    const src = PREMIUM_MODE ? (PB_API+'/product/'+encodeURIComponent(handle)) : (`/products/${handle}.js`);
    return fetch(src,{headers:{'Accept':'application/json'}})
      .then(r=>{if(!r.ok)throw new Error('HTTP '+r.status);return r.json();});
  }

  async function selectGroup(g){
    resultsBox.innerHTML='<div class="search-empty">Loading colors…</div>';
    try{
      let handles=g.handles.slice();
      if(!PREMIUM_MODE) try{
        const url=`/search/suggest.json?q=${encodeURIComponent(g.title)}&resources[type]=product&resources[limit]=10`;
        const res=await fetch(url,{headers:{'Accept':'application/json'}});
        const data=await res.json();
        const more=((data.resources&&data.resources.results&&data.resources.results.products)||[])
          .filter(p=>(p.title||'').trim().toLowerCase()===(g.title||'').trim().toLowerCase())
          .map(p=>p.handle);
        handles=[...new Set(handles.concat(more))];
      }catch(e){}
      const fetched=await Promise.all(handles.map(h=>fetchProduct(h).catch(()=>null)));
      const valid=fetched.filter(Boolean);
      if(!valid.length) throw new Error('no products loaded');
      const merged=[], seenVal=new Set();
      valid.forEach(p=>extractColorGroups(p).forEach(cg=>{
        const key=(cg.val||'').toLowerCase();
        if(cg.val!=null && seenVal.has(key)) return;
        if(cg.val!=null) seenVal.add(key);
        merged.push(cg);
      }));
      valid.sort((a,b)=>(a.handle||'').length-(b.handle||'').length);
      const canon=valid[0];
      setupProduct(g.title, canon.url||('/products/'+canon.handle), merged, canon.vendor, mergeSizes(valid),
                   canon.handle, canon.type||'', buildPriceBySize(valid));
      showBackToResults();
    }catch(e){
      console.error('[BulkThreads] group load failed',e);
      resultsBox.innerHTML='<div class="search-empty">Could not load that product.</div>';
    }
  }

  function buildPriceBySize(products){
    var map={};
    (products||[]).forEach(function(p){
      var names=optionNames(p);
      var idx=names.findIndex(function(n){return /^\s*sizes?\s*$/i.test(n);});
      (p.variants||[]).forEach(function(v){
        var vals=v.options||[v.option1,v.option2,v.option3];
        var sz=idx>=0?vals[idx]:null;
        var key=String(sz==null?'__all__':sz).trim()||'__all__';
        var cents=(typeof v.price==='number')?v.price:parseInt(v.price,10);
        if(!isNaN(cents)){ var d=cents/100; if(map[key]==null||d>map[key]) map[key]=d; }
      });
    });
    return map;
  }

  function setupProduct(title,url,groups,vendor,sizes,handle,ptype,priceBySize){
    cxTrack('product_selected', { product:title, meta:{ vendor:vendor||'', handle:handle||'' } });
    product={title:title,url:url,vendor:vendor||'',sizes:sizes||[],
             handle:(handle||((url||'').split('?')[0].split('/').pop())||''),
             type:ptype||'', priceBySize:priceBySize||{}};
    if(SNS_ENABLED) loadSns();         // warm the lookups while the user picks a color
    if(SANMAR_ENABLED) loadSanmar();
    captureCarry(false);               // stash the outgoing artwork BEFORE the reset below wipes it
    designs={}; currentView=null; selectedColor=null; selectedSourceUrl=url;
    var sgReset=document.getElementById('sizeGrid'); if(sgReset){ sgReset.innerHTML=''; delete sgReset.dataset.sig; }
    var dqReset=document.getElementById('decoQty'); if(dqReset) dqReset.value='';
    document.getElementById('selProdTitle').textContent=title;
    const link=document.getElementById('selProdLink'); if(link) link.href=url||'#';   // absent in premium mode (Draft products have no public page)
    document.getElementById('productInfo').style.display='block';
    // Collapse the intro copy + shortcut banners so the colour swatches sit higher.
    try{ document.querySelector('.pane[data-pane="product"]').classList.add('has-product'); }catch(e){}
    resultsBox.innerHTML=''; searchInput.value=title;
    renderColorUI(groups);
  }

  function optionNames(p){
    if(!p.options) return [];
    return p.options.map(o=> typeof o==='string' ? o : (o&&o.name) || '');
  }
  function colorOptionIndex(p){
    return optionNames(p).findIndex(n=>/colou?r/i.test(n));
  }

  var SIZE_ORDER=['xxs','xs','s','sm','small','m','md','medium','l','lg','large','xl','xlarge',
    '2xl','xxl','2x','3xl','xxxl','3x','4xl','4x','5xl','5x','6xl','6x','osfa','one size'];
  function sizeRank(s){ var i=SIZE_ORDER.indexOf(String(s).trim().toLowerCase()); return i<0?999:i; }
  function sizeValues(p){
    var idx=optionNames(p).findIndex(n=>/^\s*sizes?\s*$/i.test(n));
    if(idx<0) return [];
    var seen=[], set=new Set();
    (p.variants||[]).forEach(function(v){
      var vals=v.options||[v.option1,v.option2,v.option3];
      var val=vals[idx];
      if(val==null) return;
      var k=String(val).trim(); if(!k||set.has(k)) return; set.add(k); seen.push(k);
    });
    return seen;
  }
  function mergeSizes(products){
    var out=[], set=new Set();
    (products||[]).forEach(function(p){ sizeValues(p).forEach(function(s){ if(!set.has(s)){set.add(s);out.push(s);} }); });
    return out.sort(function(a,b){ var ra=sizeRank(a),rb=sizeRank(b); return ra===rb?0:ra-rb; });
  }

  // colour||size combos Shopify reports as unavailable (out of stock AND policy=deny).
  // The customizer never checked stock, and its checkout builds a DRAFT order, which does
  // not enforce inventoryPolicy -- so DENY on the variant stops the normal cart but not
  // this. BT18223 went through that gap for 466 pieces of a delisted colourway.
  var stockOut={};
  function stockKey(c,z){ return String(c==null?'':c).trim().toLowerCase()+'||'+String(z==null?'':z).trim().toLowerCase(); }
  function isKnownOut(c,z){ return stockOut[stockKey(c,z)]===true; }

  function extractColorGroups(p){
    const purl=p.url||('/products/'+p.handle);
    const imgs=(p.images&&p.images.length)?p.images.slice():(p.featured_image?[p.featured_image]:[]);
    const ci=colorOptionIndex(p);
    const sIdx=optionNames(p).findIndex(function(n){return /^\s*sizes?\s*$/i.test(n);});
    const pricesByColor={};
    stockOut={};
    (p.variants||[]).forEach(function(v){
      const vals=v.options||[v.option1,v.option2,v.option3];
      const cv=(ci<0)?'__nocolor__':vals[ci]; if(cv==null) return;
      const sv=sIdx>=0?vals[sIdx]:null;
      // Only record a POSITIVE no. A combo we cannot see (it lives on a sibling page that
      // was not merged in) stays unknown and is never blocked.
      if(v.available===false) stockOut[stockKey(cv, sv==null?'__all__':sv)]=true;
      const sk=String(sv==null?'__all__':sv).trim()||'__all__';
      const cents=(typeof v.price==='number')?v.price:parseInt(v.price,10);
      if(isNaN(cents)) return;
      (pricesByColor[cv]=pricesByColor[cv]||{})[sk]=cents/100;
    });
    if(ci<0){
      return [{val:null,img:imgs[0]||'',images:imgs.slice(0,12),url:purl,prices:pricesByColor['__nocolor__']||{}}];
    }
    const seen=new Map();
    (p.variants||[]).forEach(v=>{
      const vals = v.options || [v.option1,v.option2,v.option3];
      const val = vals[ci];
      if(val==null || seen.has(val)) return;
      const fi=v.featured_image;
      seen.set(val,{val, pos:(fi&&fi.position)||null, src:(fi&&fi.src)||p.featured_image||imgs[0]||''});
    });
    const list=[...seen.values()];
    const positions=list.filter(c=>c.pos).map(c=>c.pos).sort((a,b)=>a-b);
    return list.map(c=>{
      let images;
      if(c.pos){
        const next=positions.find(p2=>p2>c.pos);
        const start=c.pos-1, end=next?next-1:imgs.length;
        images=imgs.slice(start,end);
        if(!images.length) images=[c.src];
      }else{
        images=[c.src];
      }
      return {val:c.val, img:c.src, images:images.slice(0,12), url:purl, prices:pricesByColor[c.val]||{}};
    });
  }

  function renderColorUI(groups){
    colorGroups=groups;
    const wrap=document.getElementById('colorSwatches');
    const grp=document.getElementById('colorGroup');
    wrap.innerHTML='';
    const hasColors = groups.length>1 || (groups[0] && groups[0].val!=null);
    grp.style.display = hasColors ? 'block' : 'none';
    let startIdx=0;
    if(pendingColor){
      const idx=groups.findIndex(g=>(g.val||'').toLowerCase()===pendingColor.toLowerCase());
      if(idx>=0) startIdx=idx;
      pendingColor=null;
    }
    groups.forEach((c,i)=>{
      const d=document.createElement('button');
      d.className='color-swatch'+(i===startIdx?' active':'');
      d.title=c.val||'Default';
      d.innerHTML=`<span class="cs-dot">${c.img?`<img src="${c.img}" alt="" crossorigin="anonymous">`:''}</span><span class="cs-name">${c.val||'Default'}</span>`;
      d.onclick=()=>{
        document.querySelectorAll('#colorSwatches .color-swatch').forEach(s=>s.classList.remove('active'));
        d.classList.add('active'); setColorGroup(i);
      };
      wrap.appendChild(d);
    });
    setColorGroup(startIdx);
    const act=wrap.querySelector('.color-swatch.active');
    if(act && act.scrollIntoView) act.scrollIntoView({block:'nearest'});
  }

  function setColorGroup(i){
    const g=colorGroups[i];
    if(!g)return;
    // A color change keeps `designs` but changes every image URL, so the art would
    // silently vanish. Same mechanism as a product switch — but carried over
    // automatically, since nobody changes color intending to lose their artwork.
    if(selectedColor!==null && selectedColor!==g.val) captureCarry(true);
    selectedColor=g.val;
    selectedSourceUrl=g.url||(product&&product.url)||null;
    if(product) product.activePrices=g.prices||null;   // exact per-size prices for THIS color (matches the charged variant)
    applyViews(g);
    updateSelProdPrice();
    try{ if(currentMethod&&currentMethod()==='dtg'){ renderPrice(); } }catch(e){}
    scheduleSave();
  }

  function updateSelProdPrice(){
    var el=document.getElementById('selProdPrice'); if(!el) return;
    if(!PRICING_ENABLED){ el.style.display='none'; return; }   // show whenever live pricing is on (no method needed yet)
    var prices=(product&&product.activePrices)||null;
    var vals=prices?Object.keys(prices).map(function(k){return prices[k];}).filter(function(n){return n>0;}):[];
    if(!vals.length){ el.style.display='none'; return; }
    var min=Math.min.apply(null,vals);
    el.style.display='';
    el.innerHTML='Garment <b>from '+money(min)+'/ea</b> <span style="color:var(--ink-2,#777);font-weight:500">— decoration added when you build your order</span>';
  }

  /* ============================================================
     IMPORT THE SHOPIFY CART
     Someone who already picked 100 garments on the storefront shouldn't have to
     retype them here. /cart.js is a public same-origin endpoint, and the shape
     lines up: a cart grouped by product then color IS what the size grid stores
     (`readColorSizes` -> [{color, sizes:{size:qty}}]). So we import the tedious
     part — the quantities — and let the existing design + "add another product"
     flow (with the carry prompt) handle the artwork.
     ============================================================ */
  let cartImport=[];        // products still waiting to be worked through
  let cartImportOn=false;   // an import is in progress, so auto-fill the next product

  function cartOptVal(li,re){
    const ov=li.options_with_values||[];
    for(let i=0;i<ov.length;i++){ if(re.test(ov[i].name||'')) return String(ov[i].value||'').trim(); }
    return '';
  }
  // Fall back to the variant title ("Royal / XL") when options aren't named.
  function cartVariantParts(li){
    return String(li.variant_title||'').split('/').map(function(s){ return s.trim(); }).filter(Boolean);
  }

  async function fetchCart(){
    const r=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    if(!r.ok) throw new Error('HTTP '+r.status);
    return r.json();
  }

  // Cart lines -> one entry per product, each holding {color: {size: qty}}.
  function groupCart(cart){
    const byHandle={}, skipped=[];
    (cart.items||[]).forEach(function(li){
      const handle=(li.handle||'').trim();
      if(!handle){ skipped.push(li.product_title||'an item'); return; }
      // Prefer named options; fall back to the variant title only for what's missing.
      // Careful: a one-option product ("OSFA") has a size and NO color — inferring a
      // color from the variant title there would file it under a color named "OSFA".
      let color=cartOptVal(li,/colou?r/i), size=cartOptVal(li,/size/i);
      const parts=cartVariantParts(li);
      if(!color && !size){
        if(parts.length>=2){ color=parts[0]; size=parts[parts.length-1]; }
        else { size=parts[0]||''; }                                  // single option = the size
      }else if(!size){
        const rest=parts.filter(function(x){ return x!==color; });
        size=rest[rest.length-1]||'';
      }else if(!color){
        const rest=parts.filter(function(x){ return x!==size; });
        color=rest[0]||'';                                           // stays '' when size-only
      }
      // A product with no size option at all (a tote, a patch) is still decoratable —
      // the size grid represents that as the single "__all__" bucket.
      if(!size) size='__all__';
      const g=byHandle[handle]||(byHandle[handle]={
        handle:handle, title:li.product_title||handle, image:li.image||'', colors:{}, pieces:0
      });
      const c=g.colors[color]||(g.colors[color]={});
      c[size]=(c[size]||0)+(li.quantity||0);
      g.pieces+=(li.quantity||0);
    });
    return { products:Object.keys(byHandle).map(function(h){ return byHandle[h]; }), skipped:skipped };
  }

  function openCartImport(){
    const modal=document.getElementById('cartModal'); if(!modal) return;
    const list=document.getElementById('cartList'), st=document.getElementById('cartStatus'),
          sk=document.getElementById('cartSkipped');
    if(st) st.textContent=''; if(sk) sk.textContent='';
    list.innerHTML='<p class="qm-foot">Reading your cart…</p>';
    modal.classList.add('show');
    fetchCart().then(function(cart){
      const g=groupCart(cart);
      if(!g.products.length){
        list.innerHTML='<p class="qm-foot">Your cart is empty — add the garments you want on the store first, then come back.</p>';
        return;
      }
      list.innerHTML=g.products.map(function(p,i){
        const colors=Object.keys(p.colors);
        return '<label style="display:flex;gap:10px;align-items:flex-start;padding:9px 0;border-bottom:1px solid var(--line);cursor:pointer">'+
          '<input type="checkbox" class="cart-pick" data-i="'+i+'" checked style="margin-top:3px">'+
          (p.image?('<img src="'+p.image+'" alt="" style="width:44px;height:44px;object-fit:contain;background:var(--paper);border:1px solid var(--line);border-radius:6px;flex:none">'):'')+
          '<span style="flex:1;min-width:0;font-size:13.5px;line-height:1.35"><b>'+_artEsc(p.title)+'</b>'+
            '<br><span style="color:var(--ink-2)">'+_artEsc(colors.join(', '))+' · '+p.pieces+' pc'+(p.pieces===1?'':'s')+'</span></span>'+
        '</label>';
      }).join('');
      if(g.skipped.length && sk) sk.textContent=g.skipped.length+' item(s) in your cart can’t be decorated here and were left out.';
      cartImport=g.products;
    }).catch(function(e){
      console.error('[BulkThreads] cart read failed',e);
      list.innerHTML='<p class="qm-foot">Sorry — we couldn’t read your cart just now.</p>';
    });
  }
  function closeCartImport(){ const m=document.getElementById('cartModal'); if(m) m.classList.remove('show'); }

  // Drop the imported quantities into the size grid for whichever product is loaded.
  function applyCartQuantities(entry){
    if(!entry) return 0;
    const grid=document.getElementById('sizeGrid');
    if(!grid || grid.style.display==='none') return 0;
    let placed=0;
    // Anything we can't find a cell for is reported rather than silently dropped —
    // losing pieces out of a 100-shirt import would be invisible otherwise.
    applyCartQuantities.missed=[];
    Object.keys(entry.colors).forEach(function(color){
      // The grid starts with the selected color; add a block for any others.
      if(!grid.querySelector('.qm-color-block[data-color="'+(color||'').replace(/"/g,'\\"')+'"]')){
        try{ addColorBlock(color); }catch(e){}
      }
      const block=grid.querySelector('.qm-color-block[data-color="'+(color||'').replace(/"/g,'\\"')+'"]')
               || grid.querySelector('.qm-color-block');
      if(!block) return;
      Object.keys(entry.colors[color]).forEach(function(size){
        const inp=block.querySelector('input[data-size="'+String(size).replace(/"/g,'\\"')+'"]')
               || block.querySelector('input[data-size="__all__"]');
        if(inp){ inp.value=entry.colors[color][size]; placed++; }
        else applyCartQuantities.missed.push((color?(color+' '):'')+size+' ×'+entry.colors[color][size]);
      });
    });
    try{ updateSizeTotal(); }catch(e){}
    return placed;
  }

  // Load the next imported product: pick it, choose its first color, fill quantities.
  async function loadNextCartProduct(){
    const entry=cartImport.shift();
    if(!entry){ cartImportOn=false; return false; }
    try{
      await selectGroup({ title:entry.title, handles:[entry.handle], image:entry.image||'' });
      const first=Object.keys(entry.colors)[0];
      if(first){
        const idx=(colorGroups||[]).findIndex(function(g){ return g && String(g.val).toLowerCase()===String(first).toLowerCase(); });
        if(idx>=0) setColorGroup(idx);
      }
      try{ buildSizeGrid(); }catch(e){}
      const placed=applyCartQuantities(entry);
      cartToast(entry, placed);
      return true;
    }catch(e){
      console.error('[BulkThreads] cart product load failed',entry&&entry.handle,e);
      return false;
    }
  }

  function cartToast(entry,placed){
    const el=document.getElementById('cartStatus');
    const left=cartImport.length;
    const missed=(applyCartQuantities.missed||[]);
    const msg=(placed?('Filled in '+entry.pieces+' pc'+(entry.pieces===1?'':'s')+' for '+entry.title+'.')
                    :('Loaded '+entry.title+' — enter its quantities below.'))+
              (left?(' '+left+' more garment'+(left===1?'':'s')+' from your cart to go.'):' That was the last one from your cart.')+
              (missed.length?('  ⚠ This garment has no '+missed.join(', ')+' here — add those by hand.'):'');
    if(el) el.textContent=msg;
    try{ qmErr(msg); }catch(e){}
  }

  function startCartImport(){
    const picks=Array.prototype.filter.call(document.querySelectorAll('.cart-pick'),function(c){ return c.checked; })
      .map(function(c){ return cartImport[parseInt(c.getAttribute('data-i'),10)]; }).filter(Boolean);
    if(!picks.length){ alert('Pick at least one garment to import.'); return; }
    cartImport=picks; cartImportOn=true;
    closeCartImport();
    if(typeof goTab==='function') goTab('product');
    loadNextCartProduct();
  }

  // Cart permalinks only carry variant ids, and a cart belongs to the browser that
  // built it — so instead of decoding the link we let Shopify load it into THIS
  // cart and bounce straight back here with ?importcart=1.
  function loadCartPermalink(){
    const raw=((document.getElementById('cartPermalink')||{}).value||'').trim();
    const m=raw.match(/\/cart\/([0-9]+:[0-9]+(?:,[0-9]+:[0-9]+)*)/);
    if(!m){ alert('That doesn’t look like a cart link. It should contain /cart/ followed by numbers, e.g. /cart/12345:2,67890:5'); return; }
    const back=window.location.pathname+'?importcart=1';
    window.location.href='/cart/'+m[1]+'?return_to='+encodeURIComponent(back);
  }

  function initCartImport(){
    const link=document.getElementById('importCartLink');
    if(link) link.onclick=function(e){ e.preventDefault(); openCartImport(); };
    const x=document.getElementById('cartClose'); if(x) x.onclick=closeCartImport;
    const m=document.getElementById('cartModal');
    if(m) m.addEventListener('click',function(e){ if(e.target.id==='cartModal') closeCartImport(); });
    const imp=document.getElementById('cartImport'); if(imp) imp.onclick=startCartImport;
    const pl=document.getElementById('cartLoadLink'); if(pl) pl.onclick=loadCartPermalink;

    // Only advertise the button when there's actually something to import.
    fetchCart().then(function(cart){
      const cta=document.getElementById('importCartCta');
      if(cta && groupCart(cart).products.length){
        cta.style.display='';   // the .cta-row flex handles the layout either way
      }
      try{
        if(new URLSearchParams(window.location.search).get('importcart')==='1') openCartImport();
      }catch(e){}
    }).catch(function(){});
  }

  /* ============================================================
     CARRY A DESIGN TO THE NEXT GARMENT
     `designs` is keyed by garment IMAGE URL, so switching product — or even color —
     leaves the new views with no matching key and the canvas comes up empty. This
     stashes the outgoing artwork and re-keys it onto the new product's matching
     views (by Front/Back/Side label, falling back to position for unlabelled
     Shopify thumbnails). Coordinates need no conversion: the canvas is always
     STAGE_W x STAGE_H for every product, layoutStage() only scales the DOM.
     ============================================================ */
  let carry=null;          // {views:[{label,index,json}], fromTitle, fromColor, sameProduct}
  let carryApplied=false;  // once accepted, re-apply through async view rebuilds

  // Snapshot the current artwork. MUST run while the outgoing product's view
  // buttons are still in the DOM — that's where the labels come from.
  function captureCarry(sameProduct){
    try{
      saveView();
      const srcs=Object.keys(designs).filter(function(s){ return designs[s]&&designs[s].objects&&designs[s].objects.length; });
      carryApplied=false;
      if(!srcs.length){ carry=null; return; }
      const order=Array.prototype.map.call(document.querySelectorAll('#viewThumbs [data-src]'),function(b){ return b.dataset.src; });
      carry={
        views:srcs.map(function(s){ return { label:(viewLabelForSrc(s)||'').toLowerCase(), index:order.indexOf(s), json:designs[s] }; }),
        fromTitle:(product&&product.title)||'', fromColor:selectedColor||'', sameProduct:!!sameProduct
      };
    }catch(e){ carry=null; }
  }

  // Re-snapshot from the live canvas, keeping the carry's metadata. Runs just before
  // an already-accepted design is re-applied through a view rebuild — otherwise the
  // rebuild would restore the ORIGINAL snapshot and silently undo any nudges the user
  // made after accepting.
  function refreshCarry(){
    if(!carry||!carryApplied) return;
    const meta={ fromTitle:carry.fromTitle, fromColor:carry.fromColor, sameProduct:carry.sameProduct };
    const wasApplied=carryApplied;
    captureCarry(meta.sameProduct);
    if(carry){ carry.fromTitle=meta.fromTitle; carry.fromColor=meta.fromColor; }
    carryApplied=wasApplied;   // captureCarry clears the flag; this is a refresh, not a new carry
  }

  // Re-key the stashed artwork onto whatever views are on screen now.
  function applyCarry(){
    if(!carry) return null;
    const btns=Array.prototype.slice.call(document.querySelectorAll('#viewThumbs [data-src]'));
    if(!btns.length) return null;
    const views=btns.map(function(b,i){ return { src:b.dataset.src, label:(b.textContent||b.title||'').trim().toLowerCase(), i:i }; });
    const used={}; let applied=0; const missed=[];
    carry.views.forEach(function(cv){
      let t=null;
      if(cv.label) t=views.find(function(v){ return v.label===cv.label && !used[v.i]; });
      if(!t && cv.index>=0 && views[cv.index] && !used[cv.index]) t=views[cv.index];   // unlabelled → same position
      if(t){ used[t.i]=1; designs[t.src]=cv.json; applied++; }
      else missed.push(cv.label||('view '+(cv.index+1)));
    });
    if(applied){ setView(currentView||views[0].src); scheduleSave(); }
    return { applied:applied, missed:missed };
  }

  function hideCarryBar(){ const b=document.getElementById('carryBar'); if(b) b.style.display='none'; }
  function showCarryBar(){
    const b=document.getElementById('carryBar'), m=document.getElementById('carryMsg');
    if(!b||!m||!carry) return;
    m.innerHTML='Use the same design as <b>'+_artEsc(carry.fromTitle||'the last garment')+'</b>?';
    b.style.display='flex';
  }

  // Called once the view buttons for a product/color are on screen. buildViews()
  // can run twice (again when the S&S/SanMar lookup resolves) and each run clears
  // the canvas — so once the art is accepted we re-apply on every rebuild.
  function handleCarry(){
    if(!carry){ hideCarryBar(); return; }
    if(carry.sameProduct || carryApplied){
      const r=applyCarry();
      if(r&&r.applied) carryApplied=true;
      hideCarryBar();
      return;
    }
    showCarryBar();
  }

  function initCarryBar(){
    const a=document.getElementById('carryApply'), s=document.getElementById('carrySkip');
    if(a) a.onclick=function(){
      const r=applyCarry();
      hideCarryBar();
      if(r&&r.applied){
        carryApplied=true;
        if(r.missed.length) alert('Brought your design over.\n\nThis garment has no '+r.missed.join(' or ')+' view, so that artwork did not carry — it is still on the previous product.');
      }else{
        alert('Sorry — that design could not be applied to this garment.');
      }
    };
    if(s) s.onclick=function(){ carry=null; carryApplied=false; hideCarryBar(); };
  }

  function bestViews(g){
    if(PREMIUM_MODE) return g.images;
    if(product){
      if(SNS_ENABLED && snsData){
        const sv=snsViews(product.title, product.vendor, g.val);
        if(sv.length) return sv;
      }
      if(SANMAR_ENABLED && sanmarData){
        const sm=sanmarViews(matchStyle(product.title, product.vendor), g.val);
        if(sm.length) return sm;
      }
    }
    return g.images;   // Shopify fallback (unlabeled thumbnails)
  }
  function applyViews(g){
    buildViews(bestViews(g));
    const pending=[];
    if(SNS_ENABLED && !snsData) pending.push(loadSns());
    if(SANMAR_ENABLED && !sanmarData) pending.push(loadSanmar());
    if(!aliasData) pending.push(loadAliases());   // bridges title style-codes to data keys
    if(pending.length){
      Promise.all(pending).then(function(){
        if(selectedColor!==g.val) return;              // user moved on
        buildViews(bestViews(g));
      });
    }
  }

  function buildViews(imgs){
    const wrap=document.getElementById('viewThumbs');
    refreshCarry();      // capture edits made since accepting, while the labels are still in the DOM
    wrap.innerHTML='';
    if(!imgs||!imgs.length){wrap.innerHTML='<span class="vt-label">No images for this color</span>';hideCarryBar();return;}
    const views=imgs.map(it=> (typeof it==='string') ? {label:'',src:it} : it).filter(v=>v&&v.src);
    if(!views.length){wrap.innerHTML='<span class="vt-label">No images for this color</span>';hideCarryBar();return;}
    if(views.every(v=>v.label)){
      const lbl=document.createElement('span');lbl.className='vt-label';lbl.textContent='View:';wrap.appendChild(lbl);
      const seg=document.createElement('div');seg.className='seg view-seg';
      views.forEach(v=>{
        const b=document.createElement('button');b.type='button';b.dataset.src=v.src;b.textContent=v.label;
        b.onclick=()=>setView(v.src);
        seg.appendChild(b);
      });
      wrap.appendChild(seg);
    }else{
      const lbl=document.createElement('span');lbl.className='vt-label';lbl.textContent='Views:';wrap.appendChild(lbl);
      views.forEach(v=>{
        const item=document.createElement('div');item.className='vt-item';
        const b=document.createElement('button');b.className='view-thumb';b.dataset.src=v.src;b.title=v.label||'';
        b.innerHTML=`<img src="${v.src}" alt="${v.label||''}" crossorigin="anonymous">`;
        b.onclick=()=>setView(v.src);
        item.appendChild(b);
        if(v.label){const cap=document.createElement('span');cap.className='vt-cap';cap.textContent=v.label;item.appendChild(cap);}
        wrap.appendChild(item);
      });
    }
    setView(views[0].src);
    handleCarry();   // the buttons now exist, so labels can be matched
  }

  function setView(src){
    saveView();
    currentView=src;
    document.querySelectorAll('#viewThumbs [data-src]').forEach(b=>b.classList.toggle('active',b.dataset.src===src));
    const photo=document.getElementById('productPhoto');
    photo.crossOrigin='anonymous';
    photo.src=src;
    document.getElementById('productStage').classList.add('has-photo');
    canvas.clear(); canvas.backgroundColor='transparent';
    const data=designs[src];
    if(data&&data.objects&&data.objects.length){
      canvas.loadFromJSON(data,()=>{canvas.renderAll();refreshLayers();syncControls();});
    }else{
      canvas.renderAll();refreshLayers();syncControls();
    }
    requestAnimationFrame(layoutStage);  // re-fit once the photo/layout settles
    scheduleSave();
  }
  function saveView(){ if(currentView){ designs[currentView]=canvas.toJSON(['selectable','_bt_name','_bt_curve','_bt_uid']); } }

  /* ============================================================
     UPLOAD
     ============================================================ */
  const drop=document.getElementById('drop'), fileInput=document.getElementById('bt-file');
  drop.onclick=()=>fileInput.click();
  drop.ondragover=e=>{e.preventDefault();drop.classList.add('over');};
  drop.ondragleave=()=>drop.classList.remove('over');
  drop.ondrop=e=>{e.preventDefault();drop.classList.remove('over');if(e.dataTransfer.files[0])handleFile(e.dataTransfer.files[0]);};
  fileInput.onchange=e=>{if(e.target.files[0])handleFile(e.target.files[0]);};
  document.getElementById('stage').addEventListener('dragover',e=>e.preventDefault());
  document.getElementById('stage').addEventListener('drop',e=>{e.preventDefault();if(e.dataTransfer.files[0])handleFile(e.dataTransfer.files[0]);});

  function handleFile(file){
    const reader=new FileReader();
    reader.onload=ev=>{
      const isSvg = file.type==='image/svg+xml';
      const item={ id:'u'+(uploadSeq++), name:file.name||'Artwork', kind:isSvg?'svg':'img', data:ev.target.result };
      uploads.push(item);
      renderUploads();
      showOverlay("I'm making your design print-ready…",1500,()=>placeFromUpload(item,true));
    };
    if(file.type==='image/svg+xml')reader.readAsText(file); else reader.readAsDataURL(file);
  }

  function placeFromUpload(item,fresh){
    if(item.kind==='svg'){
      fabric.loadSVGFromString(item.data,(objs,opts)=>{
        const g=fabric.util.groupSVGElements(objs,opts); placeObject(g,!fresh,item.id);
      });
    }else{
      fabric.Image.fromURL(item.data,img=>placeObject(img,!fresh,item.id),{crossOrigin:'anonymous'});
    }
  }

  function placeObject(obj,keepTab,uid){
    const max=Math.min(canvas.width*0.6,canvas.height*0.6);
    const s=Math.min(max/obj.width,max/obj.height,1);
    obj.set({left:canvas.width/2,top:canvas.height/2,originX:'center',originY:'center',scaleX:s,scaleY:s});
    obj._bt_name = obj.type==='image' ? 'Image' : 'Graphic';
    // Identity that survives re-serialisation: the same artwork is re-encoded to a
    // DIFFERENT data URL when the shopper switches garment colour, so src is not a
    // stable answer to 'is this the same file'. The upload id is.
    if(uid) obj._bt_uid = uid;
    canvas.add(obj); canvas.setActiveObject(obj); canvas.renderAll();
    refreshLayers(); if(!keepTab) goTab('adjust');
  }

  // The ✂ crop button's CSS used to live only inside cropModal() (injected on first
  // crop) — so the button was unstyled/invisible until clicked. Inject it up front,
  // once, so ✂ is visible from the first render (mirrors the ✕ delete button, top-left).
  function ensureUploadCss(){
    if(document.getElementById('bt-upload-css')) return;
    var st=document.createElement('style'); st.id='bt-upload-css';
    st.textContent='.upload-cell{position:relative}'
      +'.upload-cell .ucell-crop{position:absolute;top:2px;left:2px;border:none;background:rgba(255,255,255,.92);border-radius:50%;width:20px;height:20px;line-height:20px;text-align:center;font-size:11px;cursor:pointer;padding:0;z-index:3}';
    document.head.appendChild(st);
  }
  function renderUploads(){
    ensureUploadCss();
    const grid=document.getElementById('uploadGrid');
    const wrap=document.getElementById('uploadLib');
    grid.innerHTML='';
    wrap.style.display=uploads.length?'block':'none';
    uploads.forEach(item=>{
      const thumb = item.kind==='svg' ? 'data:image/svg+xml;utf8,'+encodeURIComponent(item.data) : item.data;
      const cell=document.createElement('div');cell.className='upload-cell';cell.title=item.name;
      cell.innerHTML=`<img src="${thumb}" alt="${item.name}"><button class="ucell-crop" title="Crop this image">✂</button><button class="ucell-del" title="Remove from uploads">✕</button>`;
      cell.querySelector('img').onclick=()=>placeFromUpload(item,false);
      cell.querySelector('.ucell-crop').onclick=ev=>{ev.stopPropagation();openCropTool(item);};
      cell.querySelector('.ucell-del').onclick=ev=>{ev.stopPropagation();uploads=uploads.filter(u=>u!==item);renderUploads();};
      grid.appendChild(cell);
    });
    scheduleSave();
  }

  // ---- Optional crop as an edit on an uploaded image ------------------------
  // Drag-to-crop modal (self-contained; no deps). Replaces the upload's image with the
  // cropped region as a PNG (keeps transparency). Works on raster + rasterizes SVG.
  function openCropTool(item){
    var src = item.kind==='svg' ? 'data:image/svg+xml;utf8,'+encodeURIComponent(item.data) : item.data;
    var im=new Image();
    im.onload=function(){ cropModal(item, im); };
    im.onerror=function(){ alert('Sorry — couldn’t load this image to crop.'); };
    im.src=src;
  }
  function cropModal(item, im, onApply){
    var NW=im.naturalWidth||im.width, NH=im.naturalHeight||im.height;
    if(!NW||!NH){ alert('This image has no fixed size to crop.'); return; }
    if(!document.getElementById('bt-crop-css')){
      var st=document.createElement('style'); st.id='bt-crop-css';
      st.textContent='.bt-crop-ov{position:fixed;inset:0;background:rgba(15,23,42,.72);z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px}'
        +'.bt-crop-card{background:#fff;border-radius:14px;padding:16px;max-width:95vw;box-shadow:0 20px 60px rgba(0,0,0,.35)}'
        +'.bt-crop-title{font-size:13.5px;font-weight:700;margin-bottom:10px;color:#0f172a}'
        +'.bt-crop-stage{display:flex;justify-content:center;background:#f4f6f8;border-radius:8px;padding:10px}'
        +'.bt-crop-cv{touch-action:none;cursor:crosshair;max-width:100%;border-radius:4px}'
        +'.bt-crop-btns{display:flex;align-items:center;gap:8px;margin-top:12px}'
        +'.bt-crop-btns button{font-size:13px;padding:8px 16px;border-radius:8px;border:1px solid #cbd5e1;background:#fff;cursor:pointer}'
        +'.bt-crop-apply{background:#0d3b66!important;color:#fff!important;border-color:#0d3b66!important;font-weight:700}'
        +'.upload-cell .ucell-crop{position:absolute;top:2px;left:2px;border:none;background:rgba(255,255,255,.92);border-radius:50%;width:20px;height:20px;line-height:20px;text-align:center;font-size:11px;cursor:pointer;padding:0}';
      document.head.appendChild(st);
    }
    var maxW=Math.min(560,(window.innerWidth||600)-60), maxH=(window.innerHeight||700)-230;
    var scale=Math.min(maxW/NW, maxH/NH, 1); if(!(scale>0)) scale=1;
    var DW=Math.max(1,Math.round(NW*scale)), DH=Math.max(1,Math.round(NH*scale));
    var ov=document.createElement('div'); ov.className='bt-crop-ov';
    ov.innerHTML='<div class="bt-crop-card"><div class="bt-crop-title">Crop image — drag the box, or drag a new one; drag corners to resize</div>'
      +'<div class="bt-crop-stage"><canvas class="bt-crop-cv"></canvas></div>'
      +'<div class="bt-crop-btns"><button class="bt-crop-reset">Reset</button><span style="flex:1"></span>'
      +'<button class="bt-crop-cancel">Cancel</button><button class="bt-crop-apply">Apply crop</button></div></div>';
    document.body.appendChild(ov);
    var cv=ov.querySelector('.bt-crop-cv'); cv.width=DW; cv.height=DH; cv.style.width=DW+'px'; cv.style.height=DH+'px';
    var ctx=cv.getContext('2d');
    var rect={x:0,y:0,w:DW,h:DH};
    function handlePts(){ var x=rect.x,y=rect.y,w=rect.w,h=rect.h; return [
      {k:'nw',x:x,y:y},{k:'n',x:x+w/2,y:y},{k:'ne',x:x+w,y:y},{k:'e',x:x+w,y:y+h/2},
      {k:'se',x:x+w,y:y+h},{k:'s',x:x+w/2,y:y+h},{k:'sw',x:x,y:y+h},{k:'w',x:x,y:y+h/2}]; }
    function draw(){
      ctx.clearRect(0,0,DW,DH); ctx.drawImage(im,0,0,DW,DH);
      ctx.save(); ctx.fillStyle='rgba(0,0,0,.55)'; ctx.beginPath();
      ctx.rect(0,0,DW,DH); ctx.rect(rect.x,rect.y,rect.w,rect.h); ctx.fill('evenodd'); ctx.restore();
      // Rule-of-thirds guides inside the crop box
      ctx.strokeStyle='rgba(255,255,255,.4)'; ctx.lineWidth=1;
      for(var gi=1;gi<3;gi++){ var gx=rect.x+rect.w*gi/3, gy=rect.y+rect.h*gi/3;
        ctx.beginPath();ctx.moveTo(gx,rect.y);ctx.lineTo(gx,rect.y+rect.h);ctx.stroke();
        ctx.beginPath();ctx.moveTo(rect.x,gy);ctx.lineTo(rect.x+rect.w,gy);ctx.stroke(); }
      // High-contrast border: dark backing + bright dashed accent on top (visible on any image)
      ctx.setLineDash([]); ctx.lineWidth=3; ctx.strokeStyle='rgba(0,0,0,.65)'; ctx.strokeRect(rect.x+.5,rect.y+.5,rect.w,rect.h);
      ctx.lineWidth=2; ctx.strokeStyle='#ff4a23'; ctx.setLineDash([7,5]); ctx.strokeRect(rect.x+.5,rect.y+.5,rect.w,rect.h); ctx.setLineDash([]);
      // Chunky handles: accent square with a white ring
      handlePts().forEach(function(p){ ctx.fillStyle='#fff'; ctx.fillRect(p.x-6,p.y-6,12,12);
        ctx.fillStyle='#ff4a23'; ctx.fillRect(p.x-4,p.y-4,8,8); });
    }
    function pos(ev){ var r=cv.getBoundingClientRect(); var t=ev.touches&&ev.touches[0]?ev.touches[0]:ev; return {x:t.clientX-r.left, y:t.clientY-r.top}; }
    function hitHandle(p){ var pts=handlePts(); for(var i=0;i<pts.length;i++){ if(Math.abs(p.x-pts[i].x)<=8&&Math.abs(p.y-pts[i].y)<=8) return pts[i].k; } return null; }
    function inRect(p){ return p.x>=rect.x&&p.x<=rect.x+rect.w&&p.y>=rect.y&&p.y<=rect.y+rect.h; }
    var drag=null;
    function down(ev){ ev.preventDefault(); var p=pos(ev); var h=hitHandle(p);
      if(h) drag={mode:'resize',k:h}; else if(inRect(p)) drag={mode:'move',ox:p.x-rect.x,oy:p.y-rect.y};
      else { drag={mode:'new',sx:p.x,sy:p.y}; rect={x:p.x,y:p.y,w:0,h:0}; draw(); } }
    function move(ev){ if(!drag) return; ev.preventDefault(); var p=pos(ev);
      p.x=Math.max(0,Math.min(DW,p.x)); p.y=Math.max(0,Math.min(DH,p.y));
      if(drag.mode==='move'){ rect.x=Math.max(0,Math.min(DW-rect.w,p.x-drag.ox)); rect.y=Math.max(0,Math.min(DH-rect.h,p.y-drag.oy)); }
      else if(drag.mode==='new'){ rect.x=Math.min(drag.sx,p.x); rect.y=Math.min(drag.sy,p.y); rect.w=Math.abs(p.x-drag.sx); rect.h=Math.abs(p.y-drag.sy); }
      else { var x2=rect.x+rect.w,y2=rect.y+rect.h;
        if(drag.k.indexOf('w')>=0) rect.x=Math.min(p.x,x2-8);
        if(drag.k.indexOf('n')>=0) rect.y=Math.min(p.y,y2-8);
        if(drag.k.indexOf('e')>=0) x2=Math.max(p.x,rect.x+8);
        if(drag.k.indexOf('s')>=0) y2=Math.max(p.y,rect.y+8);
        rect.w=x2-rect.x; rect.h=y2-rect.y; }
      draw(); }
    function up(){ drag=null; }
    cv.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
    cv.addEventListener('touchstart',down,{passive:false}); window.addEventListener('touchmove',move,{passive:false}); window.addEventListener('touchend',up);
    function cleanup(){ window.removeEventListener('mousemove',move); window.removeEventListener('mouseup',up); window.removeEventListener('touchmove',move); window.removeEventListener('touchend',up); ov.remove(); }
    ov.addEventListener('mousedown',function(e){ if(e.target===ov) cleanup(); });
    ov.querySelector('.bt-crop-cancel').onclick=cleanup;
    ov.querySelector('.bt-crop-reset').onclick=function(){ rect={x:0,y:0,w:DW,h:DH}; draw(); };
    ov.querySelector('.bt-crop-apply').onclick=function(){
      if(rect.w<4||rect.h<4){ cleanup(); return; }
      var sx=Math.round(rect.x/scale), sy=Math.round(rect.y/scale), sw=Math.round(rect.w/scale), sh=Math.round(rect.h/scale);
      sx=Math.max(0,Math.min(NW-1,sx)); sy=Math.max(0,Math.min(NH-1,sy));
      sw=Math.max(1,Math.min(NW-sx,sw)); sh=Math.max(1,Math.min(NH-sy,sh));
      var out=document.createElement('canvas'); out.width=sw; out.height=sh;
      out.getContext('2d').drawImage(im, sx,sy,sw,sh, 0,0, sw,sh);
      var cropped; try{ cropped=out.toDataURL('image/png'); }
      catch(e){ alert('Could not crop this image ('+(e.message||e)+').'); cleanup(); return; }
      if(onApply){ cleanup(); onApply(cropped); return; }   // Adjust-tab path: write back to the canvas object
      item.data=cropped; item.kind='img';
      if(item.name && !/\(cropped\)/i.test(item.name)) item.name=item.name.replace(/\.[a-z0-9]{2,4}$/i,'')+' (cropped).png';
      cleanup(); renderUploads();
    };
    draw();
  }

  // Crop the currently-selected canvas image (Adjust tab). Same modal as the uploads
  // tray, but writes the cropped result back onto the fabric object (via replaceArt).
  function openCropFromAdjust(){
    var obj=canvas.getActiveObject();
    if(obj && obj.type==='activeSelection'){ obj=obj.getObjects().find(function(o){return o.type==='image';})||null; }
    if(!obj || obj.type!=='image'){ var imgs=canvas.getObjects().filter(function(o){return o.type==='image';}); if(imgs.length===1) obj=imgs[0]; }
    if(!obj || obj.type!=='image'){ alert('Crop works on an uploaded image (PNG/JPG). Click the image on the garment to select it first.'); return; }
    canvas.setActiveObject(obj);
    // Draw straight from the fabric element (already loaded + drawable) — no reload.
    var el=obj._element || obj._originalElement;
    if(!el){ alert('This element can’t be cropped.'); return; }
    var NW=el.naturalWidth||el.width, NH=el.naturalHeight||el.height;
    if(!NW||!NH){ alert('This image has no fixed size to crop.'); return; }
    cropModal(null, el, function(dataUrl){ replaceArt(obj, dataUrl, function(ni){ canvas.setActiveObject(ni); canvas.renderAll(); }); });
  }

  // AI Logo Designer — brief -> Worker (Haiku prompt + Recraft image) -> options
  // land in "Your uploads" and reuse the existing click-to-place / layers / save.
  // Cost-gated server-side (per-visitor + global daily caps) + invisible Turnstile.
  (function(){
    const btn=document.getElementById('aiGenBtn'); if(!btn) return;
    const input=document.getElementById('aiPrompt');
    const status=document.getElementById('aiStatus');
    function setStatus(msg){ status.textContent=msg||''; status.style.display=msg?'block':'none'; }

    // Invisible Turnstile — mint a fresh single-use token per generate.
    let tsWid=null, tsResolve=null;
    function tsInit(){
      if(!TURNSTILE_SITE_KEY) return;
      const el=document.getElementById('lgTs'); if(!el) return;
      if(window.turnstile){
        if(tsWid===null){ try{ tsWid=window.turnstile.render(el,{sitekey:TURNSTILE_SITE_KEY,execution:'execute',appearance:'interaction-only',
          callback:t=>{ if(tsResolve){ const r=tsResolve; tsResolve=null; r(t||''); } },
          'error-callback':()=>{ if(tsResolve){ const r=tsResolve; tsResolve=null; r(''); } }}); }catch(e){} }
      }else{
        const s=document.createElement('script'); s.src='https://challenges.cloudflare.com/turnstile/v0/api.js'; s.async=true; s.defer=true; s.onload=tsInit; document.head.appendChild(s);
      }
    }
    function tsToken(){
      return new Promise(resolve=>{
        if(!TURNSTILE_SITE_KEY){ resolve(''); return; }
        if(!window.turnstile || tsWid===null){ tsInit(); resolve(''); return; }
        tsResolve=resolve;
        try{ window.turnstile.reset(tsWid); window.turnstile.execute(tsWid); }catch(e){ tsResolve=null; resolve(''); }
        setTimeout(()=>{ if(tsResolve){ const r=tsResolve; tsResolve=null; r(''); } },9000);
      });
    }
    tsInit();

    async function generate(){
      const brief=(input.value||'').trim();
      if(!brief){ input.focus(); return; }
      if(!DESIGN_API_BASE){ setStatus("AI generation isn't set up yet."); return; }
      btn.disabled=true; setStatus('Designing your logo… this takes a few seconds.');
      try{
        const turnstileToken=await tsToken();
        const res=await fetch(LOGO_GEN_API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({brief,count:1,turnstileToken})});
        const data=await res.json().catch(()=>({}));
        if(!res.ok){ setStatus(data.error||"Couldn't generate that — please try again."); return; }
        const imgs=Array.isArray(data.images)?data.images:[];
        if(!imgs.length){ setStatus('No image came back — try rephrasing.'); return; }
        imgs.forEach(d=>uploads.push({ id:'u'+(uploadSeq++), name:'AI logo', kind:'img', data:d }));
        renderUploads();
        const left=(typeof data.remaining==='number')?(' '+data.remaining+' free left today.'):'';
        setStatus('Added to "Your uploads" below — click it to place it.'+left);
      }catch(e){ setStatus('Something went wrong — please try again.'); }
      finally{ btn.disabled=false; }
    }
    btn.onclick=generate;
    input.addEventListener('keydown',e=>{ if((e.metaKey||e.ctrlKey)&&e.key==='Enter') generate(); });
  })();

  var adjCropBtn=document.getElementById('adjCrop'); if(adjCropBtn) adjCropBtn.onclick=openCropFromAdjust;
  document.getElementById('rmWhite').onclick=()=>removeBg([255,255,255]);
  document.getElementById('rmBlack').onclick=()=>removeBg([0,0,0]);
  document.getElementById('rmAuto').onclick=()=>removeBg(null);
  const tol=document.getElementById('tol');
  tol.oninput=()=>document.getElementById('tolVal').textContent=tol.value;

  function removeBg(target){
    if(typeof spotMode!=='undefined' && spotMode) exitSpotMode();
    if(typeof brushMode!=='undefined' && brushMode) exitBrushMode(true);
    let obj=canvas.getActiveObject();
    if(obj && obj.type==='activeSelection'){ obj=obj.getObjects().find(o=>o.type==='image')||null; }
    if(!obj || obj.type!=='image'){
      const imgs=canvas.getObjects().filter(o=>o.type==='image');
      if(imgs.length===1) obj=imgs[0];
    }
    if(!obj || obj.type!=='image'){
      alert('Background removal works on an uploaded photo (PNG/JPG). Click the image on the garment to select it first.\n\n(It can’t run on vector/SVG logos.)');
      return;
    }
    canvas.setActiveObject(obj);
    showOverlay("I'm making your background removable…",1400,()=>{
      const el=obj._element, w=el.naturalWidth||el.width, h=el.naturalHeight||el.height;
      const tc=document.createElement('canvas');tc.width=w;tc.height=h;
      const ctx=tc.getContext('2d');ctx.drawImage(el,0,0,w,h);
      const id=ctx.getImageData(0,0,w,h),d=id.data;
      let t=target;
      if(!t){
        var cs=[[0,0],[w-1,0],[0,h-1],[w-1,h-1]].map(function(p){var o=(p[1]*w+p[0])*4;return [d[o],d[o+1],d[o+2]];});
        var best=cs[0],bestSum=Infinity;
        cs.forEach(function(a){var s=0;cs.forEach(function(b){s+=Math.sqrt((a[0]-b[0])**2+(a[1]-b[1])**2+(a[2]-b[2])**2);});if(s<bestSum){bestSum=s;best=a;}});
        t=best;
      }
      const tolv=parseInt(tol.value);
      for(let i=0;i<d.length;i+=4){
        const dist=Math.sqrt((d[i]-t[0])**2+(d[i+1]-t[1])**2+(d[i+2]-t[2])**2);
        if(dist<=tolv) d[i+3]=0;
        else if(dist<=tolv+22) d[i+3]=Math.round(d[i+3]*(dist-tolv)/22);
      }
      ctx.putImageData(id,0,0);
      fabric.Image.fromURL(tc.toDataURL('image/png'),newImg=>{
        newImg.set({left:obj.left,top:obj.top,originX:obj.originX,originY:obj.originY,
          scaleX:obj.scaleX,scaleY:obj.scaleY,angle:obj.angle,opacity:obj.opacity});
        newImg._bt_name=obj._bt_name||'Image';
        if(obj._bt_uid) newImg._bt_uid=obj._bt_uid;   // crop rebuilds the image; keep its identity
        const idx=canvas.getObjects().indexOf(obj);
        canvas.remove(obj);canvas.add(newImg);newImg.moveTo(idx);
        canvas.setActiveObject(newImg);canvas.renderAll();refreshLayers();
      });
    });
  }

  function pickArtImage(){
    let obj=canvas.getActiveObject();
    if(obj && obj.type==='activeSelection'){ obj=obj.getObjects().find(o=>o.type==='image')||null; }
    if(!obj || obj.type!=='image'){ const imgs=canvas.getObjects().filter(o=>o.type==='image'); if(imgs.length===1) obj=imgs[0]; }
    return (obj && obj.type==='image') ? obj : null;
  }
  function replaceArt(obj, dataUrl, cb){
    fabric.Image.fromURL(dataUrl, function(newImg){
      newImg.set({left:obj.left,top:obj.top,originX:obj.originX,originY:obj.originY,
        scaleX:obj.scaleX,scaleY:obj.scaleY,angle:obj.angle,opacity:obj.opacity,flipX:obj.flipX,flipY:obj.flipY});
      newImg._bt_name=obj._bt_name||'Image';
      if(obj._bt_uid) newImg._bt_uid=obj._bt_uid;   // same identity, new pixels
      const idx=canvas.getObjects().indexOf(obj);
      canvas.remove(obj); canvas.add(newImg); newImg.moveTo(idx);
      canvas.renderAll(); refreshLayers();
      if(cb) cb(newImg);
    });
  }
  var spotMode=false, spotTarget=null, spotBanner=null;
  function showSpotBanner(on, text){
    if(on){
      if(!spotBanner){
        spotBanner=document.createElement('div');
        spotBanner.style.cssText='position:absolute;top:10px;left:50%;transform:translateX(-50%);z-index:25;background:var(--accent,#ff4a23);color:#fff;font-size:12px;font-weight:600;padding:7px 13px;border-radius:999px;box-shadow:0 4px 14px rgba(0,0,0,.25);pointer-events:none;white-space:nowrap';
        var stage=document.getElementById('stage'); if(stage) stage.appendChild(spotBanner);
      }
      spotBanner.textContent=text||'Editing — Esc or “Exit” to finish';
      spotBanner.style.display='block';
    } else if(spotBanner){ spotBanner.style.display='none'; }
  }
  function imgPixelAt(obj, e){
    var pt=canvas.getPointer(e);
    var lp=obj.toLocalPoint(new fabric.Point(pt.x, pt.y), 'left', 'top');
    var el=obj._element, ew=el.naturalWidth||el.width, eh=el.naturalHeight||el.height;
    var px=Math.round(lp.x/(obj.scaleX||1)*ew/(obj.width||ew));
    var py=Math.round(lp.y/(obj.scaleY||1)*eh/(obj.height||eh));
    if(obj.flipX) px=ew-1-px;
    if(obj.flipY) py=eh-1-py;
    if(px<0||py<0||px>=ew||py>=eh) return null;
    return {px:px, py:py, w:ew, h:eh};
  }
  function exitSpotMode(){
    spotMode=false; spotTarget=null;
    var b=document.getElementById('rmSpot'); if(b){ b.classList.remove('on'); b.textContent='Spot remove'; }
    canvas.skipTargetFind=false; canvas.defaultCursor='default'; canvas.selection=true; canvas.renderAll();
    showSpotBanner(false);
  }
  var rmSpotBtn=document.getElementById('rmSpot');
  if(rmSpotBtn) rmSpotBtn.onclick=function(){
    if(spotMode){ exitSpotMode(); return; }
    if(typeof brushMode!=='undefined' && brushMode) exitBrushMode(true);
    var obj=pickArtImage();
    if(!obj){ alert('Spot removal works on an uploaded photo (PNG/JPG). Add or click your image first.'); return; }
    spotMode=true; spotTarget=obj;
    this.classList.add('on'); this.textContent='✕ Exit spot remove';
    canvas.skipTargetFind=true; canvas.defaultCursor='crosshair'; canvas.selection=false;
    canvas.discardActiveObject(); canvas.renderAll();
    showSpotBanner(true, '✂︎ Spot-erase — click areas to erase · Esc to finish');
  };
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && spotMode) exitSpotMode(); });
  canvas.on('mouse:down', function(opt){
    if(!spotMode || !spotTarget || !spotTarget._element) return;
    var p=imgPixelAt(spotTarget, opt.e); if(!p) return;
    floodRemove(spotTarget, p.px, p.py);
  });
  function floodRemove(obj, sx, sy){
    var el=obj._element, w=el.naturalWidth||el.width, h=el.naturalHeight||el.height;
    var tc=document.createElement('canvas'); tc.width=w; tc.height=h;
    var ctx=tc.getContext('2d'); ctx.drawImage(el,0,0,w,h);
    var id=ctx.getImageData(0,0,w,h), d=id.data, si=(sy*w+sx)*4;
    if(d[si+3]===0) return;                       // clicked an already-transparent spot
    var sr=d[si],sg=d[si+1],sb=d[si+2];
    var tol=parseInt(document.getElementById('tol').value,10)||60, tol2=tol*tol;
    var seen=new Uint8Array(w*h), stack=[sy*w+sx]; seen[sy*w+sx]=1;
    while(stack.length){
      var p=stack.pop(), o=p*4;
      var dr=d[o]-sr, dg=d[o+1]-sg, db=d[o+2]-sb;
      if(dr*dr+dg*dg+db*db>tol2) continue;        // hit the edge / a different colour — boundary
      d[o+3]=0;
      var x=p%w, y=(p-x)/w;
      if(x>0     && !seen[p-1]){seen[p-1]=1;stack.push(p-1);}
      if(x<w-1   && !seen[p+1]){seen[p+1]=1;stack.push(p+1);}
      if(y>0     && !seen[p-w]){seen[p-w]=1;stack.push(p-w);}
      if(y<h-1   && !seen[p+w]){seen[p+w]=1;stack.push(p+w);}
    }
    ctx.putImageData(id,0,0);
    replaceArt(obj, tc.toDataURL('image/png'), function(newImg){ spotTarget=newImg; });
  }

  var brushMode=false, brushObj=null, brushCv=null, brushCtx=null, brushPainting=false, brushLast=null;
  var brushSlider=document.getElementById('brushSize');
  if(brushSlider) brushSlider.oninput=function(){ var v=document.getElementById('brushVal'); if(v) v.textContent=this.value; };
  function exitBrushMode(commit){
    if(brushMode && brushObj && brushCv && commit) replaceArt(brushObj, brushCv.toDataURL('image/png'));
    if(brushObj){ brushObj.objectCaching=true; }
    brushMode=false; brushObj=null; brushCv=null; brushCtx=null; brushPainting=false; brushLast=null;
    var b=document.getElementById('rmBrush'); if(b){ b.classList.remove('on'); b.textContent='Brush erase'; }
    canvas.skipTargetFind=false; canvas.defaultCursor='default'; canvas.selection=true; canvas.renderAll();
    showSpotBanner(false);
  }
  var rmBrushBtn=document.getElementById('rmBrush');
  if(rmBrushBtn) rmBrushBtn.onclick=function(){
    if(brushMode){ exitBrushMode(true); return; }
    if(spotMode) exitSpotMode();
    var obj=pickArtImage();
    if(!obj){ alert('Brush erase works on an uploaded photo (PNG/JPG). Add or click your image first.'); return; }
    var el=obj._element, w=el.naturalWidth||el.width, h=el.naturalHeight||el.height;
    brushCv=document.createElement('canvas'); brushCv.width=w; brushCv.height=h;
    brushCtx=brushCv.getContext('2d'); brushCtx.drawImage(el,0,0,w,h);
    obj.setElement(brushCv); obj.objectCaching=false; obj.dirty=true;   // paint live on this canvas, no cache
    brushObj=obj; brushMode=true;
    this.classList.add('on'); this.textContent='✕ Done erasing';
    canvas.skipTargetFind=true; canvas.defaultCursor='crosshair'; canvas.selection=false;
    canvas.discardActiveObject(); canvas.renderAll();
    showSpotBanner(true, '🖌 Brush-erase — drag to wipe background · Esc to finish');
  };
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && brushMode) exitBrushMode(true); });
  function brushStroke(e){
    if(!brushObj || !brushCtx) return;
    var p=imgPixelAt(brushObj, e); if(!p) { brushLast=null; return; }
    var sz=parseInt((document.getElementById('brushSize')||{}).value,10)||24;
    var r=Math.max(2, sz/(brushObj.scaleX||1));     // brush radius in image pixels (consistent on-screen size)
    brushCtx.save(); brushCtx.globalCompositeOperation='destination-out';
    brushCtx.fillStyle='#000'; brushCtx.strokeStyle='#000'; brushCtx.lineCap='round'; brushCtx.lineJoin='round'; brushCtx.lineWidth=r*2;
    if(brushLast){ brushCtx.beginPath(); brushCtx.moveTo(brushLast.px, brushLast.py); brushCtx.lineTo(p.px, p.py); brushCtx.stroke(); }
    brushCtx.beginPath(); brushCtx.arc(p.px, p.py, r, 0, Math.PI*2); brushCtx.fill();
    brushCtx.restore();
    brushLast=p; brushObj.dirty=true; canvas.requestRenderAll();
  }
  canvas.on('mouse:down', function(opt){ if(brushMode){ brushPainting=true; brushLast=null; brushStroke(opt.e); } });
  canvas.on('mouse:move', function(opt){ if(brushMode && brushPainting) brushStroke(opt.e); });
  canvas.on('mouse:up',   function(){ if(brushMode){ brushPainting=false; brushLast=null; } });
  var bgGroup=document.getElementById('bgRemovalGroup');
  if(bgGroup) bgGroup.addEventListener('toggle', function(){
    if(!this.open){ if(spotMode) exitSpotMode(); if(brushMode) exitBrushMode(true); }
  });

  /* ============================================================
     TEXT
     ============================================================ */
  document.getElementById('addText').onclick=()=>{
    const t=new fabric.Textbox('Your text',{
      left:canvas.width/2,top:canvas.height/2,originX:'center',originY:'center',
      width:200,fontSize:42,fontFamily:'Anton',fill:'#181410',textAlign:'center',editable:true
    });
    t._bt_name='Text';
    canvas.add(t);canvas.setActiveObject(t);canvas.renderAll();
    syncControls();refreshLayers();
  };
  document.getElementById('txtContent').oninput=e=>applyText('text',e.target.value);
  const txtHexEl=document.getElementById('txtHex');
  document.getElementById('txtColor').oninput=e=>{applyText('fill',e.target.value);txtHexEl.value=e.target.value.toUpperCase();};
  txtHexEl.oninput=e=>{let h=e.target.value.trim();if(h[0]!=='#')h='#'+h;if(!/^#[0-9a-fA-F]{6}$/.test(h))return;document.getElementById('txtColor').value=h;applyText('fill',h);};
  document.getElementById('txtSize').onchange=e=>applyText('fontSize',parseInt(e.target.value)||42);
  document.getElementById('txtSpace').oninput=e=>{document.getElementById('spaceVal').textContent=e.target.value;applyText('charSpacing',parseInt(e.target.value));};
  document.getElementById('txtCurve').oninput=e=>{const v=parseInt(e.target.value)||0;document.getElementById('curveVal').textContent=v+'°';applyCurve(canvas.getActiveObject(),v);};
  document.getElementById('txtSkewX').oninput=e=>applyText('skewX',parseInt(e.target.value)||0);
  document.getElementById('txtSkewY').oninput=e=>applyText('skewY',parseInt(e.target.value)||0);
  document.querySelectorAll('#txtAlign button').forEach(b=>b.onclick=()=>{
    document.querySelectorAll('#txtAlign button').forEach(x=>x.classList.remove('active'));
    b.classList.add('active');applyText('textAlign',b.dataset.a);
  });
  document.getElementById('tBold').onclick=function(){toggleStyle(this,'fontWeight','bold','normal');};
  document.getElementById('tItalic').onclick=function(){toggleStyle(this,'fontStyle','italic','normal');};
  document.getElementById('tUnder').onclick=function(){const o=canvas.getActiveObject();if(!o)return;const v=!o.underline;o.set('underline',v);this.classList.toggle('on',v);canvas.renderAll();};
  function toggleStyle(btn,prop,on,off){const o=canvas.getActiveObject();if(!o)return;const v=o[prop]===on?off:on;o.set(prop,v);btn.classList.toggle('on',v===on);canvas.renderAll();}
  function applyText(prop,val){const o=canvas.getActiveObject();if(!o||o.type!=='textbox')return;o.set(prop,val);if((prop==='text'||prop==='fontSize'||prop==='charSpacing')&&o._bt_curve)applyCurve(o,o._bt_curve);canvas.renderAll();refreshLayers();}

  function measureTextWidth(o){
    try{
      const ctx=canvas.getContext();
      ctx.save();
      ctx.font=`${o.fontStyle||'normal'} ${o.fontWeight||'normal'} ${o.fontSize}px ${o.fontFamily||'sans-serif'}`;
      let w=ctx.measureText(o.text||'').width;
      if(o.charSpacing){ w += (o.text||'').length * o.fontSize * (o.charSpacing/1000); }
      ctx.restore();
      return w;
    }catch(e){ return ((o.text||'').length)*(o.fontSize||42)*0.55; }
  }

  function applyCurve(o,amount){
    if(!o||o.type!=='textbox')return;
    o._bt_curve=amount;
    try{
      if(!amount){ o.set('path',null); o.set('pathStartOffset',0); o.dirty=true; o.setCoords(); canvas.requestRenderAll(); return; }
      const w=Math.max(measureTextWidth(o),1);
      const rad=Math.abs(amount)*Math.PI/180;
      const R=Math.max(w/Math.max(rad,0.01),o.fontSize||10);
      const half=Math.min(rad,Math.PI*1.999)/2;
      const up=amount>0;
      const sx=-R*Math.sin(half), ex=R*Math.sin(half);
      const sag=R*(1-Math.cos(half));
      const sy=up?sag:-sag, ey=up?sag:-sag;
      const large=rad>Math.PI?1:0, sweep=up?1:0;
      const d=`M ${sx.toFixed(2)} ${sy.toFixed(2)} A ${R.toFixed(2)} ${R.toFixed(2)} 0 ${large} ${sweep} ${ex.toFixed(2)} ${ey.toFixed(2)}`;
      const path=new fabric.Path(d,{fill:'',stroke:''});
      o.set('path',path); o.set('pathStartOffset',0); o.set('pathAlign','center');
      o.dirty=true; o.setCoords(); canvas.requestRenderAll();
    }catch(err){ console.error('[BulkThreads] curve failed',err); }
  }

  const pal=document.getElementById('txtPal');
  swatchPal.forEach(h=>{const s=document.createElement('span');s.style.background=h;s.onclick=()=>{document.getElementById('txtColor').value=h;document.getElementById('txtHex').value=h.toUpperCase();applyText('fill',h);};pal.appendChild(s);});

  const fg=document.getElementById('fontGrid');
  fonts.forEach(f=>{const d=document.createElement('div');d.className='font-chip';d.style.fontFamily=`'${f}'`;d.textContent='Aa '+f.split(' ')[0];d.dataset.font=f;
    d.onclick=()=>{document.querySelectorAll('.font-chip').forEach(x=>x.classList.remove('active'));d.classList.add('active');applyText('fontFamily',f);};fg.appendChild(d);});
  document.getElementById('fontSearch').oninput=e=>{
    const q=e.target.value.trim().toLowerCase();
    document.querySelectorAll('#fontGrid .font-chip').forEach(ch=>{ch.style.display=ch.dataset.font.toLowerCase().includes(q)?'':'none';});
  };

  /* ============================================================
     ADJUST
     ============================================================ */
  const rot=document.getElementById('rot'),scaleS=document.getElementById('scale'),op=document.getElementById('op');
  rot.oninput=()=>{const o=canvas.getActiveObject();if(!o)return;o.rotate(parseInt(rot.value));document.getElementById('rotVal').textContent=rot.value+'°';canvas.renderAll();};
  scaleS.oninput=()=>{const o=canvas.getActiveObject();if(!o)return;if(!o._bt_baseScale)o._bt_baseScale=o.scaleX;const f=parseInt(scaleS.value)/100;o.scale(o._bt_baseScale*f);document.getElementById('scaleVal').textContent=scaleS.value+'%';canvas.renderAll();checkDpi();};
  op.oninput=()=>{const o=canvas.getActiveObject();if(!o)return;o.set('opacity',parseInt(op.value)/100);document.getElementById('opVal').textContent=op.value+'%';canvas.renderAll();};
  document.getElementById('flipH').onclick=()=>{const o=canvas.getActiveObject();if(o){o.set('flipX',!o.flipX);canvas.renderAll();}};
  document.getElementById('flipV').onclick=()=>{const o=canvas.getActiveObject();if(o){o.set('flipY',!o.flipY);canvas.renderAll();}};
  document.getElementById('centerH').onclick=()=>{const o=canvas.getActiveObject();if(o){o.centerH();o.setCoords();canvas.renderAll();}};
  document.getElementById('centerV').onclick=()=>{const o=canvas.getActiveObject();if(o){o.centerV();o.setCoords();canvas.renderAll();}};
  document.getElementById('fwd').onclick=()=>{const o=canvas.getActiveObject();if(o){o.bringForward();canvas.renderAll();refreshLayers();}};
  document.getElementById('bwd').onclick=()=>{const o=canvas.getActiveObject();if(o){o.sendBackwards();canvas.renderAll();refreshLayers();}};
  document.getElementById('dupe').onclick=dupe;
  document.getElementById('del').onclick=delSel;
  function dupe(){const o=canvas.getActiveObject();if(!o)return;o.clone(c=>{c.set({left:o.left+16,top:o.top+16});c._bt_name=o._bt_name;c._bt_baseScale=null;canvas.add(c);canvas.setActiveObject(c);canvas.renderAll();refreshLayers();});}
  function delSel(){const o=canvas.getActiveObject();if(o){canvas.remove(o);canvas.discardActiveObject();canvas.renderAll();refreshLayers();syncControls();}}

  document.addEventListener('keydown',e=>{
    const t=e.target;
    if(t && (t.tagName==='INPUT'||t.tagName==='TEXTAREA'||t.tagName==='SELECT'||t.isContentEditable)) return;
    if((e.key==='Delete'||e.key==='Backspace')){
      const o=canvas.getActiveObject();
      if(o&&!(o.type==='textbox'&&o.isEditing)){e.preventDefault();delSel();}
    }
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape') return;
    var open=document.querySelectorAll('.bt-modal.show');
    if(open.length){ e.preventDefault(); open.forEach(function(m){ m.classList.remove('show'); }); }
  });

  /* ============================================================
     LAYERS
     ============================================================ */
  function refreshLayers(){
    const list=document.getElementById('layerList'),empty=document.getElementById('layerEmpty');
    list.innerHTML='';
    const objs=canvas.getObjects().slice().reverse();
    empty.style.display=objs.length?'none':'block';
    const active=canvas.getActiveObject();
    objs.forEach(o=>{
      const row=document.createElement('div');row.className='layer'+(o===active?' sel':'');
      let thumb='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7V4h16v3M9 20h6M12 4v16"/></svg>';
      let name=o._bt_name||'Layer';
      if(o.type==='textbox'){name=(o.text||'Text').slice(0,18)||'Text';}
      else if(o.type==='image'){try{thumb=`<img src="${o.toDataURL({multiplier:0.3})}">`;}catch(e){}}
      row.innerHTML=`<div class="thumb">${thumb}</div><div class="ln">${name}</div>
        <button class="del" title="Delete">✕</button>`;
      row.onclick=ev=>{if(ev.target.closest('.del'))return;canvas.setActiveObject(o);canvas.renderAll();};
      row.querySelector('.del').onclick=()=>{canvas.remove(o);canvas.discardActiveObject();canvas.renderAll();refreshLayers();syncControls();};
      list.appendChild(row);
    });
  }

  /* ============================================================
     SELECTION SYNC
     ============================================================ */
  function checkDpi(){
    const w=document.getElementById('dpiWarn'); if(!w) return;
    const o=canvas.getActiveObject();
    if(o && o.type==='image'){
      const sc=Math.max(o.scaleX||1,o.scaleY||1);
      const dpi=(STAGE_W/14)/sc;          // ~14in assumed garment-area width (advisory)
      w.style.display = dpi<150 ? 'block' : 'none';
    } else { w.style.display='none'; }
  }

  function syncControls(){
    const o=canvas.getActiveObject();
    const tc=document.getElementById('textControls');
    if(o&&o.type==='textbox'){
      tc.style.display='block';
      document.getElementById('txtContent').value=o.text;
      document.getElementById('txtColor').value=o.fill;
      document.getElementById('txtHex').value=(o.fill||'#000000').toString().toUpperCase();
      document.getElementById('txtSize').value=Math.round(o.fontSize);
      document.getElementById('txtSpace').value=o.charSpacing||0;
      document.getElementById('spaceVal').textContent=o.charSpacing||0;
      document.getElementById('txtCurve').value=o._bt_curve||0;
      document.getElementById('curveVal').textContent=(o._bt_curve||0)+'°';
      document.getElementById('txtSkewX').value=o.skewX||0;
      document.getElementById('txtSkewY').value=o.skewY||0;
      document.getElementById('tBold').classList.toggle('on',o.fontWeight==='bold');
      document.getElementById('tItalic').classList.toggle('on',o.fontStyle==='italic');
      document.getElementById('tUnder').classList.toggle('on',!!o.underline);
      document.querySelectorAll('#txtAlign button').forEach(b=>b.classList.toggle('active',b.dataset.a===o.textAlign));
      document.querySelectorAll('.font-chip').forEach(b=>b.classList.toggle('active',b.dataset.font===o.fontFamily));
    } else tc.style.display='none';
    const ac=document.getElementById('adjControls'),ae=document.getElementById('adjEmpty');
    if(o){
      ac.style.display='block';ae.style.display='none';
      rot.value=Math.round(o.angle>180?o.angle-360:o.angle);document.getElementById('rotVal').textContent=rot.value+'°';
      o._bt_baseScale=o._bt_baseScale||o.scaleX;scaleS.value=100;document.getElementById('scaleVal').textContent='100%';
      op.value=Math.round(o.opacity*100);document.getElementById('opVal').textContent=op.value+'%';
    }else{ac.style.display='none';ae.style.display='block';}
    refreshLayers();
    checkDpi();
  }

  function onSelect(){ syncControls();
    var o=canvas.getActiveObject();
    if(o&&o.type==='image' && !(typeof spotMode!=='undefined'&&spotMode) && !(typeof brushMode!=='undefined'&&brushMode)) goTab('adjust');
  }
  canvas.on('selection:created',onSelect);
  canvas.on('selection:updated',onSelect);
  canvas.on('selection:cleared',syncControls);
  canvas.on('object:modified',()=>{const o=canvas.getActiveObject();if(o)o._bt_baseScale=o.scaleX;syncControls();});
  canvas.on('object:added',()=>scheduleSave());
  canvas.on('object:removed',()=>scheduleSave());
  canvas.on('object:modified',()=>scheduleSave());

  document.getElementById('guideBtn').onclick=function(){
    document.getElementById('productStage').classList.toggle('show-guide');
    this.classList.toggle('on');
  };
  (function(){
    var pg=document.getElementById('printGuide'), ps=document.getElementById('productStage');
    if(!pg||!ps) return;
    var DEF={l:22,t:28,w:56,h:58}, MIN=10, st=null;
    function cur(){ return { l:parseFloat(pg.style.left)||DEF.l, t:parseFloat(pg.style.top)||DEF.t, w:parseFloat(pg.style.width)||DEF.w, h:parseFloat(pg.style.height)||DEF.h }; }
    function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }
    function move(e){
      if(!st) return;
      var dx=(e.clientX-st.x)/st.bw*100, dy=(e.clientY-st.y)/st.bh*100, c=st.c, m=st.mode;
      if(m==='move'){
        pg.style.left=clamp(c.l+dx,0,100-c.w)+'%';
        pg.style.top =clamp(c.t+dy,0,100-c.h)+'%';
      }else{
        var l=c.l,t=c.t,w=c.w,h=c.h;
        if(m.indexOf('e')>=0) w=clamp(c.w+dx,MIN,100-c.l);
        if(m.indexOf('s')>=0) h=clamp(c.h+dy,MIN,100-c.t);
        if(m.indexOf('w')>=0){ var nl=clamp(c.l+dx,0,c.l+c.w-MIN); w=c.w+(c.l-nl); l=nl; }
        if(m.indexOf('n')>=0){ var nt=clamp(c.t+dy,0,c.t+c.h-MIN); h=c.h+(c.t-nt); t=nt; }
        pg.style.left=l+'%'; pg.style.top=t+'%'; pg.style.width=w+'%'; pg.style.height=h+'%';
      }
      e.preventDefault();
    }
    function up(){ st=null; window.removeEventListener('pointermove',move); window.removeEventListener('pointerup',up); }
    function down(e,mode){
      var r=ps.getBoundingClientRect();
      st={mode:mode, x:e.clientX, y:e.clientY, bw:r.width, bh:r.height, c:cur()};
      window.addEventListener('pointermove',move); window.addEventListener('pointerup',up);
      e.preventDefault(); e.stopPropagation();
    }
    var tab=pg.querySelector('.pg-tab');
    if(tab){
      tab.addEventListener('pointerdown',function(e){ down(e,'move'); });
      tab.addEventListener('dblclick',function(){ pg.style.left=DEF.l+'%';pg.style.top=DEF.t+'%';pg.style.width=DEF.w+'%';pg.style.height=DEF.h+'%'; });
    }
    ['nw','ne','sw','se'].forEach(function(h){ var el=pg.querySelector('.pg-'+h); if(el) el.addEventListener('pointerdown',function(e){ down(e,h); }); });
  })();

  function openSpecGuide(){
    try{
      if(window.btSpecGuide && typeof window.btSpecGuide.open==='function' && document.getElementById('bt-sg-modal')){
        window.btSpecGuide.open();
        return;
      }
    }catch(e){ console.error('[BulkThreads] spec guide open failed',e); }
    if(SPEC_GUIDE_URL){ window.open(SPEC_GUIDE_URL,'_blank','noopener'); }
    else { alert('Our spec guide opens on product pages. Set a "Spec guide fallback link" in the customizer settings to link it here, or we can embed it directly.'); }
  }

  function layoutStage(){
    try{
      const stage=document.getElementById('stage');
      const availW=stage.clientWidth-24, availH=stage.clientHeight-24;
      if(availW<=0||availH<=0) return;
      const base=Math.min(availW/STAGE_W, availH/STAGE_H, 1.25); // fit; allow a little upscale to fill a tall pane
      const s=Math.max(0.1, base*zoom);                       // zoom is a multiplier (default 1)
      const ps=document.getElementById('productStage');
      ps.style.width=(STAGE_W*s)+'px';
      ps.style.height=(STAGE_H*s)+'px';
      canvas.setDimensions({width:(STAGE_W*s)+'px', height:(STAGE_H*s)+'px'}, {cssOnly:true});
      document.getElementById('zoomVal').textContent=Math.round(s*100)+'%';
    }catch(e){}
  }
  document.getElementById('zoomIn').onclick=()=>{zoom=Math.min(3,zoom+0.1);layoutStage();};
  document.getElementById('zoomOut').onclick=()=>{zoom=Math.max(0.5,zoom-0.1);layoutStage();};
  initCarryBar();
  initCartImport();
  // Ticking the confirmation reveals the "which pieces?" box, so re-render on change.
  (function(){ var b=document.getElementById('pfPartialConfirm');
    if(b) b.addEventListener('change', function(){ try{ renderPrice(); }catch(e){} }); })();

  (function(){
    const stageEl=document.getElementById('stage');
    let pinching=false, startDist=0, startZoom=1;
    const dist=t=>Math.hypot(t[0].clientX-t[1].clientX, t[0].clientY-t[1].clientY);
    stageEl.addEventListener('touchstart',e=>{
      if(e.touches.length===2){ pinching=true; startDist=dist(e.touches); startZoom=zoom; }
    },{passive:true});
    stageEl.addEventListener('touchmove',e=>{
      if(pinching && e.touches.length===2){
        e.preventDefault();                       // stop the browser zooming the whole page
        const d=dist(e.touches);
        if(startDist>0){ zoom=Math.max(0.5,Math.min(3, startZoom*(d/startDist))); layoutStage(); }
      }
    },{passive:false});
    stageEl.addEventListener('touchend',e=>{ if(e.touches.length<2) pinching=false; },{passive:true});
    stageEl.addEventListener('touchcancel',()=>{ pinching=false; },{passive:true});
  })();

  /* ============================================================
     EXPORT
     ============================================================ */
  function captureMockup(){
    return new Promise((resolve,reject)=>{
      if(!currentView){reject(new Error('no-product'));return;}
      canvas.discardActiveObject();canvas.renderAll();
      const photo=document.getElementById('productPhoto');
      const out=document.createElement('canvas');
      out.width=STAGE_W*2; out.height=STAGE_H*2;
      const octx=out.getContext('2d');
      octx.fillStyle='#ffffff';octx.fillRect(0,0,out.width,out.height);
      const nw=photo.naturalWidth, nh=photo.naturalHeight;
      if(nw&&nh){
        const scale=Math.min(out.width/nw,out.height/nh);
        const dw=nw*scale, dh=nh*scale, dx=(out.width-dw)/2, dy=(out.height-dh)/2;
        try{octx.drawImage(photo,dx,dy,dw,dh);}catch(e){reject(new Error('cors'));return;}
      }
      const dimg=new Image();
      dimg.onload=()=>{
        octx.drawImage(dimg,0,0,out.width,out.height);
        try{
          const url=out.toDataURL('image/png');
          const colorEl=document.querySelector('#colorSwatches .color-swatch.active .cs-name');
          const color=colorEl?colorEl.textContent.trim():'';
          const label=((product&&product.title)||'Design')+(color?(' — '+color):'');
          resolve({url,label,w:out.width,h:out.height});
        }catch(err){reject(new Error('cors'));}
      };
      dimg.onerror=()=>reject(new Error('design-render'));
      dimg.src=canvas.toDataURL({format:'png',multiplier:2});
    });
  }
  function mockupCorsAlert(){
    alert('The product photo could not be exported due to image security settings.\n\nPlease try again, or save and share your design link instead.');
  }

  document.getElementById('dlMockup').onclick=()=>{
    cxTrack('mockup_exported', cxContext());
    if(!currentView){alert('Pick a product first.');return;}
    captureMockup()
      .then(({url})=>download(url,'bulkthreads-mockup.png'))
      .catch(err=>{ console.error('[BulkThreads] mockup export failed',err); if(String(err.message)==='cors') mockupCorsAlert(); });
  };

  /* ============================================================
     COMPARE DESIGNS (side-by-side snapshots)
     ============================================================ */
  (function(){
    const MAX_COMPARE=4;
    let compareItems=[]; // [{url,label,w,h}]
    const addBtn=document.getElementById('addCompare');
    const openBtn=document.getElementById('openCompare');
    const wrapEl=document.getElementById('cmpWrap');
    const clearBtn=document.getElementById('cmpClear');
    const countEl=document.getElementById('cmpCount');
    const view=document.getElementById('compareView');
    const grid=document.getElementById('compareGrid');
    const emptyEl=document.getElementById('compareEmpty');

    function updateButtons(){
      if(countEl) countEl.textContent=String(compareItems.length);
      // The wrapper carries the visibility now — it holds the button plus its ✕ badge.
      if(wrapEl) wrapEl.style.display=compareItems.length?'':'none';
      else if(openBtn) openBtn.style.display=compareItems.length?'':'none';
    }
    function add(){
      if(!currentView){alert('Pick a product and add a design first.');return;}
      captureMockup().then(item=>{
        compareItems.push(item);
        if(compareItems.length>MAX_COMPARE) compareItems.shift();
        updateButtons();
        flash(addBtn,'Added ✓');
        if(view.style.display!=='none') renderGrid();
      }).catch(err=>{ console.error('[BulkThreads] compare capture failed',err); if(String(err.message)==='cors') mockupCorsAlert(); });
    }
    function flash(btn,msg){
      if(!btn)return; const span=[...btn.childNodes].find(n=>n.nodeType===3&&n.textContent.trim());
      if(!span)return; const prev=span.textContent; span.textContent=' '+msg; btn.disabled=true;
      setTimeout(()=>{span.textContent=prev;btn.disabled=false;},900);
    }
    function open(){ renderGrid(); view.style.display='flex'; }
    function close(){ view.style.display='none'; }
    // Drop every snapshot and hide the Compare button — the only way back out of compare
    // mode short of reloading the page, which is what customers were having to do.
    function clearAll(){
      compareItems=[];
      close();
      if(grid) grid.innerHTML='';
      updateButtons();
    }
    function removeAt(i){ compareItems.splice(i,1); updateButtons(); renderGrid(); if(!compareItems.length) close(); }
    function renderGrid(){
      grid.innerHTML='';
      emptyEl.style.display=compareItems.length<2?'':'none';
      compareItems.forEach((it,i)=>{
        const pane=document.createElement('div');pane.className='compare-pane';
        pane.innerHTML=`<img src="${it.url}" alt="">`+
          `<div class="cp-foot"><span>${(it.label||'Design').replace(/</g,'&lt;')}</span>`+
          `<button class="cp-remove" title="Remove" aria-label="Remove">✕</button></div>`;
        pane.querySelector('.cp-remove').onclick=()=>removeAt(i);
        grid.appendChild(pane);
      });
    }
    function exportAll(){
      if(!compareItems.length)return;
      const imgs=compareItems.map(it=>{const im=new Image();im.src=it.url;return im;});
      Promise.all(imgs.map(im=>im.decode().catch(()=>{}))).then(()=>{
        const pad=24, w0=imgs[0].naturalWidth||840, h0=imgs[0].naturalHeight||1000;
        const out=document.createElement('canvas');
        out.width=imgs.length*w0+(imgs.length+1)*pad; out.height=h0+pad*2;
        const ctx=out.getContext('2d');ctx.fillStyle='#ffffff';ctx.fillRect(0,0,out.width,out.height);
        imgs.forEach((im,i)=>{ try{ctx.drawImage(im,pad+i*(w0+pad),pad,w0,h0);}catch(e){} });
        try{ download(out.toDataURL('image/png'),'bulkthreads-compare.png'); }catch(e){ mockupCorsAlert(); }
      });
    }
    if(addBtn) addBtn.onclick=add;
    if(openBtn) openBtn.onclick=open;
    if(clearBtn) clearBtn.onclick=function(e){ e.preventDefault(); e.stopPropagation(); clearAll(); };
    const cmpAdd=document.getElementById('cmpAdd'); if(cmpAdd) cmpAdd.onclick=add;
    const cmpClose=document.getElementById('cmpClose'); if(cmpClose) cmpClose.onclick=close;
    const cmpExport=document.getElementById('cmpExport'); if(cmpExport) cmpExport.onclick=exportAll;
    updateButtons();
  })();

  /* ============================================================
     SUBMIT FOR A QUOTE (mailto)
     ============================================================ */
  function updateEmbNote(){
    var m=document.getElementById('decoType'), n=document.getElementById('embNote');
    if(n) n.style.display=(m && /embroider/i.test(m.value) && !isPricingActive())?'':'none';
  }
  var _dtEl=document.getElementById('decoType'); if(_dtEl) _dtEl.addEventListener('change',updateEmbNote);

  function openModal(toStep){
    cxTrack('modal_opened', cxContext());
    const st=document.getElementById('qmStatus');
    if(st){ st.textContent='Your design attaches automatically — no email app required.'; st.style.color=''; }
    const b=document.getElementById('qmSend');
    if(b){ b.disabled=false; b.textContent='Send quote request'; }
    buildSizeGrid();
    var _dd=document.getElementById('decoDate'); if(_dd) _dd.min=minInHandDate();   // block in-hand dates sooner than 7 days
    var _ddd=document.getElementById('pfDropDead'); if(_ddd) _ddd.min=minInHandDate();
    // "My dates are flexible" checked hides the drop-dead date; unchecked (default) reveals it.
    var _fx=document.getElementById('pfFlexDate'), _fxw=document.getElementById('pfDropDeadWrap');
    if(_fx && _fxw){ var syncFlex=function(){ _fxw.style.display=_fx.checked?'none':''; }; _fx.addEventListener('change',syncFlex); syncFlex(); }
    if(PRICING_ENABLED) syncPriceFlow();
    updateEmbNote();
    document.getElementById('quoteModal').classList.add('show');
    updateOrderBanner();
    qmGoStep(toStep || (orderItems.length?2:1));   // already added a product → contact is done, jump to Method
  }

  /* ---- Size breakdown grid ----
     When the selected product exposes its sizes, swap the free-text "Size
     breakdown" field for a per-size quantity grid; otherwise keep the text box.
     The grid feeds both the size breakdown line and the total piece count. */
  function availableColors(){ return (colorGroups||[]).filter(function(g){ return g && g.val!=null; }); }
  function buildColorBlock(colorVal){
    var sizes=(product&&product.sizes&&product.sizes.length)?product.sizes:['__all__'];
    var g=(colorGroups||[]).find(function(x){ return x.val===colorVal; });
    var block=document.createElement('div'); block.className='qm-color-block'; block.dataset.color=colorVal||'';
    if(colorVal){
      var head=document.createElement('div'); head.className='qm-color-head';
      head.innerHTML='<span class="qm-dot">'+(g&&g.img?'<img src="'+g.img+'" alt="">':'')+'</span>'+
        '<span class="qm-cname"></span><span class="qm-csub" data-ctotal>0 pcs</span>'+
        '<button type="button" class="qm-rmcolor" title="Remove this color">✕</button>';
      head.querySelector('.qm-cname').textContent=colorVal;
      head.querySelector('.qm-rmcolor').onclick=function(){ removeColorBlock(block); };
      block.appendChild(head);
    }
    var sg=document.createElement('div'); sg.className='size-grid';
    sizes.forEach(function(s){
      var cell=document.createElement('div'); cell.className='size-cell';
      var lbl=document.createElement('span'); lbl.className='sz-lbl'; lbl.textContent=(s==='__all__'?'Qty':s);
      var inp=document.createElement('input');
      inp.type='number'; inp.min='0'; inp.inputMode='numeric'; inp.placeholder='0';
      inp.dataset.size=s; inp.dataset.color=colorVal||''; inp.oninput=updateSizeTotal;
      cell.appendChild(lbl); cell.appendChild(inp); sg.appendChild(cell);
    });
    block.appendChild(sg);
    return block;
  }
  function refreshAddColorOptions(){
    var sel=document.querySelector('#sizeGrid .qm-addcolor select'); if(!sel) return;
    var used={}; document.querySelectorAll('#sizeGrid .qm-color-block').forEach(function(b){ used[b.dataset.color]=1; });
    var opts='<option value="">+ Add another color…</option>';
    availableColors().forEach(function(c){ if(!used[c.val]) opts+='<option value="'+(c.val||'').replace(/"/g,'&quot;')+'">'+c.val+'</option>'; });
    sel.innerHTML=opts;
  }
  function buildAddColor(){
    var wrap=document.createElement('div'); wrap.className='qm-addcolor';
    var sel=document.createElement('select');
    sel.onchange=function(){ if(sel.value){ addColorBlock(sel.value); sel.value=''; } };
    wrap.appendChild(sel);
    return wrap;
  }
  function addColorBlock(colorVal){
    var grid=document.getElementById('sizeGrid'); var addEl=grid.querySelector('.qm-addcolor');
    var block=buildColorBlock(colorVal);
    if(addEl) grid.insertBefore(block, addEl); else grid.appendChild(block);
    refreshAddColorOptions(); updateSizeTotal();
    var f=block.querySelector('input'); if(f){ try{ f.focus(); }catch(e){} }
  }
  function removeColorBlock(block){
    var grid=document.getElementById('sizeGrid');
    if(grid.querySelectorAll('.qm-color-block').length<=1) return;   // always keep at least one color
    block.remove(); refreshAddColorOptions(); updateSizeTotal();
  }
  function buildSizeGrid(){
    const grid=document.getElementById('sizeGrid');
    const free=document.getElementById('decoSizes');
    const totWrap=document.getElementById('sizeGridTotalWrap');
    const sizes=(product&&product.sizes)||[];
    const cols=availableColors();
    if(!grid||!free) return;
    if(!sizes.length && !cols.length){                   // nothing structured → free-text fallback
      grid.style.display='none'; grid.innerHTML=''; free.style.display='';
      if(totWrap) totWrap.style.display='none';
      return;
    }
    free.style.display='none';
    if(totWrap) totWrap.style.display='';
    var sig=sizes.join('|')+'#'+cols.map(function(c){return c.val;}).join('|');
    if(grid.dataset.sig!==sig){
      grid.innerHTML=''; grid.dataset.sig=sig;
      if(cols.length){
        var seed=cols.find(function(c){return c.val===selectedColor;})||cols[0];
        grid.appendChild(buildColorBlock(seed.val));
        grid.appendChild(buildAddColor());
        refreshAddColorOptions();
      } else {
        grid.appendChild(buildColorBlock(null));         // single block, no color dimension
      }
    }
    grid.style.display='';
    updateSizeTotal();
  }
  function readSizeGrid(){
    const grid=document.getElementById('sizeGrid');
    if(!grid || grid.style.display==='none') return null;
    const parts=[]; let total=0;
    grid.querySelectorAll('.qm-color-block').forEach(function(b){
      const color=b.dataset.color||''; const sub=[]; let ct=0;
      b.querySelectorAll('input[data-size]').forEach(function(inp){
        const n=parseInt(inp.value,10);
        if(n>0){ sub.push(n+(inp.dataset.size==='__all__'?'':' '+inp.dataset.size)); ct+=n; total+=n; }
      });
      const ctEl=b.querySelector('[data-ctotal]'); if(ctEl) ctEl.textContent=ct+' pcs';
      if(sub.length) parts.push((color?color+': ':'')+sub.join(', '));
    });
    return {breakdown:parts.join('  ·  '), total:total};
  }
  function readColorSizes(){
    const grid=document.getElementById('sizeGrid'); const out=[];
    if(grid && grid.style.display!=='none'){
      grid.querySelectorAll('.qm-color-block').forEach(function(b){
        const color=b.dataset.color||(selectedColor||''); const sizes={};
        b.querySelectorAll('input[data-size]').forEach(function(inp){ const n=parseInt(inp.value,10); if(n>0) sizes[inp.dataset.size]=n; });
        if(Object.keys(sizes).length) out.push({color:color, sizes:sizes});
      });
    }
    if(!out.length) out.push({color:selectedColor||'', sizes:{'__all__':totalPieces()}});  // free-text fallback
    return out;
  }
  function updateSizeTotal(){
    const t=readSizeGrid(); const el=document.getElementById('sizeGridTotal');
    if(el && t) el.textContent=t.total;
    if(PRICING_ENABLED) renderPrice();
  }
  function closeModal(){ document.getElementById('quoteModal').classList.remove('show'); }
  document.getElementById('submitQuote').onclick=()=>{
    if(!product){alert('Please search and select a product first.');return;}
    openModal();
  };
  document.getElementById('qmClose').onclick=closeModal;
  document.getElementById('quoteModal').addEventListener('click',e=>{if(e.target.id==='quoteModal')closeModal();});
  document.getElementById('qmSend').onclick=sendQuote;

  var QM_STEP=1, QM_MAX=6;
  function minInHandDate(){ var d=new Date(); d.setHours(0,0,0,0); d.setDate(d.getDate()+7); return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
  function qmErr(msg){ var e=document.getElementById('qmStepErr'); if(e){ e.textContent=msg||''; e.style.display=msg?'block':'none'; } }
  function qmValidate(step){
    if(step===1){
      if(!qval('qName')) return 'Please enter your name.';
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(qval('qEmail'))) return 'Please enter a valid email address.';
      var d=shipDest();
      if(!d.raw) return 'Please enter your shipping ZIP code.';
      if(d.noShip) return 'Sorry, we don’t ship to that destination — please use a serviceable U.S. ZIP.';
      if(d.complete && !d.valid) return 'Please enter a valid U.S. ZIP code.';
      if(!qval('decoDate')) return 'Please choose your preferred in-hand date.';
      if(qval('decoDate') < minInHandDate()) return 'Our turnaround is 7–10 days — please pick a preferred date at least 7 days out.';
      if(!chk('pfFlexDate') && qval('pfDropDead')){
        if(qval('pfDropDead') < minInHandDate()) return 'Your “absolutely need it by” date must be at least 7 days out.';
        if(qval('pfDropDead') < qval('decoDate')) return 'Your “absolutely need it by” date can’t be before your preferred date.';
      }
      return '';
    }
    if(step===2){ return currentMethod() ? '' : 'Please choose a decoration method.'; }
    if(step===3){
      if(totalPieces()<1) return 'Add quantities in the size breakdown.';
      var out=[];
      readColorSizes().forEach(function(cs){
        Object.keys(cs.sizes||{}).forEach(function(sz){
          if((cs.sizes[sz]||0)>0 && isKnownOut(cs.color, sz)) out.push((cs.color||'')+' '+(sz==='__all__'?'':sz));
        });
      });
      if(out.length) return 'Out of stock: '+out.slice(0,6).join(', ')+(out.length>6?(' and '+(out.length-6)+' more'):'')+
        '. Pick a different size or color, or ask us about a substitute.';
      return '';
    }   // MOQ is per-DESIGN and gated at step 5 — don't block here, the customer may still be adding garments to reach it.
    if(step===4){
      var locs=readLocations(); if(!locs.length) return 'Add at least one '+(currentMethod()==='embroidery'?'embroidery':'print')+' location.';
      if(currentMethod()!=='embroidery'){
        var noPlace=false; document.querySelectorAll('#pfLocations .pf-loc').forEach(function(r){ var pl=r.querySelector('.pf-loc-place'); if(!pl||!(pl.value||'').trim()) noPlace=true; });
        if(noPlace) return 'Choose a print location for each spot (use the “Choose a location…” dropdown).';
      }
      if(currentMethod()==='screenprint'){
        var miss=false; document.querySelectorAll('#pfLocations .pf-loc').forEach(function(r){ var cl=r.querySelector('.pf-loc-colorlist'); if(!cl||!cl.value.trim()) miss=true; });
        if(miss) return 'List the ink colors at each print location.';
      }
      if(currentMethod()==='embroidery'){
        var bad=false; document.querySelectorAll('#pfLocations .pf-loc').forEach(function(r){ if(!((r.querySelector('.pf-loc-place')||{}).value||'').trim()) bad=true; var st=parseInt((r.querySelector('.pf-loc-stitches')||{}).value,10)||0; if(st<1) bad=true; });
        if(bad) return 'Add a placement and logo size (stitch count) at each embroidery location.';
      }
      // Partial prints are caught HERE, where the quantity was typed — not three steps
      // later at checkout, which left the customer being told off on a screen with
      // nothing to act on. Confirm the split first, then describe it: agreeing that only
      // some pieces get printed is the decision; which ones is the detail.
      var _g4=partialPrintGaps(locs, totalPieces());
      if(_g4.length){
        if(!chk('pfPartialConfirm')) return partialPrintSentence(_g4)+
          ' Tick the box to confirm. If every piece should be printed, clear the quantity box next to the location (blank = all).';
        if(!((document.getElementById('pfPlacementNotes')||{}).value||'').trim())
          return 'Now tell us which sizes/colors get the print, so we decorate the right pieces.';
      }
      return '';
    }
    // Step 5 (Extras) is where the price panel already spells out the shortfall, so this is
    // where the per-design MOQ is enforced — not at Review, which let a customer build the
    // whole order before being told. Safe to block here: the Extras pane carries the "add
    // another product" button, and committing a product doesn't check MOQ, so someone can
    // still add a 2nd garment of the SAME design to pool up to the minimum.
    // Checkout re-checks (doCheckout) in case a step is skipped via the step bar.
    if(step===5){
      if(!PRICING_ENABLED || !PRICE_RATES) return '';   // quote-only mode doesn't price or gate
      var _s=designsBelowMoq();
      if(_s.length) return moqMessage(_s);
      return '';
    }
    return '';
  }
  function qmRenderBar(){
    var box=document.getElementById('qmSteps'); if(!box) return;
    box.querySelectorAll('button').forEach(function(b){ var n=parseInt(b.dataset.goto,10); b.classList.toggle('on',n===QM_STEP); b.classList.toggle('done',n<QM_STEP); });
  }

  /* Send the customer to the field that needs fixing. A validation message shown on the
     Review step is a dead end — the placement note and its confirmation live back on
     Locations (step 4), so naming the problem there gives them nothing to act on. */
  function goFixPartialPrint(msg){
    try{
      qmGoStep(4);              // note: this clears the error, so set it afterwards
      qmErr(msg);
      var wrap=document.getElementById('pfPlacementNotesWrap');
      if(wrap){
        wrap.style.display='';
        if(wrap.scrollIntoView) wrap.scrollIntoView({behavior:'smooth', block:'center'});
      }
      var note=document.getElementById('pfPlacementNotes');
      var box=document.getElementById('pfPartialConfirm');
      // Focus whichever is outstanding, in the order they're asked: tick, then notes.
      var target=(box && !box.checked) ? box : (note||box);
      if(target && target.focus) setTimeout(function(){ try{ target.focus(); }catch(e){} }, 250);
    }catch(e){}
  }

  function qmGoStep(n){
    n=Math.max(1,Math.min(QM_MAX,n)); QM_STEP=n; qmErr('');
    cxTrack('step_'+n, Object.assign({step:n}, cxContext()));   // funnel: price first appears at step 4
    document.querySelectorAll('#quoteModal .qm-step').forEach(function(p){ p.classList.toggle('qm-on', parseInt(p.dataset.step,10)===n); });
    qmRenderBar();
    var back=document.getElementById('qmBack'), next=document.getElementById('qmNext');
    if(back) back.style.visibility=(n===1)?'hidden':'visible';
    if(next) next.style.display=(n===QM_MAX)?'none':'';
    if(PRICING_ENABLED && n>=4) syncPriceFlow();
    if(PRICING_ENABLED && n===5){ renderPrice(); maybePromptArtwork(); }   // entering step 5 = just past Locations
    if(PRICING_ENABLED) updateRunPrice();   // premium running-price bar refreshes on every step
    if(n===6){ renderCart(); if(PRICING_ENABLED){ ensureTurnstile(); updateArtReminder(); } }
    var pane=document.querySelector('#quoteModal .qm-step[data-step="'+n+'"]');
    var f=pane && pane.querySelector('input,select,textarea');
    if(f && n!==5){ try{ f.focus({preventScroll:true}); }catch(e){} }
    var card=document.querySelector('#quoteModal .bt-modal-card'); if(card) card.scrollTop=0;
  }
  function qmNext(){ var e=qmValidate(QM_STEP); if(e){ qmErr(e); return; } qmGoStep(QM_STEP+1); }
  function qmJump(target){
    if(target<=QM_STEP){ qmGoStep(target); return; }            // jumping back is always allowed
    for(var s=QM_STEP;s<target;s++){ var e=qmValidate(s); if(e){ qmErr(e); qmGoStep(s); return; } }  // forward: each step must pass
    qmGoStep(target);
  }
  (function(){
    var nx=document.getElementById('qmNext'); if(nx) nx.onclick=qmNext;
    var bk=document.getElementById('qmBack'); if(bk) bk.onclick=function(){ qmGoStep(QM_STEP-1); };
    var bar=document.getElementById('qmSteps'); if(bar) bar.addEventListener('click',function(e){ var btn=e.target.closest('button[data-goto]'); if(btn) qmJump(parseInt(btn.dataset.goto,10)); });
    var nudge=document.getElementById('pfTierNudge'); if(nudge) nudge.addEventListener('click',function(e){ var a=e.target.closest('.qm-goto-sizes'); if(a){ e.preventDefault(); qmGoStep(3); } });
    var ap=document.getElementById('qmAddProduct'); if(ap) ap.onclick=addAnotherProduct;
    var ap2=document.getElementById('qmAddProduct2'); if(ap2) ap2.onclick=addAnotherProduct;
    var gal=document.getElementById('pfGallery'); if(gal) gal.addEventListener('change',function(){ if(QM_STEP===6) renderCart(); });
    var obr=document.getElementById('obReview'); if(obr) obr.onclick=function(){ openModal(6); };   // jump straight to the cart
    updateOrderBanner();   // capture the button's base label + start hidden
  })();

  function qval(id){const el=document.getElementById(id);return el?(''+el.value).trim():'';}

  function buildSummary(c){
    const origin=window.location.origin;
    const srcPath=selectedSourceUrl||product.url||'';
    const purl=srcPath?(origin+srcPath.split('?')[0]):'';
    const viewsWithArt=Object.keys(designs).filter(s=>designs[s]&&designs[s].objects&&designs[s].objects.length);
    const describe=(o)=> o.type==='textbox'
      ? '      - Text: "'+o.text+'" ('+o.fontFamily+', '+Math.round(o.fontSize)+'px, '+o.fill+')'
      : (o.type==='image' ? '      - Uploaded image / logo' : '      - Graphic');
    const L=[];
    L.push('Customer: '+c.name);
    L.push('Email: '+c.email);
    if(c.phone) L.push('Phone: '+c.phone);
    L.push('');
    L.push('Product: '+product.title);
    if(purl) L.push('Product link: '+purl);
    if(selectedColor) L.push('Color: '+selectedColor);
    L.push('');
    L.push('Decoration details:');
    L.push('  Method: '+c.decoType);
    L.push('  Quantity (pieces): '+c.decoQty);
    if(c.decoSizes)  L.push('  Size breakdown: '+c.decoSizes);
    if(c.decoColors) L.push('  Ink/thread colors: '+c.decoColors);
    L.push('  In-hand date: '+(c.decoDate||'Not specified'));
    if(c.notes) L.push('  Notes: '+c.notes);
    L.push('');
    if(viewsWithArt.length){
      L.push('Designs by view (artwork attached):');
      viewsWithArt.forEach((src,i)=>{
        L.push('  View '+(i+1)+':');
        L.push('    Photo: '+src);
        designs[src].objects.forEach(o=>L.push(describe(o)));
      });
    }else{
      L.push('Designs: (no artwork placed yet)');
    }
    return L.join('\n');
  }

  function renderViewArt(json){
    return new Promise(function(resolve){
      try{
        const el=document.createElement('canvas'); el.width=STAGE_W; el.height=STAGE_H;
        const fc=new fabric.StaticCanvas(el,{width:STAGE_W,height:STAGE_H,backgroundColor:'transparent'});
        fc.loadFromJSON(json,function(){ fc.renderAll(); var url=''; try{url=fc.toDataURL({format:'png',multiplier:2});}catch(e){} fc.dispose(); resolve(url); });
      }catch(e){ resolve(''); }
    });
  }

  // Why every mockup failure used to vanish: three stacked paths each returned an empty
  // string -- toDataURL() throwing on a tainted canvas, the per-view catch in
  // renderCurrentMockups(), and uploadDataUrl() on a bad response. `if(m)` then dropped
  // the view silently. Reasons now land here and ride along to the order and cx_events.
  var mockupDiag=[];
  function mockupNote(stage, detail){ try{ mockupDiag.push(stage+(detail?(':'+detail):'')); }catch(e){} }

  function renderViewMockup(photoSrc, json){
    return new Promise(function(resolve){
      const M=2, W=STAGE_W*M, H=STAGE_H*M;
      const out=document.createElement('canvas'); out.width=W; out.height=H;
      const ctx=out.getContext('2d');
      function overlayArtAndFinish(){
        renderViewArt(json).then(function(artUrl){
          if(!artUrl){ finish(); return; }
          const ai=new Image();
          ai.onload=function(){ try{ctx.drawImage(ai,0,0,W,H);}catch(e){} finish(); };
          ai.onerror=finish;
          ai.src=artUrl;
        });
      }
      function finish(){ var url='';
        try{ url=out.toDataURL('image/png'); }
        catch(e){ mockupNote('taint', (e&&e.name)||'toDataURL'); }   // tainted canvas -> SecurityError
        if(!url) mockupNote('empty', viewLabelForSrc(photoSrc)||'view');
        resolve(url); }
      const photo=new Image(); photo.crossOrigin='anonymous';
      photo.onload=function(){
        const nw=photo.naturalWidth||photo.width, nh=photo.naturalHeight||photo.height;
        const scale=Math.min(W/nw, H/nh);          // object-fit: contain
        const dw=nw*scale, dh=nh*scale, dx=(W-dw)/2, dy=(H-dh)/2;
        try{ ctx.drawImage(photo,dx,dy,dw,dh); }catch(e){}
        overlayArtAndFinish();
      };
      photo.onerror=function(){ mockupNote('photo404', viewLabelForSrc(photoSrc)||'view'); overlayArtAndFinish(); };  // no photo → art only
      photo.src=photoSrc;
    });
  }
  function dataURLtoBlob(durl){
    try{ var a=durl.split(','),mime=a[0].match(/:(.*?);/)[1],bin=atob(a[1]),n=bin.length,u=new Uint8Array(n); while(n--)u[n]=bin.charCodeAt(n); return new Blob([u],{type:mime}); }catch(e){ return null; }
  }

  function sendViaMailto(summary,subject){
    closeModal();
    const body=encodeURIComponent('Hi BulkThreads team,\n\nI would like a quote for the following custom order:\n\n'+summary+'\n\n(I’ll attach my mockup — use the “Export mockup” button.)\n\nThanks!');
    window.location.href='mailto:'+BT_QUOTE_EMAIL+'?subject='+encodeURIComponent(subject)+'&body='+body;
  }

  function quoteSuccess(name){
    const status=document.getElementById('qmStatus');
    const btn=document.getElementById('qmSend');
    if(btn){ btn.disabled=false; btn.textContent='Send quote request'; }
    if(status){
      status.textContent='✓ Sent! We’ll follow up shortly — tweak your design and submit again anytime.';
      status.style.color='var(--good)';
    }
    setTimeout(closeModal,1800);   // brief confirmation, then return to the design
  }

  async function sendQuote(){
    cxTrack('quote_sent', cxContext());
    if(!product){alert('Please search and select a product first.');return;}
    const c={ name:qval('qName'), email:qval('qEmail'), phone:qval('qPhone'),
              decoType:qval('decoType'), decoQty:qval('decoQty'), decoSizes:qval('decoSizes'),
              decoColors:qval('decoColors'), decoDate:qval('decoDate'), notes:qval('decoNotes') };
    const sg=readSizeGrid();
    if(sg){ c.decoSizes=sg.breakdown; if(!c.decoQty && sg.total) c.decoQty=String(sg.total); }
    if(!c.name || !c.email){ alert('Please enter your name and email so we can send your quote.'); return; }
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email)){ alert('Please enter a valid email address.'); return; }
    if(!c.decoType || !c.decoQty){ alert('Please choose a decoration type and how many pieces you need.'); return; }
    // Embroidery submits here rather than through doCheckout, so the partial-print rules
    // have to be repeated — otherwise this path skips them entirely (it did until now).
    // Only the partial-print checks, deliberately: this is also a lead-capture form and
    // running the full product validation would start rejecting quote requests that have
    // always been accepted.
    var _pgaps=partialPrintGaps(readLocations(), totalPieces());
    if(_pgaps.length){
      if(!chk('pfPartialConfirm')){ alert(partialPrintSentence(_pgaps)+'\n\nTick the box to confirm. '+
        'If every piece should be printed, clear the quantity box next to the location (blank = all).'); return; }
      var _pnote=((document.getElementById('pfPlacementNotes')||{}).value||'').trim();
      if(!_pnote){ alert('Tell us which sizes/colors get the print, so we decorate the right pieces.'); return; }
    }
    saveView();
    const subject='Quote request — '+product.title+(selectedColor?(' ('+selectedColor+')'):'')+' · '+c.decoType+' · '+c.decoQty+' pcs';
    const summary=buildSummary(c);

    if(!FORM_ENDPOINT){ sendViaMailto(summary,subject); return; }

    const btn=document.getElementById('qmSend'); const status=document.getElementById('qmStatus');
    const orig=btn.textContent; btn.disabled=true; btn.textContent='Sending…'; if(status){ status.textContent='Uploading your design and details…'; }
    try{
      const fd=new FormData();
      if(FORM_KEY) fd.append('access_key',FORM_KEY);
      fd.append('botcheck','');           // Web3Forms honeypot (spam protection)
      fd.append('subject',subject);
      fd.append('from_name',c.name);
      fd.append('name',c.name);
      fd.append('email',c.email);
      if(c.phone) fd.append('phone',c.phone);
      fd.append('message',summary);
      try{ if(document.fonts&&document.fonts.ready) await document.fonts.ready; }catch(e){}  // ensure fonts before rendering art
      const views=Object.keys(designs).filter(s=>designs[s]&&designs[s].objects&&designs[s].objects.length);
      for(let i=0;i<views.length;i++){
        const src=views[i];
        const mock=await renderViewMockup(src, designs[src]);
        if(mock){ const mb=dataURLtoBlob(mock); if(mb) fd.append('mockup_view_'+(i+1),mb,'mockup-view-'+(i+1)+'.png'); }
        const art=await renderViewArt(designs[src]);
        const ab=art?dataURLtoBlob(art):null;
        if(ab) fd.append('design_view_'+(i+1),ab,'design-view-'+(i+1)+'.png');
      }
      const res=await fetch(FORM_ENDPOINT,{method:'POST',body:fd});
      let ok=res.ok;
      try{ const j=await res.clone().json(); if(typeof j.success!=='undefined') ok=j.success; }catch(e){}
      if(!ok) throw new Error('Submit failed ('+res.status+')');
      quoteSuccess(c.name);
    }catch(err){
      console.error('[BulkThreads] form submit failed',err);
      btn.disabled=false; btn.textContent=orig;
      if(status){
        status.innerHTML='We couldn’t send the form. <a href="#" id="qmFallback">Email it instead</a>, or try again.';
        const fb=document.getElementById('qmFallback'); if(fb) fb.onclick=function(e){e.preventDefault();sendViaMailto(summary,subject);};
      }
    }
  }

  /* ============================================================
     REORDER A PAST JOB (simple lead form — no order lookup)
     Captures name/email + the previous PO or job description and sends it to
     the same quote inbox (form endpoint, or mailto fallback). We follow up.
     ============================================================ */
  function openReorder(){ cxTrack('reorder_opened', cxContext()); document.getElementById('reorderModal').classList.add('show'); }
  function closeReorder(){ document.getElementById('reorderModal').classList.remove('show'); }
  async function sendReorder(){
    const name=qval('roName'), email=qval('roEmail'), phone=qval('roPhone'), job=qval('roJob'), notes=qval('roNotes');
    if(!name || !email){ alert('Please enter your name and email so we can reach you.'); return; }
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ alert('Please enter a valid email address.'); return; }
    if(!job){ alert('Please add the previous PO number or a short description of the job.'); return; }
    const subject='Reorder request — '+name;
    const L=['REORDER REQUEST','Customer: '+name,'Email: '+email];
    if(phone) L.push('Phone: '+phone);
    L.push('','Previous PO / job: '+job);
    if(notes) L.push('Changes this time: '+notes);
    const summary=L.join('\n');
    const sb=document.getElementById('roSend'), status=document.getElementById('roStatus');
    if(!FORM_ENDPOINT){
      closeReorder();
      const body=encodeURIComponent('Hi BulkThreads team,\n\nI’d like to reorder a previous job:\n\n'+summary+'\n\nThanks!');
      window.location.href='mailto:'+BT_QUOTE_EMAIL+'?subject='+encodeURIComponent(subject)+'&body='+body;
      return;
    }
    const orig=sb?sb.textContent:''; if(sb){ sb.disabled=true; sb.textContent='Sending…'; }
    if(status){ status.textContent='Sending your request…'; status.style.color=''; }
    try{
      const fd=new FormData();
      if(FORM_KEY) fd.append('access_key',FORM_KEY);
      fd.append('botcheck','');
      fd.append('subject',subject);
      fd.append('from_name',name);
      fd.append('name',name);
      fd.append('email',email);
      if(phone) fd.append('phone',phone);
      fd.append('message',summary);
      const res=await fetch(FORM_ENDPOINT,{method:'POST',body:fd});
      let ok=res.ok; try{ const j=await res.clone().json(); if(typeof j.success!=='undefined') ok=j.success; }catch(e){}
      if(!ok) throw new Error('Submit failed ('+res.status+')');
      if(sb){ sb.disabled=false; sb.textContent=orig; }
      if(status){ status.textContent='✓ Sent! We’ll get back to you shortly to confirm the details.'; status.style.color='var(--good)'; }
      setTimeout(closeReorder,1800);
    }catch(err){
      console.error('[BulkThreads] reorder send failed',err);
      if(sb){ sb.disabled=false; sb.textContent=orig; }
      if(status){
        status.innerHTML='We couldn’t send it. <a href="#" id="roFallback">Email us instead</a>, or try again.';
        const fb=document.getElementById('roFallback'); if(fb) fb.onclick=function(e){e.preventDefault();closeReorder();const body=encodeURIComponent('Hi BulkThreads team,\n\nI’d like to reorder a previous job:\n\n'+summary+'\n\nThanks!');window.location.href='mailto:'+BT_QUOTE_EMAIL+'?subject='+encodeURIComponent(subject)+'&body='+body;};
      }
    }
  }
  (function(){
    const rl=document.getElementById('reorderLink'); if(rl) rl.onclick=function(e){ e.preventDefault(); closeModal(); openReorder(); };
    const rls=document.getElementById('reorderLinkSearch'); if(rls) rls.onclick=function(e){ e.preventDefault(); openReorder(); };
    const x=document.getElementById('roClose'); if(x) x.onclick=closeReorder;
    const m=document.getElementById('reorderModal'); if(m) m.addEventListener('click',function(e){ if(e.target.id==='reorderModal') closeReorder(); });
    const s=document.getElementById('roSend'); if(s) s.onclick=sendReorder;
  })();

  function openComplex(){ document.getElementById('complexModal').classList.add('show'); }
  function closeComplex(){ document.getElementById('complexModal').classList.remove('show'); }
  async function sendComplex(){
    const name=qval('cxName'), email=qval('cxEmail'), phone=qval('cxPhone'), job=qval('cxJob');
    if(!name || !email){ alert('Please enter your name and email so we can reach you.'); return; }
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ alert('Please enter a valid email address.'); return; }
    if(!job){ alert('Please tell us a bit about your order, or add your PO number.'); return; }
    const subject='Complex order request — '+name;
    const L=['COMPLEX ORDER REQUEST','Customer: '+name,'Email: '+email];
    if(phone) L.push('Phone: '+phone);
    L.push('','Order details / PO: '+job);
    const summary=L.join('\n');
    const sb=document.getElementById('cxSend'), status=document.getElementById('cxStatus');
    if(!FORM_ENDPOINT){
      closeComplex();
      const body=encodeURIComponent('Hi BulkThreads team,\n\nI have a complex order:\n\n'+summary+'\n\nThanks!');
      window.location.href='mailto:'+BT_QUOTE_EMAIL+'?subject='+encodeURIComponent(subject)+'&body='+body;
      return;
    }
    const orig=sb?sb.textContent:''; if(sb){ sb.disabled=true; sb.textContent='Sending…'; }
    if(status){ status.textContent='Sending your request…'; status.style.color=''; }
    try{
      const fd=new FormData();
      if(FORM_KEY) fd.append('access_key',FORM_KEY);
      fd.append('botcheck','');
      fd.append('subject',subject);
      fd.append('from_name',name);
      fd.append('name',name);
      fd.append('email',email);
      if(phone) fd.append('phone',phone);
      fd.append('message',summary);
      const res=await fetch(FORM_ENDPOINT,{method:'POST',body:fd});
      let ok=res.ok; try{ const j=await res.clone().json(); if(typeof j.success!=='undefined') ok=j.success; }catch(e){}
      if(!ok) throw new Error('Submit failed ('+res.status+')');
      if(sb){ sb.disabled=false; sb.textContent=orig; }
      if(status){ status.textContent='✓ Sent! We’ll get back to you shortly to scope it out.'; status.style.color='var(--good)'; }
      setTimeout(closeComplex,1800);
    }catch(err){
      console.error('[BulkThreads] complex send failed',err);
      if(sb){ sb.disabled=false; sb.textContent=orig; }
      if(status){
        status.innerHTML='We couldn’t send it. <a href="#" id="cxFallback">Email us instead</a>, or try again.';
        const fb=document.getElementById('cxFallback'); if(fb) fb.onclick=function(e){e.preventDefault();closeComplex();const body=encodeURIComponent('Hi BulkThreads team,\n\nI have a complex order:\n\n'+summary+'\n\nThanks!');window.location.href='mailto:'+BT_QUOTE_EMAIL+'?subject='+encodeURIComponent(subject)+'&body='+body;};
      }
    }
  }
  (function(){
    const b=document.getElementById('complexBtn'); if(b) b.onclick=openComplex;
    const x=document.getElementById('cxClose'); if(x) x.onclick=closeComplex;
    const m=document.getElementById('complexModal'); if(m) m.addEventListener('click',function(e){ if(e.target.id==='complexModal') closeComplex(); });
    const s=document.getElementById('cxSend'); if(s) s.onclick=sendComplex;
  })();

  var PRICE_MATCH_ENDPOINT = (BT_CFG.pricematchEndpoint || '').trim();
  var PRICE_MATCH_MAX_BYTES = 10 * 1024 * 1024;
  var pmTsWidgetId=null, pmTsLoading=false;
  function ensurePmTurnstile(){
    if(!TURNSTILE_SITE_KEY) return;
    var el=document.getElementById('pmTurnstile'); if(!el) return;
    if(window.turnstile){ if(pmTsWidgetId===null){ try{ pmTsWidgetId=window.turnstile.render(el,{sitekey:TURNSTILE_SITE_KEY}); }catch(e){} } return; }
    if(pmTsLoading){ return; } pmTsLoading=true;
    var s=document.createElement('script');
    s.src='https://challenges.cloudflare.com/turnstile/v0/api.js'; s.async=true; s.defer=true;
    s.onload=function(){ try{ if(pmTsWidgetId===null) pmTsWidgetId=window.turnstile.render(el,{sitekey:TURNSTILE_SITE_KEY}); }catch(e){} };
    document.head.appendChild(s);
  }
  function getPmTurnstileToken(){
    try{ return (TURNSTILE_SITE_KEY && window.turnstile && pmTsWidgetId!==null) ? (window.turnstile.getResponse(pmTsWidgetId)||'') : ''; }catch(e){ return ''; }
  }
  function resetPmTurnstile(){ try{ if(window.turnstile && pmTsWidgetId!==null) window.turnstile.reset(pmTsWidgetId); }catch(e){} }
  function openPriceMatch(){ cxTrack('price_match_opened', cxContext()); document.getElementById('priceMatchModal').classList.add('show'); ensurePmTurnstile(); }
  function closePriceMatch(){ document.getElementById('priceMatchModal').classList.remove('show'); }
  async function sendPriceMatch(){
    const email=qval('pmEmail'), phone=qval('pmPhone');
    const fileEl=document.getElementById('pmFile');
    const file=fileEl && fileEl.files ? fileEl.files[0] : null;
    const sb=document.getElementById('pmSend'), status=document.getElementById('pmStatus');
    if(email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ alert('Please enter a valid email address.'); return; }
    if(!email && !phone){ alert('Please add an email or phone so we can reach you with the price match.'); return; }
    if(!file){ alert('Please attach the competitor invoice or quote.'); return; }
    if(file.size > PRICE_MATCH_MAX_BYTES){ alert('That file is over 10 MB. Please upload a smaller file.'); return; }
    const tsToken=getPmTurnstileToken();
    if(TURNSTILE_SITE_KEY && !tsToken){ ensurePmTurnstile(); if(status){ status.textContent='Please complete the “I’m human” check above, then tap submit again.'; status.style.color='var(--accent)'; } return; }
    const orig=sb?sb.textContent:''; if(sb){ sb.disabled=true; sb.textContent='Sending…'; }
    if(status){ status.textContent='Uploading your invoice…'; status.style.color=''; }
    try{
      const fd=new FormData();
      fd.append('name', qval('pmName'));
      fd.append('email', email);
      fd.append('phone', phone);
      fd.append('order_ref', qval('pmOrderRef'));
      fd.append('message', qval('pmMessage'));
      fd.append('website', qval('pmHp')); // honeypot
      if(tsToken) fd.append('cf-turnstile-response', tsToken);
      fd.append('invoice', file);
      const res=await fetch(PRICE_MATCH_ENDPOINT,{method:'POST',body:fd});
      let data={}; try{ data=await res.clone().json(); }catch(e){}
      if(!res.ok || !data.success) throw new Error((data && data.error) || ('Submit failed ('+res.status+')'));
      if(sb){ sb.disabled=false; sb.textContent=orig; }
      const f=document.getElementById('pmFile'); if(f) f.value='';
      resetPmTurnstile();
      if(status){ status.textContent='✓ Got it! We’ll review your invoice and follow up with a price match shortly.'; status.style.color='var(--good)'; }
      setTimeout(closePriceMatch,2200);
    }catch(err){
      console.error('[BulkThreads] price-match send failed',err);
      if(sb){ sb.disabled=false; sb.textContent=orig; }
      resetPmTurnstile();
      if(status){ status.textContent=(err && err.message) ? err.message : 'We couldn’t upload it. Please try again in a moment.'; status.style.color='var(--accent)'; }
    }
  }
  (function(){
    const b=document.getElementById('priceMatchBtn'); if(b) b.onclick=openPriceMatch;
    const x=document.getElementById('pmClose'); if(x) x.onclick=closePriceMatch;
    const m=document.getElementById('priceMatchModal'); if(m) m.addEventListener('click',function(e){ if(e.target.id==='priceMatchModal') closePriceMatch(); });
    const s=document.getElementById('pmSend'); if(s) s.onclick=sendPriceMatch;
  })();

  function download(url,name){const a=document.createElement('a');a.href=url;a.download=name;a.click();}

  Promise.all(fonts.map(f=>document.fonts.load(`16px "${f}"`).catch(()=>{})))
    .then(()=>canvas.renderAll());
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(()=>canvas.renderAll());

  const SAVE_KEY=PREMIUM_MODE?'btCustomizerState-premium':'btCustomizerState';
  let saveTimer=null;
  function scheduleSave(){ clearTimeout(saveTimer); saveTimer=setTimeout(persist,700); }
  function buildState(){
    if(!product) return null;
    saveView();
    const handle=((product.url||'').split('/products/')[1]||'').split('?')[0];
    if(!handle) return null;
    return {v:2,t:Date.now(),pm:PREMIUM_MODE,title:product.title,handle:handle,color:selectedColor,currentView:currentView,designs:designs,uploads:uploads};
  }
  function persist(){
    try{
      const state=buildState();
      if(!state) return;
      let str=JSON.stringify(state);
      if(str.length>4500000){ state.uploads=[]; str=JSON.stringify(state); }  // too big → drop the uploads tray
      localStorage.setItem(SAVE_KEY,str);
    }catch(e){ /* quota exceeded or storage disabled — skip silently */ }
  }
  async function restoreState(s){
    try{
      pendingColor=s.color||null;
      await selectGroup({title:s.title, handles:[s.handle], image:''});
      if(s.uploads&&s.uploads.length){ uploads=s.uploads; renderUploads(); }
      if(s.designs){ designs=s.designs; }
      const target=(s.currentView&&designs[s.currentView]!==undefined)?s.currentView:currentView;
      if(target) setView(target);
    }catch(e){ console.error('[BulkThreads] restore failed',e); }
  }
  function tryRestore(){
    // One-shot wipe. Clearing in memory and reloading raced with autosave: something
    // re-saved the old designs{} before the reload landed, so art in non-current views
    // survived "Start over". The flag is set just before reload and honoured here, ahead
    // of any restore or save.
    try{
      if(sessionStorage.getItem('bt_cx_wipe')==='1'){
        sessionStorage.removeItem('bt_cx_wipe');
        localStorage.removeItem(SAVE_KEY);
        designs={}; uploads=[]; currentView=null;
        return;
      }
    }catch(e){}
    let raw; try{ raw=localStorage.getItem(SAVE_KEY); }catch(e){ return; }
    if(!raw) return;
    let s; try{ s=JSON.parse(raw); }catch(e){ return; }
    if(!s||s.v!==2||!s.handle) return;   // v2 = namespaced + mode-tagged; ignore legacy v1 saves (could bleed across modes)
    if(!!s.pm!==!!PREMIUM_MODE){ try{ localStorage.removeItem(SAVE_KEY); }catch(e){} return; }
    if(s.t&&(Date.now()-s.t)>7*24*3600*1000) return;   // ignore saves older than 7 days
    restoreState(s);
  }

  /* ============================================================
     SAVE / SHARE DESIGNS
     Save POSTs the design to the Worker's KV-backed /d endpoint and gets back a
     short id → a shareable link that reopens it on any device. The "My designs"
     list is per-browser (localStorage); share links carry a design across devices.
     ============================================================ */
  // "Start over" — the saved design is restored from localStorage on every visit, so a
  // half-finished job (and its art) can follow a customer back days later and keep being
  // billed. Before this there was no way for them to clear it. Two-step so a stray click
  // cannot wipe real work; no native confirm() dialog.
  (function(){
    var btn=document.getElementById('startOverBtn'), wrap=document.getElementById('startOverWrap');
    if(!btn||!wrap) return;
    var armed=false, t=null, label=btn.textContent;
    function disarm(){ armed=false; btn.classList.remove('arm'); btn.textContent=label; if(t){clearTimeout(t);t=null;} }
    // Show only when there is real work to lose. The key itself is not the test: the app
    // re-saves the chosen garment immediately on load, so keying off SAVE_KEY left the
    // button offering to clear a design that no longer existed.
    function hasSaved(){
      try{
        if((uploads||[]).length) return true;
        var d=designs||{};
        return Object.keys(d).some(function(k){ return d[k] && d[k].objects && d[k].objects.length; });
      }catch(e){ return false; }
    }
    function refresh(){ wrap.hidden=!hasSaved(); }
    btn.onclick=function(){
      if(!armed){ armed=true; btn.classList.add('arm'); btn.textContent='Tap again to erase this design';
        t=setTimeout(disarm,4000); return; }
      try{ cxTrack('design_cleared',{}); }catch(e){}
      try{ sessionStorage.setItem('bt_cx_wipe','1'); }catch(e){}
      try{ localStorage.removeItem(SAVE_KEY); }catch(e){}
      designs={}; uploads=[]; currentView=null;
      location.href=location.pathname;    // reload clean, drop any ?design= in the url
    };
    refresh();
    setInterval(refresh, 4000);
  })();

  const MY_DESIGNS_KEY=PREMIUM_MODE?'btCustomizerDesigns-premium':'btCustomizerDesigns';
  function getMyDesigns(){ try{ return JSON.parse(localStorage.getItem(MY_DESIGNS_KEY))||[]; }catch(e){ return []; } }
  function setMyDesigns(list){ try{ localStorage.setItem(MY_DESIGNS_KEY, JSON.stringify(list)); }catch(e){} }
  function addMyDesign(entry){
    const list=getMyDesigns().filter(d=>d.id!==entry.id);
    list.unshift(entry);
    setMyDesigns(list.slice(0,30));    // keep the 30 most recent
    renderMyDesigns();
  }
  function removeMyDesign(id){ setMyDesigns(getMyDesigns().filter(d=>d.id!==id)); renderMyDesigns(); }
  function daysAgo(t){ if(!t) return ''; const d=Math.floor((Date.now()-t)/86400000); return d<=0?'today':(d===1?'1 day ago':d+' days ago'); }
  function renderMyDesigns(){
    const wrap=document.getElementById('myDesigns'), list=document.getElementById('myDesignsList');
    if(!wrap||!list) return;
    const items=getMyDesigns();
    if(!items.length){ wrap.style.display='none'; list.innerHTML=''; return; }
    wrap.style.display=''; list.innerHTML='';
    items.forEach(function(d){
      const row=document.createElement('div'); row.className='saved-item';
      const main=document.createElement('button'); main.type='button'; main.className='si-main';
      const t=document.createElement('div'); t.className='si-title'; t.textContent=d.title||'Saved design';
      const m=document.createElement('div'); m.className='si-meta'; m.textContent=(d.color?d.color+' · ':'')+daysAgo(d.t);
      main.appendChild(t); main.appendChild(m); main.onclick=function(){ loadDesignById(d.id); };
      const del=document.createElement('button'); del.className='si-del'; del.title='Remove'; del.innerHTML='✕';
      del.onclick=function(e){ e.stopPropagation(); removeMyDesign(d.id); };
      row.appendChild(main); row.appendChild(del); list.appendChild(row);
    });
  }
  function shareLinkFor(id){ return window.location.origin+window.location.pathname+'?design='+encodeURIComponent(id); }

  async function saveDesign(){
    if(!DESIGN_ENABLED||!DESIGN_API_BASE) return;
    if(!product){ alert('Please pick a product and add your design first.'); return; }
    const state=buildState(); if(!state){ alert('Nothing to save yet.'); return; }
    let str=JSON.stringify(state);
    if(str.length>5500000){ state.uploads=[]; str=JSON.stringify(state); }   // stay under the Worker's 6MB cap
    const btn=document.getElementById('saveShare'); const orig=btn?btn.textContent:'';
    if(btn){ btn.disabled=true; btn.textContent='Saving…'; }
    try{
      const res=await fetch(DESIGN_API_BASE,{method:'POST',headers:{'Content-Type':'application/json'},body:str});
      if(!res.ok) throw new Error('HTTP '+res.status);
      const data=await res.json();
      if(!data||!data.id) throw new Error('no id');
      addMyDesign({id:data.id,title:product.title,color:selectedColor||'',t:Date.now()});
      showShareModal(data.id);
    }catch(e){
      console.error('[BulkThreads] design save failed',e);
      alert('Sorry — saving your design failed. Please try again.');
    }finally{
      if(btn){ btn.disabled=false; btn.textContent=orig; }
    }
  }
  async function loadDesignById(id){
    if(!DESIGN_API_BASE||!id) return;
    try{
      const res=await fetch(DESIGN_API_BASE+'/'+encodeURIComponent(id),{headers:{'Accept':'application/json'}});
      if(!res.ok) throw new Error('HTTP '+res.status);
      const s=await res.json();
      if(!s||!s.handle) throw new Error('bad design');
      await restoreState(s);
    }catch(e){
      console.error('[BulkThreads] design load failed',e);
      alert('Sorry — that design link could not be opened.');
    }
  }
  function showShareModal(id){
    const inp=document.getElementById('shareUrl'), st=document.getElementById('smStatus');
    if(inp) inp.value=shareLinkFor(id);
    if(st) st.textContent='';
    document.getElementById('shareModal').classList.add('show');
  }
  function closeShareModal(){ document.getElementById('shareModal').classList.remove('show'); }

  if(DESIGN_ENABLED && DESIGN_API_BASE){
    const ss=document.getElementById('saveShare');
    if(ss){ ss.style.display=''; ss.onclick=saveDesign; }
    document.getElementById('smClose').onclick=closeShareModal;
    document.getElementById('shareModal').addEventListener('click',function(e){ if(e.target.id==='shareModal') closeShareModal(); });
    const cp=document.getElementById('shareCopy');
    if(cp) cp.onclick=function(){
      const inp=document.getElementById('shareUrl'); if(!inp) return;
      inp.focus(); inp.select();
      const done=function(){ const st=document.getElementById('smStatus'); if(st) st.textContent='Link copied to your clipboard.'; };
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(inp.value).then(done,function(){ try{document.execCommand('copy');done();}catch(e){} }); }
      else { try{ document.execCommand('copy'); done(); }catch(e){} }
    };
    renderMyDesigns();
  }

  /* ============================================================
     CREATE A TEAM STORE
     Publishes the current design as a roster store via the Worker /ts API and
     hands the coordinator a member link + a private roster link.
     ============================================================ */
  const TS_LAST_KEY='bt_ts_last';   // last store this browser created, to offer "add to it"
  let tsStaged=[];                  // products already added to the store being built

  // Identity includes the ARTWORK, not just blank+color — a store legitimately holds
  // the same tee in six colors, and the same tee+color with two different designs.
  // This exists only so the garment still on screen isn't published twice; anything
  // the user actually changed counts as a new product.
  function tsHash(s){ let h=5381; for(let i=0;i<s.length;i++){ h=((h<<5)+h+s.charCodeAt(i))|0; } return String(h); }
  function tsDesignHash(){ try{ return tsHash(JSON.stringify(designs||{})); }catch(e){ return '0'; } }
  function tsCurrentSig(){
    const handle=(((product&&product.url)||'').split('/products/')[1]||'').split('?')[0];
    return handle+'|'+(selectedColor||'')+'|'+tsDesignHash();
  }
  function tsCurrentStaged(){ const s=tsCurrentSig(); return tsStaged.some(function(it){ return it.sig===s; }); }

  // Everything that will be published: what's been added, plus what's on screen now.
  function tsCount(){ return tsStaged.length+((product&&!tsCurrentStaged())?1:0); }

  // Decoration is chosen per product — screen-print the tees, embroider the caps.
  const TS_METHOD_OPTS=[['','Method…'],['screenprint','Screen print'],['dtf','DTF transfer'],['dtg','DTG print'],['embroidery','Embroidery']];
  let tsCurrentMethod='';   // method for the garment on screen, until it's staged

  function tsMethodSelect(attr,val){
    return '<select '+attr+' style="margin-top:4px;font-size:12.5px;padding:4px 6px;border:1px solid var(--line);border-radius:6px;max-width:150px">'+
      TS_METHOD_OPTS.map(function(o){ return '<option value="'+o[0]+'"'+(o[0]===(val||'')?' selected':'')+'>'+o[1]+'</option>'; }).join('')+
    '</select>';
  }

  function tsRow(title,color,thumb,note,removeIdx,methodAttr,methodVal){
    return '<div style="display:flex;gap:10px;align-items:center;padding:8px 0;border-bottom:1px solid var(--line)">'+
      (thumb?('<img src="'+thumb+'" alt="" style="width:40px;height:40px;object-fit:contain;background:var(--paper);border:1px solid var(--line);border-radius:6px;flex:none">')
            :'<div style="width:40px;height:40px;border:1px solid var(--line);border-radius:6px;flex:none"></div>')+
      '<div style="flex:1;min-width:0;font-size:13.5px;font-weight:600;line-height:1.3">'+_artEsc(title)+
        (color?('<div style="font-weight:500;color:var(--ink-2)">'+_artEsc(color)+'</div>'):'')+
        (note?('<div style="font-weight:500;color:var(--accent);font-size:12.5px">'+_artEsc(note)+'</div>'):'')+
        (methodAttr?tsMethodSelect(methodAttr,methodVal):'')+'</div>'+
      (removeIdx!=null?('<button type="button" class="qm-cartbtn" data-tsrm="'+removeIdx+'">Remove</button>'):'')+
    '</div>';
  }

  function renderTsProducts(){
    const box=document.getElementById('tsProducts'); if(!box) return;
    let html=tsStaged.map(function(it,i){
      return tsRow(it.productTitle||'Product',it.color,it.mockup,'',i,'data-tsm="'+i+'"',it.method);
    }).join('');
    if(product){
      html+=tsCurrentStaged()
        ? tsRow(product.title||'Product',selectedColor||'',' ','Already added — pick a different blank to add another',null,'',null)
        : tsRow(product.title||'Product',selectedColor||'','','On screen now — included when you create the store',null,'data-tscm="1"',tsCurrentMethod);
    }
    box.innerHTML=html||'<p class="qm-foot" style="margin:0">No products yet.</p>';
    Array.prototype.forEach.call(box.querySelectorAll('[data-tsrm]'),function(b){
      b.onclick=function(){ tsStaged.splice(parseInt(b.getAttribute('data-tsrm'),10),1); renderTsProducts(); tsSyncButton(); };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-tsm]'),function(s){
      s.onchange=function(){ tsStaged[parseInt(s.getAttribute('data-tsm'),10)].method=s.value; };
    });
    const cur=box.querySelector('[data-tscm]');
    if(cur) cur.onchange=function(){ tsCurrentMethod=cur.value; };
  }

  // Show the product count on the toolbar button so a half-built store isn't forgotten.
  function tsSyncButton(){
    const b=document.getElementById('teamStore'); if(!b) return;
    const n=tsStaged.length;
    const label=b.querySelector('.ts-count');
    if(n&&!label){ b.insertAdjacentHTML('beforeend',' <span class="ts-count">('+n+')</span>'); }
    else if(n&&label){ label.textContent='('+n+')'; }
    else if(label){ label.remove(); }
  }

  function tsSetMode(){
    const mode=((document.getElementById('tsMode')||{}).value||'new');
    const existing=(mode==='add'||mode==='replace');
    const mi=document.getElementById('tsManageIn');
    if(mi) mi.style.display=existing?'':'none';
    const rw=document.getElementById('tsReplaceWrap');
    if(rw) rw.style.display=(mode==='replace')?'':'none';
    ['tsOrg','tsDeadline'].forEach(function(id){
      const f=document.getElementById(id); if(f&&f.parentNode) f.parentNode.style.display=existing?'none':'';
    });
    const btn=document.getElementById('tsCreate');
    if(btn) btn.textContent=(mode==='replace')?'Replace the selected product'
                          :(mode==='add')?'Add to my existing store':'Create store & get link';
    if(mode==='replace') loadReplaceTargets();
  }

  // Populate the "which product am I replacing?" list from the pasted roster link.
  let _tsReplaceFor='';
  function loadReplaceTargets(){
    const sel=document.getElementById('tsReplaceItem'); if(!sel) return;
    const t=parseManageLink((document.getElementById('tsManageIn')||{}).value);
    if(!t){ sel.innerHTML='<option value="">Paste the roster link above first…</option>'; _tsReplaceFor=''; return; }
    if(_tsReplaceFor===t.storeId) return;                 // already loaded for this store
    _tsReplaceFor=t.storeId;
    sel.innerHTML='<option value="">Loading the store…</option>';
    fetch(TS_API_BASE+'/'+encodeURIComponent(t.storeId),{headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(store){
        const items=(store.items||[]);
        if(!items.length){ sel.innerHTML='<option value="">That store has no products</option>'; return; }
        sel.innerHTML='<option value="">Choose the product to replace…</option>'+items.map(function(it){
          return '<option value="'+it.id+'">'+_artEsc((it.productTitle||'Item')+(it.color?(' — '+it.color):''))+'</option>';
        }).join('');
      })
      .catch(function(){ _tsReplaceFor=''; sel.innerHTML='<option value="">Could not load that store — check the link</option>'; });
  }

  function openTeamStore(){
    if(!product){ alert('Please pick a product and finish your design first.'); return; }
    const sizes=(product&&product.sizes)||[];
    const ctx=document.getElementById('tsContext');
    if(ctx){
      ctx.innerHTML=sizes.length
        ? ('Sizes members can pick for <b>'+_artEsc(product.title||'this product')+'</b>: '+_artEsc(sizes.join(', ')))
        : '<span style="color:var(--accent)">This product has no sizes, so members could not pick one.</span>';
    }
    // "Add to an existing store" is ALWAYS available — a store can be added to weeks
    // later, from any browser, using the roster link. If this browser is the one that
    // made it we can name it and fill the link in; otherwise they paste it.
    let last=null;
    try{ last=JSON.parse(localStorage.getItem(TS_LAST_KEY)||'null'); }catch(e){}
    const wrap=document.getElementById('tsExistingWrap');
    if(wrap) wrap.style.display='';
    const opt=document.getElementById('tsAddOpt');
    const mi=document.getElementById('tsManageIn');
    if(last&&last.storeId&&last.manageToken){
      if(opt) opt.textContent='Add these products to '+(last.orgName?('“'+last.orgName+'”'):'my existing store');
      if(mi&&!mi.value) mi.value=tsLink(last.storeId,last.manageToken);
    }else if(opt){
      opt.textContent='Add these products to an existing store (paste its roster link)';
    }
    const ms=document.getElementById('tsMode'); if(ms) ms.value='new';
    tsSetMode();
    saveView();   // keep the signature honest before we render the list
    // Seed the method from the order form if they already picked one there.
    if(!tsCurrentMethod){ try{ tsCurrentMethod=currentMethod()||''; }catch(e){} }
    renderTsProducts();
    const st=document.getElementById('tsStatus'); if(st) st.textContent='';
    const btn=document.getElementById('tsCreate'); if(btn) btn.disabled=false;
    document.getElementById('tsModal').classList.add('show');
  }
  function closeTeamStore(){ document.getElementById('tsModal').classList.remove('show'); }

  /* "+ Add another product" — bank the garment on screen, then go back to the
     product picker for the next one. The artwork stays on the canvas, so the
     common case (same logo on a tee and a hoodie) is just: swap the blank. */
  async function stageTeamStoreProduct(){
    if(!product){ alert('Please pick a product first.'); return; }
    if(!((product&&product.sizes)||[]).length){ alert('This product has no sizes, so members couldn’t pick one. Choose a product with sizes.'); return; }
    saveView();   // fold the live canvas into `designs` FIRST so the signature sees the latest artwork
    if(tsCurrentStaged()){ alert('This exact product, color and design is already in the store.\n\nChange the color or the artwork and add it again — the same blank in several colors, or one blank with different designs, is fine.'); return; }
    const btn=document.getElementById('tsAddProduct');
    const orig=btn?btn.textContent:''; if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
    try{
      tsStaged.push(await buildTsItem());
      tsSyncButton();
      closeTeamStore();
      if(typeof goTab==='function') goTab('product');
      try{ const sb=document.getElementById('searchInput'); if(sb) sb.focus(); }catch(e){}
    }catch(e){
      console.error('[BulkThreads] staging a team-store product failed',e);
      alert('Sorry — adding that product failed. Please try again.');
    }finally{ if(btn){ btn.disabled=false; btn.textContent=orig; } }
  }

  /* The full mockup is 1176x1400 PNG (~1.5-3MB as a data URL). A team store shows
     it at 320px on a member card and 64px in the modal, and a 12-product store was
     blowing the Worker's payload cap outright — so store a downscaled JPEG instead.
     Composited on white first: the garment photo is letterboxed with transparency,
     which JPEG would otherwise render black. Falls back to the original on any error. */
  // 1200px keeps the full-size preview on the store page sharp (real stores measured
  // ~36KB at 700px, so there's room). Safe now that products upload one per request.
  const TS_MOCKUP_MAX=1200, TS_MOCKUP_Q=0.85;
  function tsShrinkMockup(dataUrl){
    return new Promise(function(resolve){
      if(!dataUrl||dataUrl.indexOf('data:image')!==0) return resolve(dataUrl||'');
      const img=new Image();
      img.onload=function(){
        try{
          const w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
          if(!w||!h) return resolve(dataUrl);
          const sc=Math.min(1,TS_MOCKUP_MAX/Math.max(w,h));
          const c=document.createElement('canvas');
          c.width=Math.max(1,Math.round(w*sc)); c.height=Math.max(1,Math.round(h*sc));
          const cx=c.getContext('2d');
          cx.fillStyle='#ffffff'; cx.fillRect(0,0,c.width,c.height);
          cx.drawImage(img,0,0,c.width,c.height);
          const out=c.toDataURL('image/jpeg',TS_MOCKUP_Q);
          resolve((out&&out.length<dataUrl.length)?out:dataUrl);
        }catch(e){ resolve(dataUrl); }
      };
      img.onerror=function(){ resolve(dataUrl); };
      img.src=dataUrl;
    });
  }

  /* Snapshot the current design as one team-store item: flatten the canvas to a
     mockup and park the editable state so the design can be reopened later. */
  async function buildTsItem(){
    saveView();
    let mockup='';
    try{ if(document.fonts&&document.fonts.ready) await document.fonts.ready; }catch(e){}
    try{ mockup = currentView ? ((await renderViewMockup(currentView, designs[currentView]))||'') : ''; }catch(e){ mockup=''; }
    try{ mockup = await tsShrinkMockup(mockup); }catch(e){}
    let designId='';
    try{
      const state=buildState();
      if(state && DESIGN_API_BASE){
        let str=JSON.stringify(state); if(str.length>5500000){ state.uploads=[]; str=JSON.stringify(state); }
        const dr=await fetch(DESIGN_API_BASE,{method:'POST',headers:{'Content-Type':'application/json'},body:str});
        if(dr.ok){ const dj=await dr.json(); designId=(dj&&dj.id)||''; }
      }
    }catch(e){}
    const handle=((product.url||'').split('/products/')[1]||'').split('?')[0];
    // `sig` is client-side bookkeeping only — the Worker ignores unknown fields.
    return { productTitle:product.title, handle:handle, color:selectedColor||'', sizes:(product&&product.sizes)||[],
             method:tsCurrentMethod||'', mockup:mockup, designId:designId, sig:tsCurrentSig() };
  }

  // Pull the store id + manage token out of a pasted roster link.
  function parseManageLink(raw){
    const s=(raw||'').trim();
    if(!s) return null;
    let store='', manage='';
    try{
      const u=new URL(s, window.location.origin);
      store=(u.searchParams.get('store')||'').trim();
      manage=(u.searchParams.get('manage')||'').trim();
    }catch(e){
      const m=s.match(/[?&]store=([^&\s]+)/), g=s.match(/[?&]manage=([^&\s]+)/);
      store=m?decodeURIComponent(m[1]):''; manage=g?decodeURIComponent(g[1]):'';
    }
    return (store&&manage)?{storeId:store,manageToken:manage}:null;
  }

  async function submitTeamStore(){
    if(!TS_ENABLED||!TS_API_BASE) return;
    const mode=(document.getElementById('tsMode')||{}).value||'new';
    // The garment on screen counts too — unless it's already in the list.
    // (Replace only ever uses the on-screen garment, so the list rules don't apply.)
    const includeCurrent=!!product && !tsCurrentStaged();
    if(mode!=='replace'){
      if(includeCurrent && !((product&&product.sizes)||[]).length){
        alert('The product on screen has no sizes, so members couldn’t pick one. Remove it or choose a product with sizes.'); return;
      }
      if(!tsStaged.length && !includeCurrent){ alert('Add at least one product to the store first.'); return; }
    }else if(!((product&&product.sizes)||[]).length){
      alert('The replacement product has no sizes, so members couldn’t pick one. Choose a product with sizes.'); return;
    }

    let target=null, org='', deadline='', replaceId='';
    if(mode==='add'||mode==='replace'){
      target=parseManageLink((document.getElementById('tsManageIn')||{}).value);
      if(!target){ alert('Please paste your private roster link — the one with “manage=” in it.'); return; }
      if(mode==='replace'){
        replaceId=((document.getElementById('tsReplaceItem')||{}).value||'').trim();
        if(!replaceId){ alert('Please choose which product you want to replace.'); return; }
        if(!product){ alert('Please pick the replacement product first.'); return; }
        if(tsStaged.length) { if(!confirm('Only the garment on screen will be used as the replacement — the '+tsStaged.length+' product(s) in your list below are ignored in this mode.\n\nContinue?')) return; }
      }
    }else{
      org=(document.getElementById('tsOrg').value||'').trim();
      deadline=(document.getElementById('tsDeadline').value||'').trim();
      if(!org){ alert('Please enter a team / organization name.'); return; }
    }

    const btn=document.getElementById('tsCreate'); const st=document.getElementById('tsStatus');
    const orig=btn?btn.textContent:''; if(btn){ btn.disabled=true; btn.textContent=(mode==='replace')?'Replacing…':(mode==='add'?'Adding…':'Creating…'); }
    if(st) st.textContent='Saving your design'+(tsCount()>1?'s':'')+'…';
    try{
      // Replace swaps ONE product in place, keeping its id so member orders survive.
      if(mode==='replace'){
        if(st) st.textContent='Saving your design…';
        const item=await buildTsItem();
        const url=TS_API_BASE+'/'+encodeURIComponent(target.storeId)+'/product/'+encodeURIComponent(replaceId)+'/replace?manage='+encodeURIComponent(target.manageToken);
        const res=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(item)});
        const data=await res.json().catch(function(){ return null; });
        if(!res.ok) throw new Error((data&&data.error)||('HTTP '+res.status));
        closeTeamStore();
        showTeamStoreLinks(target.storeId, target.manageToken, null);
        const kept=(data&&data.ordered)||0;
        alert('Swapped in “'+(product.title||'the new product')+(selectedColor?(' — '+selectedColor):'')+'”.'+
              (kept?('\n\n'+kept+' order line(s) members already placed stayed attached to it.'):''));
        return;
      }

      const items=tsStaged.slice();
      if(includeCurrent) items.push(await buildTsItem());

      // Send ONE product per request. A store full of mockups in a single POST
      // blows the payload cap (and any hiccup loses the whole thing) — this way
      // each request is small and the user sees progress.
      let storeId, manageToken, lastData=null, doneCount=0;
      if(mode==='add'){
        storeId=target.storeId; manageToken=target.manageToken;
      }else{
        if(st) st.textContent='Creating the store…';
        const res=await fetch(TS_API_BASE,{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({ orgName:org, deadline:deadline, items:[items[0]] })});
        const data=await res.json().catch(function(){ return null; });
        if(!res.ok) throw new Error((data&&data.error)||('HTTP '+res.status));
        if(!data||!data.storeId||!data.manageToken) throw new Error('bad response');
        storeId=data.storeId; manageToken=data.manageToken; lastData=data; doneCount=1;
        try{ localStorage.setItem(TS_LAST_KEY, JSON.stringify({storeId:storeId,manageToken:manageToken,orgName:org})); }catch(e){}
      }

      for(let i=(mode==='add'?0:1);i<items.length;i++){
        if(st) st.textContent='Adding product '+(i+1)+' of '+items.length+'…';
        const url=TS_API_BASE+'/'+encodeURIComponent(storeId)+'/product?manage='+encodeURIComponent(manageToken);
        const res=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(items[i])});
        const data=await res.json().catch(function(){ return null; });
        if(!res.ok){
          // The store exists and holds everything up to here — hand over the links
          // rather than losing the lot, and say exactly what didn't make it.
          const failed=items.slice(i).map(function(x){ return x.productTitle||'a product'; }).join(', ');
          tsStaged=items.slice(i); tsSyncButton();
          closeTeamStore();
          showTeamStoreLinks(storeId, manageToken, (lastData&&lastData.items)||null);
          alert((mode==='add'
                  ? (doneCount+' product'+(doneCount===1?' was':'s were')+' added, but these could not be: ')
                  : ('Your store was created with '+doneCount+' product'+(doneCount===1?'':'s')+', but these could not be added: '))+failed+
                '\n\nReason: '+((data&&data.error)||('HTTP '+res.status))+
                '\n\nThey are still in your list — open Team store again and use "Add these products to" your store to retry.');
          return;
        }
        lastData=data; doneCount++;
      }

      tsStaged=[]; tsSyncButton();
      closeTeamStore();
      showTeamStoreLinks(storeId, manageToken, (lastData&&lastData.items)||null);
    }catch(e){
      console.error('[BulkThreads] team store '+mode+' failed',e);
      if(st) st.textContent='';
      alert((mode==='add' ? 'Sorry — adding to the store failed.' : 'Sorry — creating the team store failed.')+
            '\n\n'+(e.message||'Unknown error')+
            (mode==='add' ? '\n\nCheck that your roster link is correct and the store is still open.' : ''));
    }finally{
      if(btn){ btn.disabled=false; btn.textContent=orig; }
    }
  }

  function tsLink(storeId, manageToken){
    const base=window.location.origin+TS_PAGE+'?store='+encodeURIComponent(storeId);
    return manageToken ? (base+'&manage='+encodeURIComponent(manageToken)) : base;
  }
  function showTeamStoreLinks(storeId, manageToken, items){
    const m=document.getElementById('tsMemberUrl'), g=document.getElementById('tsManageUrl');
    if(m) m.value=tsLink(storeId,'');
    if(g) g.value=tsLink(storeId,manageToken);
    const st=document.getElementById('tsDoneStatus');
    if(st) st.textContent=(items&&items.length>1)
      ? ('This store now has '+items.length+' products: '+items.map(function(i){ return i.productTitle||'item'; }).join(', ')+'.')
      : '';
    document.getElementById('tsDoneModal').classList.add('show');
  }
  function closeTeamStoreDone(){ document.getElementById('tsDoneModal').classList.remove('show'); }
  function copyInput(inputId, statusId){
    const inp=document.getElementById(inputId); if(!inp) return;
    inp.focus(); inp.select();
    const done=function(){ const st=document.getElementById(statusId); if(st) st.textContent='Copied to your clipboard.'; };
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(inp.value).then(done,function(){ try{document.execCommand('copy');done();}catch(e){} }); }
    else { try{ document.execCommand('copy'); done(); }catch(e){} }
  }

  if(TS_ENABLED && TS_API_BASE){
    const tb=document.getElementById('teamStore');
    if(tb){ tb.style.display=''; tb.onclick=openTeamStore; }
    document.getElementById('tsClose').onclick=closeTeamStore;
    document.getElementById('tsModal').addEventListener('click',function(e){ if(e.target.id==='tsModal') closeTeamStore(); });
    document.getElementById('tsCreate').onclick=submitTeamStore;
    const tsm=document.getElementById('tsMode'); if(tsm) tsm.onchange=tsSetMode;
    // Re-read the store whenever the roster link changes, so the replace list matches it.
    const tsmi=document.getElementById('tsManageIn'); if(tsmi){ tsmi.onchange=loadReplaceTargets; tsmi.onblur=loadReplaceTargets; }
    const tsap=document.getElementById('tsAddProduct'); if(tsap) tsap.onclick=stageTeamStoreProduct;
    document.getElementById('tsDoneClose').onclick=closeTeamStoreDone;
    document.getElementById('tsDoneModal').addEventListener('click',function(e){ if(e.target.id==='tsDoneModal') closeTeamStoreDone(); });
    const cm=document.getElementById('tsCopyMember'); if(cm) cm.onclick=function(){ copyInput('tsMemberUrl','tsDoneStatus'); };
    const cg=document.getElementById('tsCopyManage'); if(cg) cg.onclick=function(){ copyInput('tsManageUrl','tsDoneStatus'); };
  }

  function preselectByHandle(handle){
    fetchProduct(handle).then(p=>{
      selectGroup({title:p.title, image:p.featured_image||(p.images&&p.images[0])||'', handles:[handle]});
    }).catch(e=>console.error('[BulkThreads] preselect failed',e));
  }
  (function(){
    try{
      const params=new URLSearchParams(window.location.search);
      const did=params.get('design');
      if(did){ loadDesignById(did.trim()); return; }      // shared/saved design link
      const brand=params.get('brand');                    // landing-page logo deep link → open the picker filtered to that brand
      if(brand && PREMIUM_MODE){ try{ goTab('product'); }catch(e){} var si=document.getElementById('prodSearch'); if(si) si.value=brand.trim(); runSearch(brand.trim(), false); return; }
      const ph=params.get('product');
      if(ph){ pendingColor=params.get('color')||null; preselectByHandle(ph.trim()); return; }
    }catch(e){}
    tryRestore();   // no deep link → restore any in-progress design
  })();

  /* ============================================================
     LIVE PRICING ENGINE (screen print) — gated by 'live_pricing' setting
     ============================================================ */
  var PRICE_RATES=null, DISCOUNTS=null, SHIP_SET=null, pricingReady=false;

  function loadPricing(){
    if(!PRICING_ENABLED || pricingReady) return;
    pricingReady=true;
    Promise.all([
      fetch(PRICING_RATES_URL).then(function(r){return r.json();}).catch(function(){return null;}),
      fetch(DISCOUNT_DATA_URL).then(function(r){return r.json();}).catch(function(){return null;}),
      fetch(SHIPPING_DATA_URL).then(function(r){return r.json();}).catch(function(){return null;})
    ]).then(function(res){
      PRICE_RATES=res[0]; DISCOUNTS=res[1];
      SHIP_SET=new Set((res[2]&&res[2].upcharge)||[]);
      if(isPricingActive()) syncPriceFlow();
    });
  }
  function currentMethod(){
    if(!PRICING_ENABLED) return null;
    var m=document.getElementById('decoType'); if(!m) return null;
    var v=m.value||'';
    if(/screen/i.test(v)) return 'screenprint';
    if(/dtf|direct-to-film/i.test(v)) return 'dtf';
    if(/dtg|direct-to-garment/i.test(v)) return 'dtg';
    if(/embroider/i.test(v)) return 'embroidery';
    return null;
  }
  function isPricingActive(){ return !!currentMethod(); }
  function methodCfg(){ return (PRICE_RATES && PRICE_RATES[currentMethod()]) || (PRICE_RATES && PRICE_RATES.screenprint) || {}; }
  function chk(id){ var e=document.getElementById(id); return !!(e&&e.checked); }
  function discountGroupOf(handle){ return (DISCOUNTS&&DISCOUNTS.products&&DISCOUNTS.products[handle])||null; }
  function shipUpchargeOf(handle){ return !!(SHIP_SET&&SHIP_SET.has(handle)); }

  var ZIP3_RANGES=[
    [5,5,'NY'],[6,7,'PR'],[8,8,'VI'],[9,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],
    [50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[90,98,'AE'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],
    [200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],
    [300,319,'GA'],[320,339,'FL'],[340,340,'AA'],[341,349,'FL'],[350,369,'AL'],[370,385,'TN'],
    [386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],
    [500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],
    [600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],
    [730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],
    [850,865,'AZ'],[870,884,'NM'],[889,898,'NV'],[900,961,'CA'],[962,966,'AP'],[967,968,'HI'],
    [969,969,'GU'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']
  ];
  var STATE_NAMES={AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington DC',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',PR:'Puerto Rico',VI:'U.S. Virgin Islands',GU:'Guam',AS:'American Samoa',MP:'N. Mariana Islands',AA:'an APO/FPO address',AE:'an APO/FPO address',AP:'an APO/FPO address'};
  function zipToState(zip){
    var m=String(zip||'').trim().match(/^(\d{3})\d{0,2}$/); if(!m) return null;
    var p=parseInt(m[1],10);
    for(var i=0;i<ZIP3_RANGES.length;i++){ if(p>=ZIP3_RANGES[i][0]&&p<=ZIP3_RANGES[i][1]) return ZIP3_RANGES[i][2]; }
    return null;
  }
  function shipDest(){
    var raw=(qval('qZip')||'').trim();
    var complete=/^\d{5}(-\d{4})?$/.test(raw);
    var state=zipToState(raw);
    var cfg=(PRICE_RATES&&PRICE_RATES.shipping)||{};
    var noShip=!!(state && (cfg.noShip||[]).indexOf(state)>=0);
    var tier=(state && cfg.stateTier && cfg.stateTier[state]) || null;
    return { raw:raw, complete:complete, valid:!!state, state:state, tier:tier, noShip:noShip };
  }
  function updateZipNote(){
    var dest=shipDest();
    var note=document.getElementById('qZipNote');
    var co=document.getElementById('pfCheckout');
    var msg='', color='var(--ink-2)';
    if(dest.raw){
      if(dest.noShip){ msg='✕ Sorry — we don’t ship to '+(STATE_NAMES[dest.state]||dest.state)+'. (AK, HI, U.S. territories & APO/FPO aren’t serviceable.)'; color='var(--accent)'; }
      else if(dest.complete && !dest.valid){ msg='Please enter a valid U.S. ZIP code.'; color='var(--accent)'; }
      else if(dest.valid){ var tn={1:'West',2:'Midwest',3:'East'}[dest.tier]||''; msg='Ships to '+(STATE_NAMES[dest.state]||dest.state)+(tn?(' · '+tn+' region'):''); color='var(--ink-2)'; }
    }
    if(note){ note.textContent=msg; note.style.color=color; note.style.display=msg?'':'none'; }
    if(co){ co.disabled=!!dest.noShip; co.style.opacity=dest.noShip?'.55':''; co.style.cursor=dest.noShip?'not-allowed':''; }
    return dest;
  }

  function garmentSubtotal(){
    if(!product||!product.priceBySize) return 0;
    var pbs=product.priceBySize, ap=product.activePrices||null, sum=0;
    function priceFor(k){
      if(ap){ if(ap[k]!=null) return ap[k]; if(ap['__all__']!=null) return ap['__all__']; }
      if(pbs[k]!=null) return pbs[k]; return pbs['__all__'];
    }
    var grid=document.getElementById('sizeGrid');
    if(grid && grid.style.display!=='none'){
      grid.querySelectorAll('input[data-size]').forEach(function(inp){
        var n=parseInt(inp.value,10); if(!(n>0)) return;
        var p=priceForColorSize(inp.dataset.color, inp.dataset.size);   // each color carries its own per-size price
        if(p==null) p=priceFor(inp.dataset.size);
        if(p!=null) sum+=n*p;
      });
    } else {
      var t=parseInt((document.getElementById('decoQty')||{}).value,10)||0;
      var p=priceFor('__all__'); if(p==null){ var src=ap||pbs, ks=Object.keys(src); if(ks.length) p=src[ks[0]]; }
      if(p!=null) sum=t*p;
    }
    return Math.round(sum*100)/100;
  }
  function priceForColorSize(color,size){
    var g=(colorGroups||[]).find(function(x){ return (x.val||'')===(color||''); });
    var ap=g?g.prices:null, pbs=(product&&product.priceBySize)||{};
    if(ap){ if(ap[size]!=null) return ap[size]; if(ap['__all__']!=null) return ap['__all__']; }
    if(pbs[size]!=null) return pbs[size];
    return pbs['__all__'];
  }
  function totalPieces(){
    var sg=readSizeGrid();
    if(sg && sg.total) return sg.total;
    return parseInt((document.getElementById('decoQty')||{}).value,10)||0;
  }

  function locationOptionsHtml(){
    var pct=(methodCfg().nonStandardPlacementPct)||0;
    // Leading disabled placeholder so nothing is pre-selected — forces the customer to actively
    // pick a location (they were leaving it on the default "Full front" then sending back/chest art).
    return '<option value="" disabled selected>Choose a location…</option>'+(PRICE_RATES.locations||[]).map(function(l){
      return '<option value="'+l.id+'"'+(l.standard?'':' data-ns="1"')+'>'+l.label+((l.standard||!pct)?'':' (+'+pct+'%)')+'</option>';
    }).join('');
  }
  function inkOptionsHtml(){
    var inks=(PRICE_RATES.screenprint.specialtyInks||[]).filter(function(i){return i.customerFacing;});
    return '<option value="">Standard ink</option>'+inks.map(function(i){ return '<option value="'+i.id+'">'+i.label+' (+'+i.pct+'%)</option>'; }).join('');
  }
  function sizeOptionsHtml(){
    return ((methodCfg().sizes)||[]).map(function(s){ return '<option value="'+s.id+'">'+s.label+'</option>'; }).join('');
  }
  // ---- DTF/DTG: print size is DERIVED from the placement, not chosen ----------
  // Clients were picking 4x4 for a Full Front to dodge the price. The size now follows the
  // placement via PRICE_RATES[method].locationSizes (data, not code) and the picker is locked.
  // A location with no standard (specialty_item) keeps a live picker. Screen print and
  // embroidery don't have a size dropdown at all, so they're unaffected.
  function sizedByPlacement(method){ return method==='dtf'||method==='dtg'; }
  function standardSizeFor(method, locId){
    var map=(PRICE_RATES&&PRICE_RATES[method]&&PRICE_RATES[method].locationSizes)||{};
    return map[locId]||'';
  }
  // Point one row's size select at the standard for its placement, and lock it.
  function syncLocSize(row){
    var method=currentMethod();
    if(!sizedByPlacement(method)) return;
    var pl=row.querySelector('.pf-loc-place'), sz=row.querySelector('.pf-loc-size');
    if(!pl||!sz) return;
    var std=standardSizeFor(method, pl.value);
    if(std){
      sz.value=std;
      sz.disabled=true;
      sz.title='Standard '+method.toUpperCase()+' size for '+((pl.options[pl.selectedIndex]||{}).text||'this placement')+'. Need a different size? Contact us.';
      sz.style.background='var(--line-1,#f4f6f9)'; sz.style.color='var(--ink,#111)'; sz.style.cursor='not-allowed';
    } else {
      sz.disabled=false; sz.title=''; sz.style.background=''; sz.style.cursor='';
    }
  }
  function shadeForColor(colorName){
    var c=(colorName||'').toLowerCase(), words=(PRICE_RATES.dtg&&PRICE_RATES.dtg.lightColorWords)||[];
    for(var i=0;i<words.length;i++){ if(c.indexOf(words[i])>=0) return 'white'; }
    return 'dark';
  }
  function dtgDefaultShade(){ return shadeForColor(selectedColor); }
  function setLocHead(method){
    var h=document.getElementById('pfLocHead'); if(!h) return;
    var L='text-align:left;padding-left:9px', C='text-align:center;padding-left:0';
    if(method==='dtf'||method==='dtg'){
      var szLabel=(method==='dtf'?'Transfer size':'Image size')+' <span style="font-weight:400;color:var(--ink-2)">· by placement</span>';
      h.style.gridTemplateColumns='1fr 1fr 64px 22px';
      h.innerHTML='<span style="'+L+'">Placement</span><span style="'+L+'">'+szLabel+'</span><span style="'+C+'">Qty</span><span></span>';
    } else {
      h.style.gridTemplateColumns=''; h.innerHTML='';
    }
  }
  function ordinalNum(n){ var v=n%100,s=['th','st','nd','rd']; return n+(s[(v-20)%10]||s[v]||s[0]); }
  function updateAddLocBtn(){
    var btn=document.getElementById('pfAddLoc'); if(!btn) return;
    var n=document.querySelectorAll('#pfLocations .pf-loc').length;
    var word=currentMethod()==='embroidery'?'embroidery location':'print location';
    btn.textContent='+ Add a '+ordinalNum(n+1)+' '+word+'?';
  }
  function buildLocationRow(){
    var method=currentMethod();
    var wrap=document.createElement('div'); wrap.className='pf-loc';
    var qty='<input type="number" class="pf-loc-qty" min="1" placeholder="All" title="On how many pieces (blank = all)">';
    var del='<button type="button" class="pf-loc-del" title="Remove" style="border:none;background:none;cursor:pointer;font-size:18px;color:#999">×</button>';
    if(method==='dtf'||method==='dtg'){
      wrap.style.cssText='display:grid;grid-template-columns:1fr 1fr 64px 22px;gap:8px;align-items:stretch;margin-bottom:8px';
      wrap.innerHTML=
        '<select class="pf-loc-place">'+locationOptionsHtml()+'</select>'+
        '<select class="pf-loc-size">'+sizeOptionsHtml()+'</select>'+ qty + del;
    } else {
      wrap.style.cssText='border:1px solid var(--line-2,#e3e8ef);border-radius:11px;padding:10px;margin-bottom:10px';
      wrap.innerHTML=
        '<div style="display:grid;grid-template-columns:1fr 1fr 64px 22px;gap:8px;align-items:stretch">'+
          '<select class="pf-loc-place">'+locationOptionsHtml()+'</select>'+
          '<select class="pf-loc-ink">'+inkOptionsHtml()+'</select>'+ qty + del +
        '</div>'+
        '<div style="display:flex;align-items:center;gap:8px;margin-top:9px">'+
          '<input type="text" class="pf-loc-colorlist" placeholder="Ink colors at this location — e.g. red, navy, Pantone PMS 376 C" style="flex:1;min-width:0">'+
          '<span class="pf-loc-colorbadge" style="flex:0 0 auto;font-size:12px;font-weight:700;color:var(--ink-2);white-space:nowrap">1 color</span>'+
        '</div>';
    }
    if(method==='embroidery'){
      wrap.style.cssText='border:1px solid var(--line-2,#e3e8ef);border-radius:11px;padding:10px;margin-bottom:10px';
      var fillOpts=(PRICE_RATES.embroidery.densityBands||[]).map(function(b){return '<option value="'+b.id+'">'+b.label+'</option>';}).join('');
      wrap.innerHTML=
        '<div style="display:grid;grid-template-columns:1fr 64px 22px;gap:8px;align-items:stretch">'+
          '<input type="text" class="pf-loc-place" placeholder="Where? e.g. left chest, right shoulder, hat front">'+ qty + del +
        '</div>'+
        '<div style="display:flex;align-items:center;gap:6px;margin-top:9px;font-size:12px;flex-wrap:wrap">'+
          '<span style="color:var(--ink-2)">Logo size</span>'+
          '<input type="number" class="pf-loc-w" min="0.1" step="0.1" placeholder="W" style="width:52px">'+
          '<span style="color:var(--ink-2)">×</span>'+
          '<input type="number" class="pf-loc-h" min="0.1" step="0.1" placeholder="H" style="width:52px">'+
          '<span style="color:var(--ink-2)">in</span>'+
          '<select class="pf-loc-fill" style="flex:1;min-width:130px">'+fillOpts+'</select>'+
        '</div>'+
        '<div style="display:flex;align-items:center;gap:8px;margin-top:8px">'+
          '<span style="font-size:12px;color:var(--ink-2)">Stitches</span>'+
          '<input type="number" class="pf-loc-stitches" min="1" placeholder="1" style="width:92px" title="Estimated from size + fill — editable if you know the exact count">'+
          '<span class="pf-loc-stbadge" style="font-size:11px;color:var(--ink-2)">enter a size →</span>'+
        '</div>'+
        '<div style="margin-top:8px">'+
          '<input type="text" class="pf-loc-threads" placeholder="Thread colors — e.g. navy, white (no charge)" style="width:100%;box-sizing:border-box;font-size:12px">'+
        '</div>'+
        '<div style="display:flex;align-items:center;gap:16px;margin-top:10px;flex-wrap:wrap">'+
          '<label style="display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:400;white-space:nowrap;cursor:pointer;margin:0"><input type="checkbox" class="pf-loc-puff3d"> 3D / puff</label>'+
          '<label style="display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:400;white-space:nowrap;cursor:pointer;margin:0"><input type="checkbox" class="pf-loc-metallic"> Metallic thread</label>'+
          '<label style="display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:400;white-space:nowrap;cursor:pointer;margin:0"><input type="checkbox" class="pf-loc-ns"> Tricky spot (+$'+(PRICE_RATES.embroidery.nonStandardPlacementPerPiece||0).toFixed(2)+'/pc)</label>'+
        '</div>'+
        '<div style="font-size:11px;color:var(--ink-2);margin-top:6px">“Tricky spot” = cuff, collar, bag, pocket or other hard-to-hoop areas.</div>';
    }
    wrap.querySelector('.pf-loc-del').onclick=function(){ wrap.remove(); updateAddLocBtn(); renderPrice(); };
    if(sizedByPlacement(method)){
      var plSel=wrap.querySelector('.pf-loc-place');
      if(plSel) plSel.addEventListener('change',function(){ syncLocSize(wrap); });
      syncLocSize(wrap);   // lock the freshly-built row to its default placement
    }
    var cl=wrap.querySelector('.pf-loc-colorlist');
    if(cl) cl.addEventListener('input',function(){ updateLocBadge(wrap); });
    if(wrap.querySelector('.pf-loc-fill')){
      var reEst=function(){ estimateLocStitches(wrap); };
      wrap.querySelector('.pf-loc-w').addEventListener('input',reEst);
      wrap.querySelector('.pf-loc-h').addEventListener('input',reEst);
      wrap.querySelector('.pf-loc-fill').addEventListener('change',reEst);
      var stIn=wrap.querySelector('.pf-loc-stitches'); if(stIn) stIn.addEventListener('input',function(){ updateStitchBadge(wrap); });
    }
    wrap.addEventListener('input',renderPrice);
    wrap.addEventListener('change',renderPrice);
    return wrap;
  }
  function stitchK(n){ return '~'+Math.max(1,Math.ceil((parseInt(n,10)||0)/1000))+'k'; }
  function updateStitchBadge(row){
    var badge=row.querySelector('.pf-loc-stbadge'); if(!badge) return;
    var st=parseInt((row.querySelector('.pf-loc-stitches')||{}).value,10)||0;
    badge.textContent= st>0 ? stitchK(st)+' stitches (editable)' : 'enter a size →';
  }
  function estimateLocStitches(row){
    var w=parseFloat((row.querySelector('.pf-loc-w')||{}).value)||0;
    var h=parseFloat((row.querySelector('.pf-loc-h')||{}).value)||0;
    var fill=(row.querySelector('.pf-loc-fill')||{}).value;
    var band=((PRICE_RATES.embroidery||{}).densityBands||[]).find(function(b){return b.id===fill;});
    var stEl=row.querySelector('.pf-loc-stitches');
    if(w>0&&h>0&&band){ var st=Math.max(1000,Math.ceil(w*h*band.density/1000)*1000);
      if(stEl) stEl.value=st;
    }
    updateStitchBadge(row);
  }
  function locColorCount(row){
    var mc=(PRICE_RATES&&PRICE_RATES.screenprint&&PRICE_RATES.screenprint.maxColors)||14;
    var cl=row.querySelector('.pf-loc-colorlist');
    return Math.max(1,Math.min(mc, parseColorCount(cl?cl.value:'')||1));
  }
  function updateLocBadge(row){
    var b=row.querySelector('.pf-loc-colorbadge'); if(!b) return;
    var n=locColorCount(row);
    b.textContent=n+' color'+(n>1?'s':'');
  }
  function ensureLocationRow(){
    var c=document.getElementById('pfLocations');
    if(c && !c.children.length) c.appendChild(buildLocationRow());
    updateAddLocBtn();
  }
  function parseColorCount(s){
    if(!s) return 0;
    return String(s).replace(/\band\b/gi,',').replace(/[&\/;\n]+/g,',')
      .split(',').map(function(x){return x.trim();}).filter(Boolean).length;
  }
  // Underlay rule (screen print only): every non-black print needs a white underlay screen.
  // A single BLACK color prints direct (no underlay); everything else — including black WITH
  // another color — gets ONE underlay screen. So underlay applies unless it's black-only.
  function isBlackOnlyLoc(colorList, colors){
    if((colors||1)!==1) return false;
    return /\b(black|blk)\b/i.test(String(colorList||''));
  }

  /* Partial prints — a location set to fewer pieces than the order holds.
     Returns [{place, qty, total, missing}] so both the Locations step and the Review
     step can state the same consequence in the same words. */
  function partialPrintGaps(locs, pieces){
    var out=[];
    (locs||[]).forEach(function(l){
      if(l && l.qty>0 && pieces>0 && l.qty<pieces){
        out.push({ place:l.label||l.id||'this location', qty:l.qty, total:pieces, missing:pieces-l.qty });
      }
    });
    return out;
  }
  function partialPrintSentence(gaps){
    return gaps.map(function(g){
      return g.qty+' of '+g.total+' pieces get a print at '+g.place+
             ' — the other '+g.missing+' ship with no print there.';
    }).join(' ');
  }

  function readLocations(){
    var out=[]; var total=totalPieces(); var method=currentMethod();
    document.querySelectorAll('#pfLocations .pf-loc').forEach(function(row){
      var sel=row.querySelector('.pf-loc-place'); var opt=sel.options?sel.options[sel.selectedIndex]:null;   // <select> for print, free-text <input> for embroidery
      var qraw=parseInt(row.querySelector('.pf-loc-qty').value,10);
      var qty=(qraw>0)?Math.min(qraw,total||qraw):total;          // blank/0 = all pieces
      var rec={ id:(sel.value||'').trim(), standard:!(opt&&opt.getAttribute('data-ns')==='1'), qty:qty,
                label:((opt&&opt.text)||sel.value||'').trim() };
      if(method==='dtf'||method==='dtg'){ var sz=row.querySelector('.pf-loc-size'); rec.size=sz?sz.value:''; }
      else if(method==='embroidery'){
        var wEl=row.querySelector('.pf-loc-w'), hEl=row.querySelector('.pf-loc-h');
        var ew=parseFloat(wEl?wEl.value:0)||0, eh=parseFloat(hEl?hEl.value:0)||0;
        if(ew&&eh) rec.size=ew+'×'+eh+' in';
        var fEl=row.querySelector('.pf-loc-fill'); if(fEl) rec.fill=((fEl.options&&fEl.options[fEl.selectedIndex])?fEl.options[fEl.selectedIndex].text:fEl.value)||'';
        var stEl=row.querySelector('.pf-loc-stitches'); rec.stitches=Math.max(1,parseInt(stEl?stEl.value:0,10)||0);
        var thEl=row.querySelector('.pf-loc-threads'); rec.threads=(thEl?thEl.value:'').trim();
        var p3=row.querySelector('.pf-loc-puff3d'); rec.puff3d=!!(p3&&p3.checked);
        var mt=row.querySelector('.pf-loc-metallic'); rec.metallic=!!(mt&&mt.checked);
        var ns=row.querySelector('.pf-loc-ns'); rec.standard=!(ns&&ns.checked);
      }
      else { rec.colors=locColorCount(row); var cl=row.querySelector('.pf-loc-colorlist'); rec.colorList=(cl?cl.value:'').trim(); rec.ink=row.querySelector('.pf-loc-ink').value||null; }
      out.push(rec);
    });
    return out;
  }

  function computePrice(input){
    var r2=function(n){return Math.round(n*100)/100;};
    var method=input.method||'screenprint';
    // Shared-design pooling: poolQ drives the price TIER (combined group qty); each product still
    // pays for its own pieces. chargeSetup=false skips screen/vector/digitizing (charged once per group).
    var poolQ=input.poolQty||input.totalPieces;
    var chargeSetup=(input.chargeSetup===false)?false:true;
    // Distinct uploaded files placed across all views. Screen print bills one vectoring
    // fee per file; embroidery bills one digitizing fee per file for the same reason —
    // each separate piece of artwork is its own setup job. Shared so the two can't drift.
    var rawFiles=Math.max(0,parseInt(input.vectorFiles,10)||0);
    var artFiles=Math.max(1,rawFiles);   // vectoring: every screen print needs vector art
    var digiUnits=Math.max(1,rawFiles+Math.max(0,parseInt(input.textOnlyLocations,10)||0));  // digitizing: each design AND each text-only location
    var printBase=0,placement=0,inkUp=0,setupFees=0,setupUnderlays=0,embellish=0,digitizing=0,lines=[];
    if(method==='dtf'||method==='dtg'){
      var cfg=PRICE_RATES[method];
      var tD=function(q){ var i=cfg.qtyTiers.findIndex(function(t){return q>=t.min&&(t.max==null||q<=t.max);}); return i<0?0:i; };
      var dtgColors=null, dtgTotal=0;
      if(method==='dtg'){
        var ov=input.shadeOverride?(input.shade==='dark'?'dark':'white'):null;
        dtgColors=(input.colorSizes||[]).map(function(cs){ var q=0; for(var k in cs.sizes){ q+=parseInt(cs.sizes[k],10)||0; } return {shade:ov||shadeForColor(cs.color), pieces:q}; });
        dtgTotal=dtgColors.reduce(function(s,c){return s+c.pieces;},0);
        if(!dtgTotal){ dtgColors=[{shade:ov||input.shade||'white', pieces:input.totalPieces}]; dtgTotal=input.totalPieces||1; }
      }
      input.locations.forEach(function(loc){
        var lq=loc.qty>0?Math.min(loc.qty,input.totalPieces):input.totalPieces;
        var ti=tD(poolQ), s=cfg.sizes.find(function(x){return x.id===loc.size;});
        var per,base,dgL,dgD,dgPW,dgPK;
        if(method==='dtg'){
          dgPW=r2((s?s.white[ti]:0)+cfg.qtyTiers[ti].markup); dgPK=r2((s?s.dark[ti]:0)+cfg.qtyTiers[ti].markup);
          var lightAtLoc=0; dtgColors.forEach(function(c){ if(c.shade==='white') lightAtLoc+=Math.round(lq*(c.pieces/dtgTotal)); });
          lightAtLoc=Math.min(lq,Math.max(0,lightAtLoc)); var darkAtLoc=lq-lightAtLoc;
          dgL=lightAtLoc; dgD=darkAtLoc;
          base=r2(dgPW*lightAtLoc+dgPK*darkAtLoc); per=lq>0?r2(base/lq):dgPW;
        } else {
          per=r2((s?s.cost[ti]:0)+cfg.qtyTiers[ti].markup); base=r2(per*lq);
        }
        var plc=loc.standard?0:r2(base*(cfg.nonStandardPlacementPct||0)/100);
        printBase+=base; placement+=plc;
        var sLabel=(s&&s.label)||loc.size;
        lines.push({label:sLabel,perPiece:per,base:base,placement:plc,standard:loc.standard,qty:lq,light:dgL,dark:dgD,perW:dgPW,perK:dgPK});
      });
    } else if(method!=='embroidery'){
      var sp=PRICE_RATES.screenprint;
      var tS=function(q){ var i=sp.qtyTiers.findIndex(function(t){return q>=t.min&&(t.max==null||q<=t.max);}); return i<0?0:i; };
      var webS=function(colors,q){ var ti=tS(q); var row=sp.cost[String(Math.min(colors,sp.maxColors))]; return r2((row?row[ti]:0)+sp.qtyTiers[ti].markup); };
      var totalScreens=0;
      input.locations.forEach(function(loc){
        var lq=loc.qty>0?Math.min(loc.qty,input.totalPieces):input.totalPieces;
        var per=webS(loc.colors,poolQ), base=r2(per*lq);
        var plc=loc.standard?0:r2(base*sp.nonStandardPlacementPct/100);
        var inkRec=loc.ink?sp.specialtyInks.find(function(i){return i.id===loc.ink;}):null;
        var ink=inkRec?r2(base*inkRec.pct/100):0;
        var under=isBlackOnlyLoc(loc.colorList,loc.colors)?0:1;   // +1 white-underlay screen per location unless black-only
        printBase+=base; placement+=plc; inkUp+=ink; totalScreens+=loc.colors+under; setupUnderlays+=under;
        lines.push({label:loc.colors+'C',colors:loc.colors,underlay:under,perPiece:per,base:base,placement:plc,ink:ink,inkLabel:inkRec?inkRec.label:'',standard:loc.standard,qty:lq});
      });
      var freeS=(poolQ>=sp.screenFee.freeAtQty)?sp.screenFee.freeCount:0;
      setupFees=chargeSetup?r2(Math.max(0,totalScreens-freeS)*sp.screenFee.perColor):0;
    }
    if(method==='embroidery'){
      var em=PRICE_RATES.embroidery;
      var tEm=function(q){ var i=em.qtyTiers.findIndex(function(t){return q>=t.min&&(t.max==null||q<=t.max);}); return i<0?em.qtyTiers.length-1:i; };
      var costEm=function(st,q){ var ti=tEm(q); var band=em.stitchBands.find(function(b){return st<=b.maxStitch;});
        if(band) return band.cost[ti];
        var last=em.stitchBands[em.stitchBands.length-1]; return r2(last.cost[ti]+Math.ceil((st-last.maxStitch)/1000)*em.additional1k[ti]); };
      input.locations.forEach(function(loc){
        var lq=loc.qty>0?Math.min(loc.qty,input.totalPieces):input.totalPieces;
        var st=Math.max(1,parseInt(loc.stitches,10)||1);
        var per=r2(costEm(st,poolQ)+(em.markup||0)), base=r2(per*lq);
        var plc=loc.standard?0:r2((em.nonStandardPlacementPerPiece||0)*lq);
        var embPer=0; (em.embellishments||[]).forEach(function(eb){ if(loc[eb.id]) embPer+=eb.per1000*(st/1000); });
        var emb=r2(embPer*lq);
        printBase+=base; placement+=plc; embellish+=emb;
        lines.push({label:st.toLocaleString()+' st',stitches:st,perPiece:per,base:base,placement:plc,emb:emb,threads:loc.threads||'',standard:loc.standard,qty:lq});
      });
      digitizing=(input.embRepeat||!chargeSetup)?0:r2((em.digitizingFee||0)*digiUnits);
    }
    var discPct=0,discount=0,grp=input.premium?(input.discountTier||'normal'):discountGroupOf(input.productHandle);
    if(grp && PRICE_RATES.discountTiers[grp]){
      PRICE_RATES.discountTiers[grp].forEach(function(t){ if(input.garmentSubtotal>=t[0]) discPct=t[1]; });
      discount=r2(input.garmentSubtotal*discPct/100);
    }
    var garmentNet=r2(input.garmentSubtotal-discount);
    var ex=PRICE_RATES.extras, e=input.extras||{}, n=input.totalPieces;
    var bulky=(ex.bulkyTypes||[]).some(function(t){ return ((input.garmentType||'')+' '+(input.title||'')).toLowerCase().indexOf(t)>=0; });
    // Vector art fee is now AUTOMATIC on every screen-print order (no longer opt-in) — all
    // screen prints require vector art; customers can request a refund at checkout if they send their own.
    var vFiles=(method==='screenprint')?artFiles:0;   // one vector fee per distinct uploaded file placed
    var artPrep=!chargeSetup ? 0 : (method==='dtf' ? (e.transparentBg?(PRICE_RATES.dtf.transparentBgFee||0):0) : (method==='screenprint' ? (PRICE_RATES.screenprint.vectoringFee||0)*vFiles : 0));
    var poly=e.polyBag?r2((bulky?ex.polyBag.bulky:ex.polyBag.standard)*n):0;
    var tagRem=e.tagRemoval?r2((ex.tagRemoval||0)*n):0;
    var sizeStk=e.sizeStickers?r2((ex.sizeStickers||0)*n):0;
    var hangTag=e.hangTags?r2((ex.hangTags||0)*n):0;
    var split=e.splitShip?r2(ex.splitShipPerLocation*(e.splitShipLocations||1)):0;
    // Ink color change (screen print only): $10 per extra ink (different ink on dark vs light garments). Per product.
    var colorChange=(method==='screenprint'&&e.colorChange)?r2((PRICE_RATES.screenprint.colorChangeFee||0)*Math.max(1,parseInt(e.colorChangeInks,10)||1)):0;
    var shipCfg=PRICE_RATES.shipping||{};
    var heavyItem=input.premium?!!input.shipUpcharge:shipUpchargeOf(input.productHandle);
    var shipBase=heavyItem?(shipCfg.perPieceUpcharge||0):0;
    var shipRegionAdd=(shipBase>0 && input.shipTier)?(((shipCfg.regionSurcharge||{})[input.shipTier])||0):0;
    var shipPerPc=r2(shipBase+shipRegionAdd);
    var shipping=r2(shipPerPc*n);
    var sub=r2(garmentNet+printBase+placement+inkUp+setupFees+embellish+digitizing+artPrep+colorChange+poly+tagRem+sizeStk+hangTag+split+shipping);
    var gallery=input.galleryFeature?Math.min((PRICE_RATES.galleryDiscount||0),sub):0;
    var total=r2(sub-gallery);
    return {method:method,lines:lines,garmentSubtotal:input.garmentSubtotal,
      discPct:discPct,discount:discount,garmentNet:garmentNet,printBase:r2(printBase),placement:r2(placement),
      inkUp:r2(inkUp),setupFees:r2(setupFees),underlays:setupUnderlays,embellish:r2(embellish),digitizing:r2(digitizing),digiFiles:((chargeSetup&&method==='embroidery'&&!input.embRepeat)?digiUnits:0),artPrep:artPrep,vectorFiles:(chargeSetup?vFiles:0),colorChange:colorChange,poly:poly,tagRem:tagRem,sizeStk:sizeStk,hangTag:hangTag,split:split,shipping:shipping,shipPerPc:shipPerPc,shipRegionAdd:r2(shipRegionAdd),shipTier:input.shipTier||null,gallery:gallery,bulky:bulky,total:total};
  }

  function money(n){ return '$'+(Math.round(n*100)/100).toFixed(2); }
  function pfRow(label,val,opts){ opts=opts||{};
    return '<div style="display:flex;justify-content:space-between;gap:12px;'+(opts.muted?'color:var(--ink-2,#777);font-size:13px;':'')+(opts.strong?'font-weight:700;border-top:1px solid var(--line-2,#e3e8ef);margin-top:8px;padding-top:8px;font-size:16px;':'')+(opts.indent?'padding-left:14px;':'')+'"><span>'+label+'</span><span>'+val+'</span></div>'; }

  function renderTierNudge(pieces, locs, method, shade){
    var el=document.getElementById('pfTierNudge'); if(!el) return;
    if(method==='embroidery'){ el.innerHTML=''; return; }   // stitch-based; per-piece nudge n/a
    var cfg=PRICE_RATES[method]; if(!cfg||!cfg.qtyTiers){ el.innerHTML=''; return; }
    var ti=cfg.qtyTiers.findIndex(function(t){return pieces>=t.min&&(t.max==null||pieces<=t.max);});
    var next=cfg.qtyTiers[ti+1];
    var full=locs.filter(function(l){return !(l.qty>0&&l.qty<pieces);});   // only locations printed on ALL pieces
    if(ti<0||!next||!full.length){ el.innerHTML=''; return; }
    var perAt=function(idx){ return full.reduce(function(s,l){
      var per, mult=1;
      if(method==='dtf'||method==='dtg'){ var sz=cfg.sizes.find(function(x){return x.id===l.size;}); var arr=method==='dtg'?(sz?(shade==='dark'?sz.dark:sz.white):null):(sz?sz.cost:null); per=(arr?arr[idx]:0)+cfg.qtyTiers[idx].markup; }
      else { var row=cfg.cost[String(Math.min(l.colors,cfg.maxColors))]||[]; per=(row[idx]||0)+cfg.qtyTiers[idx].markup;
        var ink=l.ink?cfg.specialtyInks.find(function(x){return x.id===l.ink;}):null; if(ink) mult+=ink.pct/100; }
      if(l.standard===false) mult+=cfg.nonStandardPlacementPct/100;
      return s+per*mult; },0); };
    var save=Math.round((perAt(ti)-perAt(ti+1))*100)/100;
    if(!(save>0)){ el.innerHTML=''; return; }
    var cur=cfg.qtyTiers[ti], need=next.min-pieces;
    var fill=Math.max(4,Math.min(100,Math.round((pieces-cur.min)/(next.min-cur.min)*100)));
    var close=need<=Math.max(5,Math.ceil((next.min-cur.min)*0.15));
    var msg=(close?'🎯 So close — ':'💡 ')+'add <b>'+need+'</b> more '+(need===1?'piece':'pieces')+' to reach the <b>'+next.min+'+</b> price break and save <b>$'+save.toFixed(2)+'/pc</b> on printing. <a href="#" class="qm-goto-sizes" style="color:var(--accent,#ff4a23);font-weight:700;text-decoration:none;white-space:nowrap">Edit quantities →</a>';
    el.innerHTML='<div style="font-size:13px;margin-bottom:5px;color:'+(close?'var(--accent,#ff4a23)':'var(--ink-2,#555)')+'">'+msg+'</div>'+
      '<div style="height:8px;background:#ececec;border-radius:6px;overflow:hidden"><div style="height:100%;width:'+fill+'%;background:var(--accent,#ff4a23);transition:width .25s"></div></div>';
  }

  var orderItems=[];   // committed products; the in-progress product is the form's current state
  // MOQ is per DESIGN, not per order and not per product. The minimum exists because each design
  // costs a screen burn / setup, so 12 pieces of ONE design is the floor — 12 garments carrying 12
  // different designs is 12 jobs of 1, not one job of 12. Pieces pool across garments that share a
  // design (the "Same design?" choice keeps the design group), so 6 tees + 6 hoodies of one design
  // is fine. Enforced via designsBelowMoq() at checkout and mirrored in the price panel.
  function orderPieces(){ return orderItems.reduce(function(s,it){ return s+((it.summary&&it.summary.pieces)||0); },0); }

  // ---- Shared-design pooling ------------------------------------------------
  // Products that share one design (same logo) form a "design group": their quantities pool for the
  // decoration price tier and screen/vector/digitizing setup is charged ONCE for the group.
  var currentDesignGroup='g1', _groupSeq=1;
  function newDesignGroup(){ _groupSeq++; currentDesignGroup='g'+_groupSeq; }
  function moqMin(){ return (PRICE_RATES&&PRICE_RATES.moq)||12; }
  // Pieces per design group across the whole job (committed products + the in-progress one).
  function designGroupPieces(){
    var g={};
    orderItems.forEach(function(it){
      var k=it.designGroup||'g?';
      g[k]=(g[k]||0)+((it.priceInput&&it.priceInput.totalPieces)||(it.summary&&it.summary.pieces)||0);
    });
    if(product && currentMethod() && totalPieces()>0) g[currentDesignGroup]=(g[currentDesignGroup]||0)+totalPieces();
    return g;
  }
  // Design groups under the minimum, fewest pieces first. Empty array = the order clears MOQ.
  function designsBelowMoq(){
    var moq=moqMin(), gp=designGroupPieces(), out=[];
    for(var k in gp){ if(gp[k]>0 && gp[k]<moq) out.push({ group:k, pieces:gp[k] }); }
    return out.sort(function(a,b){ return a.pieces-b.pieces; });
  }
  // One shared sentence so the price panel and the checkout gate never drift apart.
  function moqMessage(short){
    var moq=moqMin(), n=short.length;
    if(!n) return '';
    if(Object.keys(designGroupPieces()).length===1)
      return 'Your order needs at least '+moq+' pieces of this design (you have '+short[0].pieces+') — add '+(moq-short[0].pieces)+' more.';
    if(n===1)
      return 'Each design needs at least '+moq+' pieces. One of your designs has only '+short[0].pieces+' — add '+(moq-short[0].pieces)+' more of it, or put it on the same garments as another design.';
    return 'Each design needs at least '+moq+' pieces. '+n+' of your designs are under that (smallest has '+short[0].pieces+') — add more of each, or combine them.';
  }
  function _mergeInput(inp,extra){ var o={}; for(var k in inp) o[k]=inp[k]; for(var k2 in extra) o[k2]=extra[k2]; return o; }
  // Pooling and setup are keyed by design group AND decoration method. A group can hold
  // items decorated different ways, and those are separate production runs: screens,
  // vectoring and digitizing are method-specific, and a DTF run's pieces must not buy a
  // cheaper screen-print tier.
  //
  // BT18295 is what keying on group alone did. A DTF item and a screen-print item shared
  // g1, so the DTF item (which has neither) consumed the one setup slot and the screen
  // print lost $20 of screens and $35 of vectoring outright. Its 12 pieces were also
  // pooled with the 12 DTF pieces onto the 24-piece tier, billing $4.91/pc where only
  // 12 were screen printed and the rate is $7.49.
  function _poolKey(x){ return (x.group||'g?')+'|'+((x.input&&x.input.method)||'?'); }
  function priceOrder(){
    var items=orderItems.map(function(it){ return { input:it.priceInput, group:it.designGroup||'g?', summary:it.summary, current:false }; });
    if(product && currentMethod() && totalPieces()>0){ items.push({ input:currentPriceInput(), group:currentDesignGroup, summary:currentItemSummary(), current:true }); }
    var groupQty={}; items.forEach(function(x){ var k=_poolKey(x); groupQty[k]=(groupQty[k]||0)+((x.input&&x.input.totalPieces)||0); });
    var seen={};
    var priced=items.map(function(x){ var k=_poolKey(x); var first=!seen[k]; seen[k]=true; var b=null;
      try{ b=computePrice(_mergeInput(x.input,{poolQty:groupQty[k],chargeSetup:first})); }catch(e){}
      return { group:x.group, current:x.current, summary:x.summary, first:first, b:b }; });
    var grand=priced.reduce(function(s,p){ return s+((p.b&&p.b.total)||0); },0);
    var gallery=chk('pfGallery')?Math.min((PRICE_RATES&&PRICE_RATES.galleryDiscount)||0,grand):0;
    return { items:priced, groupQty:groupQty, grand:Math.round(grand*100)/100, gallery:gallery, total:Math.round((grand-gallery)*100)/100 };
  }
  // The in-progress product's input, pooled within its design group (drives the live preview).
  function currentPooledInput(){
    var g=currentDesignGroup, m=currentMethod(), sum=totalPieces(), prior=false;
    orderItems.forEach(function(it){
      if((it.designGroup||'')===g && ((it.priceInput&&it.priceInput.method)||'')===m){
        sum+=((it.priceInput&&it.priceInput.totalPieces)||0); prior=true;
      }
    });
    return _mergeInput(currentPriceInput(),{poolQty:sum,chargeSetup:!prior});
  }
  // Distinct uploaded image files actually PLACED across all garment views. Drives the
  // Views for the COLOURWAY currently selected — the ones in the view switcher. designs{}
  // is keyed by garment image URL and never pruned, so every colour a shopper clicks
  // through leaves its art behind in saved state (and in localStorage across sessions).
  // Billing every one of those charged for abandoned colours and for art the customer had
  // already deleted from the view they were working in. Only the selected colourway is
  // actually being printed, so only it should count.
  function currentViewSrcs(){
    var out={};
    try{
      var els=document.querySelectorAll('#viewThumbs [data-src]');
      for(var i=0;i<els.length;i++){ if(els[i].dataset.src) out[els[i].dataset.src]=1; }
    }catch(e){}
    return out;
  }
  function billableViews(){
    var cur=currentViewSrcs(), keys=Object.keys(designs||{});
    var scoped=keys.filter(function(k){ return cur[k]; });
    return scoped.length ? scoped : keys;   // during load the switcher may be empty
  }

  function isTextObj(o){ var t=((o&&o.type)||'').toLowerCase(); return t==='textbox'||t==='text'||t==='i-text'; }

  // per-file art fee: same file on 2 locations = 1 file; 2 different files = 2.
  //
  // Counting distinct `src` OVER-charged. designs{} is keyed by GARMENT IMAGE URL, so every
  // colourway the shopper previews is saved as its own view holding its own copy of the
  // artwork -- and fabric re-serialises the image per view, producing a different base64
  // string for the SAME file. BT18212 billed two $35 vector fees for one logo because the
  // customer looked at the tank in a second colour she did not even order. Prefer the
  // upload id, which survives re-serialisation.
  function placedFileCount(){
    try{ saveView(); }catch(e){}
    var uids={}, srcs={}, anyArt=false;
    billableViews().forEach(function(v){
      var objs=(designs[v]&&designs[v].objects)||[];
      objs.forEach(function(o){
        if(!o||isTextObj(o)) return;
        anyArt=true;
        if(o._bt_uid) uids[o._bt_uid]=1;
        else if(o.src) srcs[o.src]=1;
      });
    });
    if(!anyArt) return 0;
    // Count BOTH populations. An earlier version returned early on the tagged count, which
    // silently dropped every untagged object — BT18246 had one tagged and one untagged
    // image and was billed for one digitizing fee instead of two.
    var tagged=Object.keys(uids).length;
    var loose=Object.keys(srcs).length;           // distinct srcs among UNTAGGED art only
    var total=tagged+loose;
    // The uploads tray is authoritative when present: it caps double-counting from a file
    // re-serialised across colourway views (BT18212). It is dropped when a design is too
    // big to save, so only cap when it actually holds something.
    var tray=(uploads||[]).length;
    return tray ? Math.max(1,Math.min(total,tray)) : Math.max(1,total);
  }

  // Text sharing a location with artwork is digitised as part of that design and costs
  // nothing extra; text in a location of its own is a separate digitising job. Views
  // (Front / Back / Sleeve) stand in for location, deduped by LABEL because the same view
  // is stored once per colourway. Two locations on one view read as one, which under-
  // charges rather than over-charges -- the safe direction.
  function textOnlyViewCount(){
    try{ saveView(); }catch(e){}
    var roles={};
    billableViews().forEach(function(v){
      var objs=(designs[v]&&designs[v].objects)||[];
      if(!objs.length) return;
      var role=((viewLabelForSrc(v)||v)+'').toLowerCase();
      if(!roles[role]) roles[role]={art:false,text:false};
      objs.forEach(function(o){ if(!o) return; if(isTextObj(o)) roles[role].text=true; else roles[role].art=true; });
    });
    var n=0;
    Object.keys(roles).forEach(function(r){ if(roles[r].text&&!roles[r].art) n++; });
    return n;
  }
  function currentPriceInput(){
    var dest=shipDest(); var _sh=document.getElementById('pfDtgShade');
    return { method:currentMethod(), shade:(_sh&&_sh.value)||'white', shadeOverride:!!(_sh&&(_sh.value==='white'||_sh.value==='dark')), colorSizes:readColorSizes(),
      designGroup:currentDesignGroup,
      premium:PREMIUM_MODE, shipUpcharge:!!(product&&product.shipUpcharge), discountTier:(product&&product.discountTier)||'normal',
      galleryFeature:false, embRepeat:chk('pfEmbRepeat'), productHandle:checkoutHandle(),
      garmentSubtotal:garmentSubtotal(), shipTier:dest.tier,
      garmentType:(product&&product.type)||'', title:(product&&product.title)||'',
      totalPieces:totalPieces(), locations:readLocations(), vectorFiles:placedFileCount(), textOnlyLocations:textOnlyViewCount(),
      extras:{ vectoring:(currentMethod()==='screenprint'), transparentBg:chk('pfTransparentBg'), polyBag:chk('pfPoly'),
        tagRemoval:chk('pfTagRemoval'), sizeStickers:chk('pfSizeStickers'), hangTags:chk('pfHangTags'),
        splitShip:chk('pfSplit'), splitShipLocations:parseInt((document.getElementById('pfSplitN')||{}).value,10)||1,
        colorChange:chk('pfColorChange'), colorChangeInks:parseInt((document.getElementById('pfColorChangeN')||{}).value,10)||1 } };
  }
  function validateCurrentProduct(){
    // Validates THIS product's completeness only. The per-ORDER MOQ is enforced at checkout
    // (doCheckout) — checking it here blocked committing a <MOQ product to add a 2nd one.
    if(!product||!product.handle) return 'Pick a product first.';
    if(totalPieces()<1) return 'Add quantities in the size breakdown.';
    var locs=readLocations(); if(!locs.length) return 'Add a '+(currentMethod()==='embroidery'?'embroidery':'print')+' location.';
    if(currentMethod()!=='embroidery'){
      var noPlace=false; document.querySelectorAll('#pfLocations .pf-loc').forEach(function(r){ var pl=r.querySelector('.pf-loc-place'); if(!pl||!(pl.value||'').trim()) noPlace=true; });
      if(noPlace) return 'Choose a print location for each spot (use the “Choose a location…” dropdown).';
    }
    if(currentMethod()==='screenprint'){
      var miss=false; document.querySelectorAll('#pfLocations .pf-loc').forEach(function(r){ var cl=r.querySelector('.pf-loc-colorlist'); if(!cl||!cl.value.trim()) miss=true; });
      if(miss) return 'List the ink colors at each print location.';
    }
    if(currentMethod()==='embroidery'){
      var bad=''; document.querySelectorAll('#pfLocations .pf-loc').forEach(function(r){ if(bad)return; if(!((r.querySelector('.pf-loc-place')||{}).value||'').trim()) bad='Please say where each logo goes.'; var st=parseInt((r.querySelector('.pf-loc-stitches')||{}).value,10)||0; if(st<1) bad='Enter a logo size (stitch count) at each embroidery location.'; });
      if(bad) return bad;
    }
    var pn=((document.getElementById('pfPlacementNotes')||{}).value||'').trim();
    var gaps=partialPrintGaps(locs, totalPieces());
    if(gaps.length){
      // Same order as the step-4 gate: confirm the split, then describe it. The note alone
      // was never consent — BT18549 carried a note reading "All shirts get the logo" beside
      // a quantity of 30, and nothing cross-checked the two.
      if(!chk('pfPartialConfirm')) return partialPrintSentence(gaps)+
        ' Tick the box to confirm. If every piece should be printed, clear the quantity box next to the location (blank = all).';
      if(!pn) return 'Tell us which sizes/colors get the print, so we decorate the right pieces.';
    }
    return '';
  }
  function buildItemPayload(designId){
    var pieces=totalPieces();
    return {
      method:currentMethod(), shade:(document.getElementById('pfDtgShade')||{}).value||'white', shadeOverride:(function(){var s=document.getElementById('pfDtgShade');return !!(s&&(s.value==='white'||s.value==='dark'));})(), embRepeat:chk('pfEmbRepeat'),
      premium:PREMIUM_MODE, designGroup:currentDesignGroup,
      handle:checkoutHandle(), color:selectedColor||'', productTitle:(product&&product.title)||'',
      pantones:Array.prototype.map.call(document.querySelectorAll('#pfLocations .pf-loc'),function(row){ var sel=row.querySelector('.pf-loc-place'); var place=sel?(sel.options?((sel.options[sel.selectedIndex]||{}).text||''):(sel.value||'').trim()):''; var cl=row.querySelector('.pf-loc-colorlist'), th=row.querySelector('.pf-loc-threads'); var cols=(cl?cl.value.trim():'')||(th?th.value.trim():''); return cols?(place+': '+cols):''; }).filter(Boolean).join('  |  '),
      colorSizes:readColorSizes(),
      sizes:(function(){ var m=readSizeMap(); return Object.keys(m).length?m:{'__all__':pieces}; })(),
      vectorFiles:placedFileCount(), textOnlyLocations:textOnlyViewCount(),
      locations:readLocations().map(function(l){return {id:l.id,standard:l.standard,colors:l.colors,colorList:l.colorList,ink:l.ink,size:l.size,qty:l.qty,stitches:l.stitches,threads:l.threads,puff3d:l.puff3d,metallic:l.metallic};}),
      extras:{ vectoring:(currentMethod()==='screenprint'), transparentBg:chk('pfTransparentBg'), polyBag:chk('pfPoly'), tagRemoval:chk('pfTagRemoval'), sizeStickers:chk('pfSizeStickers'), hangTags:chk('pfHangTags'), splitShip:chk('pfSplit'), splitShipLocations:parseInt((document.getElementById('pfSplitN')||{}).value,10)||1, colorChange:chk('pfColorChange'), colorChangeInks:parseInt((document.getElementById('pfColorChangeN')||{}).value,10)||1 },
      partialConfirmed: chk('pfPartialConfirm'),
      designId:designId||'', mockupUrl: designId?shareLinkFor(designId):'',
      placementNotes:((document.getElementById('pfPlacementNotes')||{}).value||'').trim()
    };
  }
  function currentItemSummary(){
    if(!product||!currentMethod()) return null;
    var cs=readColorSizes(); var colors=cs.map(function(x){return x.color;}).filter(Boolean).join(', ');
    var b=null; try{ b=computePrice(currentPriceInput()); }catch(e){}
    var mLabel={screenprint:'Screen print',dtf:'DTF',dtg:'DTG',embroidery:'Embroidery'}[currentMethod()]||currentMethod();
    return { title:(product&&product.title)||'Product', method:mLabel, colors:colors, pieces:totalPieces(), total:b?b.total:0 };
  }
  async function buildCurrentItem(){
    var designId=''; try{ designId=await saveDesignSilent(); }catch(e){}
    // store the full priceInput + group so the order can re-price with pooling later
    return { payload:buildItemPayload(designId), summary:currentItemSummary(), priceInput:currentPriceInput(), designGroup:currentDesignGroup };
  }
  function resetProductForm(){
    var dt=document.getElementById('decoType'); if(dt) dt.value='';
    var loc=document.getElementById('pfLocations'); if(loc) loc.innerHTML='';
    ['pfTransparentBg','pfPoly','pfTagRemoval','pfSizeStickers','pfHangTags','pfSplit','pfEmbRepeat'].forEach(function(id){ var e=document.getElementById(id); if(e) e.checked=false; });
    var pn=document.getElementById('pfPlacementNotes'); if(pn) pn.value='';
    var sg=document.getElementById('sizeGrid'); if(sg){ sg.innerHTML=''; delete sg.dataset.sig; }
    var af=document.getElementById('pfArtFile'); if(af) af.value='';
    _artPrompted=false; _artDone=false;   // re-prompt for artwork on the next product
    lastMethod=null;
  }
  async function addAnotherProduct(){
    var err=validateCurrentProduct();
    if(err){ qmErr(err); return; }
    var item=await buildCurrentItem();
    if(item && item.summary) orderItems.push(item);
    updateOrderBanner();
    closeModal();             // close the order modal first so the "Same design?" choice is clearly on top
    showSameDesignChoice();   // ask whether the next garment uses the same design (pools its pricing)
  }
  function showSameDesignChoice(){
    var m=document.getElementById('sameDesignModal');
    if(!m){ proceedNextProduct(false); return; }
    var same=document.getElementById('sdSame'), diff=document.getElementById('sdNew');
    if(same) same.onclick=function(){ proceedNextProduct(true); };
    if(diff) diff.onclick=function(){ proceedNextProduct(false); };
    m.classList.add('show');
  }
  function proceedNextProduct(sameDesign){
    var m=document.getElementById('sameDesignModal'); if(m) m.classList.remove('show');
    if(!sameDesign) newDesignGroup();   // "same design" keeps the current group → quantities pool + one setup
    resetProductForm();
    closeModal();
    if(typeof goTab==='function') goTab('product');      // back to product search to pick the next blank
    // Mid cart-import: pull the next garment in automatically rather than making
    // them search for something they already picked on the storefront.
    if(cartImportOn && cartImport.length){ loadNextCartProduct(); return; }
    try{ var sb=document.getElementById('searchInput'); if(sb) sb.focus(); }catch(e){}
  }
  function cartRow(p, actionHtml){
    var s=p.summary||{}, b=p.b||{};
    var deco=Math.round(((b.printBase||0)+(b.placement||0)+(b.inkUp||0)+(b.embellish||0)+(b.colorChange||0))*100)/100;
    var setup=Math.round(((b.setupFees||0)+(b.artPrep||0)+(b.digitizing||0))*100)/100;
    var bd='Garment '+money(b.garmentNet||0)+' · Decoration '+money(deco)+(setup>0?(' · Setup '+money(setup)):' · Setup shared');
    return '<div style="display:flex;gap:10px;align-items:flex-start;padding:10px 0;border-bottom:1px solid var(--line)">'+
      '<div style="flex:1;min-width:0">'+
        '<div style="font-weight:700;font-size:14px">'+(s.title||'Product')+(p.current?' <span style="font-weight:600;color:var(--accent);font-size:11px">· this product</span>':'')+'</div>'+
        '<div style="font-size:12px;color:var(--ink-2);margin-top:2px">'+(s.method||'')+(s.colors?' · '+s.colors:'')+' · '+(s.pieces||0)+' pcs</div>'+
        '<div style="font-size:11.5px;color:var(--ink-2);margin-top:3px">'+bd+'</div>'+
        '<div style="margin-top:4px">'+(actionHtml||'')+'</div>'+
      '</div>'+
      '<div style="font-weight:700;white-space:nowrap">'+money((b.total!=null?b.total:s.total)||0)+'</div>'+
    '</div>';
  }
  function renderCart(){
    var el=document.getElementById('qmCart'); if(!el) return;
    var po=priceOrder();   // pooled pricing across the whole order (shared-design groups)
    var rows='', ci=0;
    po.items.forEach(function(p){
      var action=p.current ? '<button type="button" class="qm-cartbtn" data-edit="1">Edit</button>'
                           : '<button type="button" class="qm-cartbtn" data-rm="'+(ci++)+'">Remove</button>';
      rows+=cartRow(p,action);
    });
    // Repeat any partial print at Review. This is the last screen before checkout and the
    // one place the whole order is shown together — BT18549 went out because a 30-of-86
    // split was only ever visible as a lone number back on the Locations step.
    var warn='';
    var allGaps=[];
    po.items.forEach(function(p){
      var inp=p.input||{};
      partialPrintGaps(inp.locations, inp.totalPieces).forEach(function(g){
        allGaps.push({ title:(inp.title||'This product'), g:g });
      });
    });
    if(allGaps.length){
      warn='<div style="background:#fff6f3;border:1.5px solid #f3c9bb;border-radius:10px;padding:11px 13px;margin-bottom:12px;font-size:13px;line-height:1.5">'+
        '<b>Heads up — not every piece is printed</b>'+
        allGaps.map(function(x){
          return '<div style="margin-top:5px">'+_artEsc(x.title)+': <b>'+x.g.qty+' of '+x.g.total+'</b> pieces get a print at '+
                 _artEsc(x.g.place)+' — the other <b>'+x.g.missing+'</b> ship with no print there.</div>';
        }).join('')+
        '</div>';
    }

    var foot='';
    if(po.gallery>0) foot+='<div style="display:flex;justify-content:space-between;font-size:13px;color:var(--good,#1e7e34);margin-top:6px"><span>Gallery feature credit</span><span>−'+money(po.gallery)+'</span></div>';
    foot+='<div style="display:flex;justify-content:space-between;font-weight:800;font-size:16px;margin-top:8px;padding-top:8px;border-top:1px solid var(--line-2,#e3e8ef)"><span>Order total</span><span>'+money(po.total)+'</span></div>';
    el.innerHTML=warn+rows+foot;
    el.querySelectorAll('[data-rm]').forEach(function(b){ b.onclick=function(){ removeCartItem(parseInt(b.dataset.rm,10)); }; });
    var ed=el.querySelector('[data-edit]'); if(ed) ed.onclick=function(){ qmGoStep(2); };
    // Vector-refund checkbox only applies to the (auto) screen-print art fee — show it only
    // when the order actually contains a screen-print item.
    var hasSP=(currentMethod()==='screenprint')||orderItems.some(function(i){return i.priceInput&&i.priceInput.method==='screenprint';});
    var vrw=document.getElementById('pfVectorRefundWrap'); if(vrw) vrw.style.display=hasSP?'flex':'none';
    // Per-file vector refund: cap the "print-ready files I'll send" count at the order's total vector files.
    var totVF=po.items.reduce(function(s,p){return s+((p.b&&p.b.vectorFiles)||0);},0);
    var vfN=document.getElementById('pfVectorFileN'); if(vfN) vfN.textContent=totVF;
    var vfIn=document.getElementById('pfVectorRefund');
    if(vfIn){ vfIn.max=totVF; if((parseInt(vfIn.value,10)||0)>totVF) vfIn.value=totVF; }
  }
  function removeCartItem(idx){ if(idx>=0 && idx<orderItems.length){ orderItems.splice(idx,1); renderCart(); updateOrderBanner(); } }
  function updateOrderBanner(){
    var n=(orderItems||[]).length;   // null-safe: this is also called at init, before orderItems is assigned
    var bn=document.getElementById('orderBanner');
    if(bn){ bn.style.display=n>0?'flex':'none'; var c=document.getElementById('obCount'); if(c) c.textContent=n+(n===1?' product added':' products added'); }
    var sq=document.getElementById('submitQuote');
    if(sq){
      var labelNode=null;
      sq.childNodes.forEach(function(node){ if(node.nodeType===3 && node.textContent.trim()) labelNode=node; });
      if(labelNode){ if(!sq.dataset.baseLabel) sq.dataset.baseLabel=labelNode.textContent.trim(); labelNode.textContent=' '+(n>0?('Add to order ('+n+')'):sq.dataset.baseLabel)+' '; }
    }
  }

  function updateRunPrice(){
    var el=document.getElementById('qmRunPrice'); if(!el) return;
    // Only from the Locations step (4) onward — on Sizes the color count isn't set yet, so a total would mislead.
    if(!isPricingActive() || !PRICE_RATES || (typeof QM_STEP!=='undefined' && (QM_STEP<4 || QM_STEP>5))){ el.style.display='none'; return; }
    var lab=el.querySelector('.qrp-label'), amt=el.querySelector('.qrp-amt');
    var pieces=totalPieces(), moq=moqMin(), method=currentMethod(), locs=readLocations();
    if(pieces>=1 && !designsBelowMoq().length && method && locs && locs.length){
      try{ var b=computePrice(currentPooledInput());
        if(b && b.total>0){ el.className='qm-runprice'; el.style.display='';
          lab.textContent='Running total · '+pieces+' pcs'; amt.textContent=money(b.total)+'  ·  '+money(b.total/pieces)+'/pc'; return; }
      }catch(e){}
    }
    el.className='qm-runprice hint'; el.style.display='';
    lab.textContent='Your price';
    amt.textContent=(pieces<1?'Add quantities':(designsBelowMoq().length?(moq+' pcs min per design'):(!method?'Choose a method':'Add a print location')))+' →';
  }

  function renderPrice(){
    updateRunPrice();
    var el=document.getElementById('pfBreakdown'); if(!el||!PRICE_RATES) return;
    var nudge=document.getElementById('pfTierNudge'); if(nudge) nudge.innerHTML='';
    var pnw=document.getElementById('pfPlacementNotesWrap'); if(pnw) pnw.style.display='none';
    var pieces=totalPieces();
    if(pieces<1){ el.innerHTML='<div style="color:var(--ink-2,#777)">Add quantities in the size grid to see your price.</div>'; return; }
    var _short=designsBelowMoq();
    if(_short.length){ el.innerHTML='<div style="color:var(--ink-2,#777)">'+moqMessage(_short)+'</div>'; return; }
    var locs=readLocations();
    if(!locs.length){ el.innerHTML='<div style="color:var(--ink-2,#777)">Add a '+(currentMethod()==='embroidery'?'embroidery':'print')+' location to see your price.</div>'; return; }
    var method=currentMethod();
    var shade=(document.getElementById('pfDtgShade')||{}).value||'white';
    if(shade==='auto') shade=dtgDefaultShade();   // nudge needs a concrete shade; mirror the dominant garment
    renderTierNudge(pieces, locs, method, shade);
    var _gaps=partialPrintGaps(locs, pieces);
    if(pnw) pnw.style.display=_gaps.length?'':'none';
    // Spell the consequence out inside the confirmation itself, so ticking it is a real
    // acknowledgement rather than a formality.
    var _pct=document.getElementById('pfPartialConfirmText');
    if(_pct) _pct.textContent='Yes — '+partialPrintSentence(_gaps);
    // Reveal the "which pieces?" box only once the split is confirmed — it's the follow-up
    // question, not the first one.
    var _pn=document.getElementById('pfPlacementNotes');
    var _pnLabel=_pn&&_pn.previousElementSibling;
    var _confirmed=chk('pfPartialConfirm');
    if(_pn) _pn.style.display=_confirmed?'':'none';
    if(_pnLabel&&_pnLabel.tagName==='LABEL') _pnLabel.style.display=_confirmed?'':'none';
    if(!_gaps.length){ var _pc=document.getElementById('pfPartialConfirm'); if(_pc) _pc.checked=false; }
    var dest=updateZipNote();
    var b=computePrice(currentPooledInput());   // pooled within this product's design group
    var nsPct=(methodCfg().nonStandardPlacementPct)||0, pfx=method==='dtf'?'Transfer':(method==='dtg'?'DTG':(method==='embroidery'?'Embroidery':'Print'));
    var h='';
    if(b.garmentSubtotal>0){ h+=pfRow('Garment · '+pieces+' pcs',money(b.garmentSubtotal));
      if(b.discPct>0) h+=pfRow('Material discount (−'+b.discPct+'%)','−'+money(b.discount),{muted:true,indent:true}); }
    b.lines.forEach(function(l,i){ var onN=(l.qty&&l.qty<pieces)?(' · on '+l.qty+' pcs'):'';
      var ulLab=(method==='screenprint'&&l.underlay>0)?' + underlay':'';
      h+=pfRow(pfx+' '+(i+1)+' · '+l.label+ulLab+' @ '+money(l.perPiece)+'/pc'+onN,money(l.base));
      if(method==='dtg'&&l.light>0&&l.dark>0) h+=pfRow(l.light+' light @ '+money(l.perW)+' + '+l.dark+' dark @ '+money(l.perK),'',{muted:true,indent:true});
      if(l.placement>0) h+=pfRow(method==='embroidery'?'Non-standard placement':('Non-standard placement (+'+nsPct+'%)'),'+'+money(l.placement),{muted:true,indent:true});
      if(l.emb>0) h+=pfRow('3D / metallic thread','+'+money(l.emb),{muted:true,indent:true});
      if(l.ink>0) h+=pfRow(l.inkLabel+' ink','+'+money(l.ink),{muted:true,indent:true}); });
    if(b.digitizing>0) h+=pfRow('Digitizing'+((b.digiFiles||1)>1?' ('+b.digiFiles+' designs)':' (one-time setup)'),money(b.digitizing));
    if(b.setupFees>0){ var sf=PRICE_RATES.screenprint.screenFee; var snote;
      var scCols=b.lines.reduce(function(s,l){return s+(l.colors||0);},0), scUnd=b.underlays||0;
      var comp=scCols+' color'+(scCols!==1?'s':'')+(scUnd>0?(' + '+(scUnd===1?'an underlay':(scUnd+' underlays'))):'');
      if(pieces>=sf.freeAtQty){ snote=' (first '+sf.freeCount+' screens free)'; }
      else { var totScr=scCols+scUnd;
        var save=Math.min(sf.freeCount,totScr)*sf.perColor, need=sf.freeAtQty-pieces;
        snote=' <span style="color:var(--accent,#ff4a23)">(add '+need+' '+(need===1?'piece':'pieces')+' to hit '+sf.freeAtQty+' — save '+money(save)+' on screens)</span>'; }
      h+=pfRow('Screen setup ('+comp+')'+snote,money(b.setupFees));
      if(scUnd>0) h+='<div style="color:var(--ink-2,#777);font-size:12px;padding-left:14px;margin-top:2px;line-height:1.4">We always print a white underlay under your ink so colors stay bright on colored &amp; dark garments — it counts as one extra color and one extra screen (so a 1-color design counts as 2 colors and 2 screens, a 2-color as 3 and 3, and so on).</div>'; }
    if(b.artPrep>0) h+=pfRow(method==='dtf'?'Transparent background':('Art vectoring'+((b.vectorFiles||1)>1?' ('+b.vectorFiles+' files)':'')),money(b.artPrep));
    if(b.colorChange>0) h+=pfRow('Ink color change',money(b.colorChange));
    if(b.poly>0) h+=pfRow('Fold &amp; poly-bag'+(b.bulky?' (bulky)':''),money(b.poly));
    if(b.tagRem>0) h+=pfRow('Tag removal',money(b.tagRem));
    if(b.sizeStk>0) h+=pfRow('Size stickers',money(b.sizeStk));
    if(b.hangTag>0) h+=pfRow('Hang tags',money(b.hangTag));
    if(b.split>0) h+=pfRow('Split shipping',money(b.split));
    if(b.shipping>0){
      var tierName={1:'West',2:'Midwest',3:'East'}[b.shipTier]||'';
      var rgn=b.shipTier
        ? (' · '+(dest.state||'')+(tierName?(' '+tierName):'')+(b.shipRegionAdd>0?(' +'+money(b.shipRegionAdd)+'/pc'):''))
        : ' · add ZIP for region rate';
      h+=pfRow('Overweight shipping · '+money(b.shipPerPc)+'/pc'+rgn,money(b.shipping));
    }
    if(b.gallery>0) h+=pfRow('🎁 Gallery feature credit','−'+money(b.gallery),{muted:true});
    h+=pfRow('Total',money(b.total),{strong:true});
    h+=pfRow('Per piece',money(b.total/pieces),{muted:true});
    if(!(b.shipping>0)) h+='<div style="text-align:center;font-size:12px;color:var(--ink-2,#777);margin-top:8px">🚚 Shipping included</div>';
    el.innerHTML=h;
  }

  function readSizeMap(){
    var grid=document.getElementById('sizeGrid'); var map={};
    if(grid && grid.style.display!=='none'){
      grid.querySelectorAll('input[data-size]').forEach(function(inp){ var n=parseInt(inp.value,10); if(n>0) map[inp.dataset.size]=(map[inp.dataset.size]||0)+n; });  // sum across colors
    }
    return map;
  }
  function checkoutHandle(){
    var u=(selectedSourceUrl||'').split('?')[0].replace(/\/+$/,'');
    var m=u.match(/\/products\/([^\/]+)$/);
    return (m&&m[1])||(product&&product.handle)||'';
  }
  async function saveDesignSilent(){
    try{
      if(!DESIGN_ENABLED||!DESIGN_API_BASE||!product||typeof buildState!=='function') return '';
      var state=buildState(); if(!state) return '';
      var str=JSON.stringify(state); if(str.length>5500000){ state.uploads=[]; str=JSON.stringify(state); }
      var res=await fetch(DESIGN_API_BASE,{method:'POST',headers:{'Content-Type':'application/json'},body:str});
      if(!res.ok) return ''; var data=await res.json(); return (data&&data.id)||'';
    }catch(e){ return ''; }
  }
  var tsWidgetId=null, tsLoading=false, tsScriptFailed=false, tsErrored=false, tsStartedAt=0;
  function ensureTurnstile(){
    if(!TURNSTILE_SITE_KEY) return;
    var el=document.getElementById('pfTurnstile'); if(!el) return;
    var opts={sitekey:TURNSTILE_SITE_KEY, 'error-callback':function(){ tsErrored=true; }};
    if(window.turnstile){ if(tsWidgetId===null){ try{ tsWidgetId=window.turnstile.render(el,opts); }catch(e){ tsErrored=true; } } return; }
    if(tsLoading) return; tsLoading=true; tsStartedAt=Date.now();
    var s=document.createElement('script');
    s.src='https://challenges.cloudflare.com/turnstile/v0/api.js'; s.async=true; s.defer=true;
    s.onload=function(){ try{ if(tsWidgetId===null) tsWidgetId=window.turnstile.render(el,opts); }catch(e){ tsErrored=true; } };
    s.onerror=function(){ tsScriptFailed=true; };   // ad-blocker / firewall / CSP refused the challenge script
    document.head.appendChild(s);
  }
  // True when the widget can't be completed by the user (blocked script, render/challenge error, or never loaded) — vs merely not-yet-completed.
  function turnstileBlocked(){
    return tsScriptFailed || tsErrored || (tsLoading && !window.turnstile && tsStartedAt>0 && (Date.now()-tsStartedAt)>9000);
  }
  function getTurnstileToken(){
    try{ return (TURNSTILE_SITE_KEY && window.turnstile && tsWidgetId!==null) ? (window.turnstile.getResponse(tsWidgetId)||'') : ''; }catch(e){ return ''; }
  }
  function resetTurnstile(){ try{ if(window.turnstile && tsWidgetId!==null) window.turnstile.reset(tsWidgetId); }catch(e){} }

  var _artPrompted=false, _artDone=false;
  function _artEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function getSourceArtList(){
    var out=[]; var inp=document.getElementById('pfArtFile');
    if(inp&&inp.files&&inp.files.length){ for(var i=0;i<inp.files.length;i++){ out.push({blob:inp.files[i], name:inp.files[i].name}); } return out; }
    if(typeof uploads!=='undefined' && uploads){ uploads.forEach(function(u){ var b=dataURLtoBlob(u.data); if(b){ var nm=u.name||'artwork'; if(!/\.[a-z0-9]{2,4}$/i.test(nm)) nm+=(u.kind==='svg'?'.svg':'.png'); out.push({blob:b, name:nm}); } }); }
    return out;
  }
  function artSourceName(){ var l=getSourceArtList(); return l.length?l[0].name:''; }
  function artFileChosen(){ return getSourceArtList().length>0; }
  function refreshArtModalUploads(){
    var box=document.getElementById('artExistingUploads'), head=document.getElementById('artUploadHead'), help=document.getElementById('artUploadHelp');
    if(!box) return;
    var inp=document.getElementById('pfArtFile'); var hasPick=!!(inp&&inp.files&&inp.files.length);
    var ups=(typeof uploads!=='undefined'&&uploads)?uploads:[];
    if(ups.length && !hasPick){
      box.style.display='';
      box.innerHTML='<div style="font-size:12.5px;color:#2e7d32;font-weight:700;margin-bottom:6px">✓ We’ll use the artwork you uploaded:</div>'+
        '<div style="display:flex;gap:8px;flex-wrap:wrap">'+ups.map(function(u){
          var t=(u.kind!=='svg')?('<img src="'+u.data+'" style="width:46px;height:46px;object-fit:contain;border:1px solid var(--line-2,#e3e8ef);border-radius:8px;background:#fff" alt="">'):('<div style="width:46px;height:46px;display:flex;align-items:center;justify-content:center;border:1px solid var(--line-2,#e3e8ef);border-radius:8px;background:#fff;font-size:10px;font-weight:700">SVG</div>');
          return '<div style="text-align:center"><div>'+t+'</div><div style="font-size:10px;color:var(--ink-2,#777);max-width:64px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+_artEsc(u.name||'art')+'</div></div>';
        }).join('')+'</div>';
      if(head) head.innerHTML='Your artwork <span style="color:#2e7d32">✓ ready</span>';
      if(help){ var _isSP=(document.getElementById('decoType')||{}).value&&/screen/i.test((document.getElementById('decoType')||{}).value); help.innerHTML=(_isSP?'We’ll vector the file(s) you uploaded above':'We’ll print from the file(s) you uploaded above')+'. Have a higher-res or vector version (AI/EPS/PDF/SVG)? Add it below to override — otherwise just continue.'; }
    } else {
      box.style.display='none'; box.innerHTML='';
      if(head) head.innerHTML='Upload your artwork file <span style="color:var(--accent,#ff4a23)">(required)</span>';
      if(help) help.innerHTML='Attach your design so we print from the real art — not the mockup. <b>Vector (AI, EPS, PDF, SVG) is best.</b> Only have a PNG/JPG? Upload it and check “vector my artwork” above. Max 25&nbsp;MB.';
    }
  }
  function openArtModal(){ var m=document.getElementById('artModal'); if(m){ refreshArtModalUploads(); m.classList.add('show'); var e=document.getElementById('artModalErr'); if(e) e.textContent=''; } }
  function closeArtModal(){ var m=document.getElementById('artModal'); if(m) m.classList.remove('show'); }
  function maybePromptArtwork(){
    if(_artPrompted||_artDone) return;
    var locs=readLocations();
    if(!(locs&&locs.some(function(l){return l.id||l.size||l.stitches||l.colorList;}))) return;   // a placed location (embroidery/some methods have no select-id)
    _artPrompted=true;
    setTimeout(openArtModal,250);                               // let the step paint first
  }
  function updateArtReminder(){
    var r=document.getElementById('pfArtReminder'); if(!r) return;
    if(artFileChosen()){ r.style.display=''; r.style.color='#2e7d32'; r.innerHTML='✓ Artwork attached: <b>'+_artEsc(artSourceName())+'</b>'; }
    else { r.style.display=''; r.style.color='var(--accent,#ff4a23)'; r.innerHTML='⚠ Your artwork file is required. <a href="#" id="pfArtReopen" style="color:inherit;font-weight:700;text-decoration:underline">Add it now</a>.'; var a=document.getElementById('pfArtReopen'); if(a) a.onclick=function(ev){ ev.preventDefault(); openArtModal(); }; }
  }

  async function uploadArtIfAny(status){
    var list=getSourceArtList();
    if(!list.length) return null;
    var f=list[0];   // the picked file, or the design-tool upload
    if(f.blob.size>25*1024*1024) throw new Error('art file over 25 MB');
    var fd=new FormData(); fd.append('file',f.blob,f.name);
    if(status) status.textContent='Uploading your artwork…';
    var uploadUrl=CHECKOUT_API.replace(/\/checkout$/,'/upload');
    var r=await fetch(uploadUrl,{method:'POST',body:fd});
    var j=await r.json().catch(function(){return {};});
    if(!r.ok||!j.ok) throw new Error((j&&j.error)||('upload HTTP '+r.status));
    var st=document.getElementById('pfArtStatus'); if(st){ st.style.color='#2e7d32'; st.textContent='✓ Artwork attached: '+(j.filename||f.name); }
    return { url:j.url||'', name:j.filename||f.name };
  }

  // Friendly label (e.g. "Front"/"Back") for a view src, read off the view-thumb buttons.
  function viewLabelForSrc(src){
    try{ var els=document.querySelectorAll('#viewThumbs [data-src]'); for(var i=0;i<els.length;i++){ if(els[i].dataset.src===src){ return (els[i].textContent||els[i].title||'').trim(); } } }catch(e){}
    return '';
  }
  async function renderCurrentMockups(){
    var out=[];
    mockupDiag=[];
    try{ if(document.fonts&&document.fonts.ready) await document.fonts.ready; }catch(e){}
    var views=Object.keys(designs).filter(function(s){return designs[s]&&designs[s].objects&&designs[s].objects.length;});
    for(var i=0;i<views.length;i++){
      try{ var m=await renderViewMockup(views[i], designs[views[i]]);
        if(m) out.push({name:'mockup-view-'+(i+1)+'.png', dataUrl:m, label:viewLabelForSrc(views[i])});
      }catch(e){ mockupNote('render', (e&&e.message||'').slice(0,60)); }
    }
    return out;
  }
  async function uploadDataUrl(dataUrl, filename){
    try{
      var blob=dataURLtoBlob(dataUrl); if(!blob) return '';
      var fd=new FormData(); fd.append('file',blob,filename);
      var r=await fetch(CHECKOUT_API.replace(/\/checkout$/,'/upload'),{method:'POST',body:fd});
      var j=await r.json().catch(function(){return {};});
      if(r.ok&&j&&j.ok&&j.url) return j.url;
      mockupNote('upload', r.status+(j&&j.error?(' '+String(j.error).slice(0,40)):''));
      return '';
    }catch(e){ mockupNote('upload', (e&&e.message||'net').slice(0,40)); return ''; }
  }
  function emailOrderSummary(ref){
    var s='New customizer ORDER'+(ref?(' — Shopify draft '+ref):'')+'\n';
    s+='Customer: '+(qval('qName')||'(n/a)')+' · '+(qval('qEmail')||'')+(qval('qPhone')?(' · '+qval('qPhone')):'')+'\n';
    if(qval('decoDate')) s+='Preferred in-hand date: '+qval('decoDate')+(chk('pfFlexDate')?' (flexible — ASAP is fine)':(qval('pfDropDead')?' · MUST HAVE BY '+qval('pfDropDead'):' (firm date)'))+'\n';
    s+='\nAttached: the customer’s uploaded artwork file + rendered mockup(s).\n';
    s+='Full order details (products, sizes, decoration, pricing) are in the Shopify order/draft.\n';
    return s;
  }
  async function emailOrderArt(ref, mockups){
    if(!FORM_ENDPOINT) return;
    var fd=new FormData();
    if(FORM_KEY) fd.append('access_key',FORM_KEY);
    fd.append('botcheck','');
    fd.append('subject','Customizer ORDER — '+((product&&product.title)||'order')+(ref?(' (draft '+ref+')'):''));
    fd.append('from_name',qval('qName')||'Customizer');
    fd.append('name',qval('qName')||'');
    fd.append('email',qval('qEmail')||'');
    if(qval('qPhone')) fd.append('phone',qval('qPhone'));
    fd.append('message', emailOrderSummary(ref));
    var srcs=getSourceArtList(); srcs.forEach(function(s,i){ fd.append(srcs.length>1?('source_artwork_'+(i+1)):'source_artwork', s.blob, s.name); });
    (mockups||[]).forEach(function(m,i){ var b=dataURLtoBlob(m.dataUrl); if(b) fd.append('mockup_view_'+(i+1), b, m.name); });
    await fetch(FORM_ENDPOINT,{method:'POST',body:fd});
  }

  async function doCheckout(){
    if(!PRICE_RATES) return;
    cxTrack('checkout_clicked', cxContext());
    var status=document.getElementById('pfCheckoutStatus'); var btn=document.getElementById('pfCheckout');
    var hasCurrent=!!(product && product.handle && currentMethod() && totalPieces()>0);
    if(hasCurrent){
      var err=validateCurrentProduct();
      if(err){
        status.textContent=err;
        if(/fewer than all pieces|confirm the partial print/i.test(err)) goFixPartialPrint(err);
        return;
      }
    }
    if(!orderItems.length && !hasCurrent){ status.textContent='Add a product to your order first.'; return; }
    // per-DESIGN minimum, enforced across the whole order (committed + current). 12 garments
    // carrying 12 different designs is 12 jobs of 1 and must not pass as one 12-pc order.
    var _shortCk=designsBelowMoq();
    if(_shortCk.length){ cxTrack('checkout_blocked_moq', cxContext()); status.textContent=moqMessage(_shortCk); return; }
    // Partial prints, checked against the DATA about to be submitted rather than the form
    // on screen. validateCurrentProduct only sees the current product, and only when
    // hasCurrent is true — so anything already banked in the order could slip past it.
    var _partialErr=null;
    orderItems.forEach(function(i){
      if(_partialErr) return;
      var pay=i.payload||{};
      var pcs=Object.keys(pay.sizes||{}).reduce(function(a,k){ return a+(Number(pay.sizes[k])||0); },0);
      (pay.locations||[]).forEach(function(l){
        if(_partialErr||!l||!(l.qty>0)||!(pcs>0)||l.qty>=pcs||pay.partialConfirmed) return;
        _partialErr=(pay.productTitle||'A product')+': '+l.qty+' of '+pcs+' pieces get a print at '+
          (l.id||'one location')+' — the other '+(pcs-l.qty)+' would ship with no print there. '+
          'Open it with Edit and confirm the partial print.';
      });
    });
    if(!_partialErr && hasCurrent){
      var _curGaps=partialPrintGaps(readLocations(), totalPieces());
      if(_curGaps.length && !chk('pfPartialConfirm')) _partialErr='Please confirm the partial print: '+partialPrintSentence(_curGaps);
    }
    if(_partialErr){
      cxTrack('checkout_blocked_partial', cxContext());
      status.textContent=_partialErr;
      // Only jump when it's the CURRENT product — a banked item isn't in the form, and
      // its message already tells them to reopen it with Edit.
      if(hasCurrent && partialPrintGaps(readLocations(), totalPieces()).length) goFixPartialPrint(_partialErr);
      return;
    }
    var dest=shipDest();
    if(dest.noShip){ status.textContent='Sorry, we don’t ship to '+(STATE_NAMES[dest.state]||dest.state)+'. Please use a serviceable U.S. address.'; var z0=document.getElementById('qZip'); if(z0) z0.focus(); return; }
    if(hasCurrent && shipUpchargeOf(checkoutHandle()) && !dest.tier){ status.textContent='Enter your shipping ZIP code so we can calculate shipping.'; var z1=document.getElementById('qZip'); if(z1) z1.focus(); return; }
    if(TURNSTILE_SITE_KEY && !getTurnstileToken()){
      ensureTurnstile();
      cxTrack('checkout_blocked_turnstile', Object.assign({ meta:{ blocked:turnstileBlocked() } }, cxContext()));
      status.textContent = turnstileBlocked()
        ? 'We couldn’t load the “I’m human” check — this is usually an ad/tracking blocker, a VPN, or strict privacy settings. Turn those off for this site or try a different browser. Or tap “Send quote request” and we’ll email you a secure payment link.'
        : 'Please complete the “I’m human” check above, then tap checkout again.';
      return;
    }
    if(!artFileChosen()){ cxTrack('checkout_blocked_artwork', cxContext()); _artPrompted=true; openArtModal(); updateArtReminder(); status.textContent='Please attach your artwork file to continue.'; return; }
    var orig=btn.textContent; btn.disabled=true; btn.textContent='Building your checkout…'; status.textContent='';
    try{
      var art=null;
      try{ art=await uploadArtIfAny(status); }catch(ue){ console.warn('[customizer] art upload failed:',ue&&ue.message); }
      var mockups=[]; try{ mockups=await renderCurrentMockups(); }catch(e){}
      // Upload EVERY rendered view (front, back, …) so the whole design attaches to the order — not just the first.
      var mockupImages=[];
      for(var mi=0;mi<mockups.length;mi++){
        try{ var mu=await uploadDataUrl(mockups[mi].dataUrl,'mockup-'+(mi+1)+'.png'); if(mu) mockupImages.push({url:mu, label:mockups[mi].label||('View '+(mi+1))}); }catch(e){}
      }
      var mockupImageUrl=mockupImages.length?mockupImages[0].url:'';   // kept for back-compat
      var items=orderItems.map(function(i){return i.payload;});
      if(hasCurrent){ var curItem=await buildCurrentItem(); items.push(curItem.payload); }
      var payload={
        items:items,
        galleryFeature:chk('pfGallery'),
        vectorRefundCount:(parseInt((document.getElementById('pfVectorRefund')||{}).value,10)||0),
        vectorRefundRequested:((parseInt((document.getElementById('pfVectorRefund')||{}).value,10)||0)>0),
        contactName:qval('qName'), contactEmail:qval('qEmail'), contactPhone:qval('qPhone'), inHandDate:qval('decoDate'),
        dateFlexible:chk('pfFlexDate'), dropDeadDate:(chk('pfFlexDate')?'':qval('pfDropDead')),
        zip:dest.raw, shipState:dest.state||'', shipTier:dest.tier||null,
        sourceArtUrl:(art&&art.url)||'', sourceArtName:(art&&art.name)||'',
        mockupImageUrl:mockupImageUrl||'',
        mockupImages:mockupImages,
        mockupDiag:(mockupImages.length<mockups.length||!mockups.length)?mockupDiag.slice(0,12):[],
        mockupExpected:mockups.length,
        turnstileToken:getTurnstileToken()
      };
      var res=await fetch(CHECKOUT_API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
      var data=await res.json();
      if(!res.ok||!data.checkoutUrl) throw new Error((data&&data.error)||('HTTP '+res.status));
      status.textContent='Sending your artwork to our team…';
      try{ await emailOrderArt(data.draftId, mockups); }catch(e){ console.warn('[customizer] order art email failed',e&&e.message); }
      cxTrack('checkout_success', Object.assign({ meta:{ draftId:data.draftId||'' } }, cxContext()));
      // Mockups failing is invisible to the customer, so it has to be reported or it
      // only surfaces when someone asks where the artwork went (BT18212).
      if(mockupImages.length<mockups.length||!mockups.length){
        cxTrack('mockup_failed', Object.assign({ meta:{ draftId:data.draftId||'', expected:mockups.length,
          got:mockupImages.length, reasons:mockupDiag.slice(0,12) } }, cxContext()));
      }
      status.textContent='Redirecting to secure checkout…';
      window.location.href=data.checkoutUrl;
    }catch(e){
      status.textContent='Sorry — '+(e.message||'checkout failed')+'. Please try again, or use “Send quote request”.';
      btn.disabled=false; btn.textContent=orig; resetTurnstile();
    }
  }
  var lastMethod=null;
  function toggleField(id, show){ var e=document.getElementById(id); if(e&&e.closest('.field')) e.closest('.field').style.display=show?'':'none'; }
  function syncPriceFlow(){
    var pf=document.getElementById('priceFlow'); if(!pf) return;
    var method=currentMethod(), active=!!method;
    var rawMethod=(document.getElementById('decoType')||{}).value||'';
    var isEmb=/embroider/i.test(rawMethod);
    var state=active?'priced':(isEmb?'embroidery':'none');   // none | embroidery | priced
    pf.style.display=active?'':'none';
    var card=document.querySelector('#quoteModal .bt-modal-card'); if(card) card.classList.toggle('priced',active);
    var prompt=document.getElementById('pfMethodPrompt'); if(prompt) prompt.style.display=state==='none'?'':'none';
    ['decoColors','decoQty','decoNotes'].forEach(function(id){ var e=document.getElementById(id); if(e&&e.closest('.field')) e.closest('.field').style.display=state==='embroidery'?'':'none'; });
    var dsz=document.getElementById('decoSizes'); if(dsz&&dsz.closest('.field')) dsz.closest('.field').style.display=state==='none'?'none':'';  // size breakdown: priced + embroidery
    var noSize=!(product&&product.sizes&&product.sizes.length);
    if(state==='priced'&&noSize){
      var dq=document.getElementById('decoQty'); if(dq&&dq.closest('.field')) dq.closest('.field').style.display='';
      if(dsz&&dsz.closest('.field')) dsz.closest('.field').style.display='none';
    }
    var send=document.getElementById('qmSend'); if(send){ send.style.display=state==='embroidery'?'':'none'; send.textContent='Request embroidery quote'; }
    var sub=document.querySelector('#quoteModal .qm-sub'), title=document.getElementById('qmTitle');
    if(active){                                   // priced: screen print / DTF / DTG
      if(title) title.textContent='Build your order';
      if(sub) sub.textContent='Set your sizes and locations to see your price instantly, then check out. Your design attaches to the order automatically.';
    } else if(isEmb){                             // embroidery = quote
      if(title) title.textContent='Request an embroidery quote';
      if(sub) sub.textContent='Embroidery is priced from your stitch count, so we’ll review your image and reply with a quote. Your artwork attaches automatically.';
    } else {                                      // no method chosen yet
      if(title) title.textContent='Build your order';
      if(sub) sub.textContent='Choose a decoration method to see your price instantly. Your design attaches to the order automatically.';
    }
    var ci=document.getElementById('pfColorsIntro'); if(ci) ci.style.display=method==='screenprint'?'':'none';
    var ef=document.getElementById('pfEmbFields'); if(ef) ef.style.display=method==='embroidery'?'':'none';
    var isEmbM=method==='embroidery';
    var ll=document.getElementById('pfLocLabel'); if(ll) ll.textContent=isEmbM?'First embroidery location':'First print location';
    updateAddLocBtn();
    var ln=document.getElementById('pfLocNote'); if(ln) ln.innerHTML=isEmbM
      ?'“Qty” = how many pieces get this embroidery. Leave it <b>All</b> unless a location is only on some of them (e.g. a sleeve logo on 50 of 100).'
      :'“Qty” = how many pieces get this print. Leave it <b>All</b> unless a location only prints on some of them (e.g. a back logo on 50 of 100).';
    var vw=document.getElementById('pfVectorWrap'); if(vw) vw.style.display=method==='screenprint'?'':'none';
    var ccw=document.getElementById('pfColorChangeWrap'); if(ccw) ccw.style.display=method==='screenprint'?'':'none';   // ink color change is screen-print only
    var tw=document.getElementById('pfTransparentWrap'); if(tw) tw.style.display=method==='dtf'?'flex':'none';
    var ovn=document.getElementById('pfDtfOversized'); if(ovn) ovn.style.display=method==='dtf'?'':'none';
    var szn=document.getElementById('pfSizeNote');
    if(szn){
      szn.style.display=sizedByPlacement(method)?'':'none';
      var w=document.getElementById('pfSizeNoteWord'); if(w) w.textContent=(method==='dtf'?'Transfer':'Print');
    }
    var shw=document.getElementById('pfDtgShadeWrap'); if(shw) shw.style.display=method==='dtg'?'':'none';
    var exf=document.getElementById('pfExtrasField'); if(exf) exf.style.display=method==='dtg'?'none':'';   // DTG has no extras
    if(active){ loadPricing(); ensureTurnstile();
      if(PRICE_RATES){
        if(method!==lastMethod){ _artPrompted=false; _artDone=false; var c=document.getElementById('pfLocations'); if(c) c.innerHTML=''; setLocHead(method); ensureLocationRow();
          
          lastMethod=method; }
        renderPrice();
      }
    }
  }
  function initPricingUI(){
    if(!PRICING_ENABLED) return;
    var add=document.getElementById('pfAddLoc');
    if(add) add.onclick=function(){ document.getElementById('pfLocations').appendChild(buildLocationRow()); updateAddLocBtn(); renderPrice(); };
    var split=document.getElementById('pfSplit');
    if(split) split.addEventListener('change',function(){ document.getElementById('pfSplitWrap').style.display=split.checked?'':'none'; renderPrice(); });
    var cc=document.getElementById('pfColorChange');
    if(cc) cc.addEventListener('change',function(){ var w=document.getElementById('pfColorChangeNWrap'); if(w) w.style.display=cc.checked?'':'none'; renderPrice(); });
    ['pfTransparentBg','pfPoly','pfTagRemoval','pfSizeStickers','pfHangTags','pfSplitN','pfGallery','pfEmbRepeat','pfColorChangeN'].forEach(function(id){ var e=document.getElementById(id); if(e){ e.addEventListener('input',renderPrice); e.addEventListener('change',renderPrice); } });
    var dsh=document.getElementById('pfDtgShade'); if(dsh) dsh.addEventListener('change',function(){ dsh.dataset.touched='1'; renderPrice(); });
    var artFile=document.getElementById('pfArtFile');
    if(artFile) artFile.addEventListener('change',function(){ var st=document.getElementById('pfArtStatus'); if(st){ if(artFile.files&&artFile.files.length){ st.style.color='#2e7d32'; st.textContent='✓ Ready: '+artFile.files[0].name; } else { st.textContent=''; } } refreshArtModalUploads(); updateArtReminder(); });
    function dismissArt(){ closeArtModal(); updateArtReminder(); }
    var artSave=document.getElementById('artSave');
    if(artSave) artSave.onclick=function(){
      if(!artFileChosen()){ var e=document.getElementById('artModalErr'); if(e) e.textContent='Please attach your artwork file to continue.'; if(artFile) artFile.focus(); return; }
      _artDone=true; closeArtModal(); updateArtReminder();   // just close the popup and stay on Extras (don't auto-advance to Review)
    };
    var artClose=document.getElementById('artClose'); if(artClose) artClose.onclick=dismissArt;
    var artModalEl=document.getElementById('artModal'); if(artModalEl) artModalEl.addEventListener('click',function(e){ if(e.target===artModalEl) dismissArt(); });
    var co=document.getElementById('pfCheckout'); if(co) co.onclick=doCheckout;
    var m=document.getElementById('decoType'); if(m) m.addEventListener('change',function(){ syncPriceFlow(); if(currentMethod() && QM_STEP===2) qmGoStep(3); });   // picking a method jumps straight to Sizes
    var z=document.getElementById('qZip'); if(z) z.addEventListener('input',function(){ if(isPricingActive()&&PRICE_RATES) renderPrice(); else updateZipNote(); });
  }
  initPricingUI();

  cxTrack('page_view', { meta:{ premium: !!PREMIUM_MODE } });   // denominator for the whole funnel

  syncControls();
  requestAnimationFrame(function(){ requestAnimationFrame(layoutStage); }); // after first layout
  window.addEventListener('load', layoutStage);                             // after fonts/images
  window.addEventListener('resize',function(){ clearTimeout(window.__btFitTimer); window.__btFitTimer=setTimeout(layoutStage,150); });
})();